(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __reExport = (target, module2, desc) => {
    if (module2 && typeof module2 === "object" || typeof module2 === "function") {
      for (let key of __getOwnPropNames(module2))
        if (!__hasOwnProp.call(target, key) && key !== "default")
          __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
    }
    return target;
  };
  var __toModule = (module2) => {
    return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
  };
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // node_modules/barba.js/dist/barba.js
  var require_barba = __commonJS({
    "node_modules/barba.js/dist/barba.js"(exports2, module2) {
      (function webpackUniversalModuleDefinition(root, factory) {
        if (typeof exports2 === "object" && typeof module2 === "object")
          module2.exports = factory();
        else if (typeof define === "function" && define.amd)
          define("Barba", [], factory);
        else if (typeof exports2 === "object")
          exports2["Barba"] = factory();
        else
          root["Barba"] = factory();
      })(exports2, function() {
        return function(modules) {
          var installedModules = {};
          function __webpack_require__(moduleId) {
            if (installedModules[moduleId])
              return installedModules[moduleId].exports;
            var module3 = installedModules[moduleId] = {
              exports: {},
              id: moduleId,
              loaded: false
            };
            modules[moduleId].call(module3.exports, module3, module3.exports, __webpack_require__);
            module3.loaded = true;
            return module3.exports;
          }
          __webpack_require__.m = modules;
          __webpack_require__.c = installedModules;
          __webpack_require__.p = "http://localhost:8080/dist";
          return __webpack_require__(0);
        }([
          function(module3, exports3, __webpack_require__) {
            if (typeof Promise !== "function") {
              window.Promise = __webpack_require__(1);
            }
            var Barba7 = {
              version: "1.0.0",
              BaseTransition: __webpack_require__(4),
              BaseView: __webpack_require__(6),
              BaseCache: __webpack_require__(8),
              Dispatcher: __webpack_require__(7),
              HistoryManager: __webpack_require__(9),
              Pjax: __webpack_require__(10),
              Prefetch: __webpack_require__(13),
              Utils: __webpack_require__(5)
            };
            module3.exports = Barba7;
          },
          function(module3, exports3, __webpack_require__) {
            (function(setImmediate) {
              (function(root) {
                var setTimeoutFunc = setTimeout;
                function noop() {
                }
                var asap = typeof setImmediate === "function" && setImmediate || function(fn) {
                  setTimeoutFunc(fn, 0);
                };
                var onUnhandledRejection = function onUnhandledRejection2(err) {
                  if (typeof console !== "undefined" && console) {
                    console.warn("Possible Unhandled Promise Rejection:", err);
                  }
                };
                function bind(fn, thisArg) {
                  return function() {
                    fn.apply(thisArg, arguments);
                  };
                }
                function Promise2(fn) {
                  if (typeof this !== "object")
                    throw new TypeError("Promises must be constructed via new");
                  if (typeof fn !== "function")
                    throw new TypeError("not a function");
                  this._state = 0;
                  this._handled = false;
                  this._value = void 0;
                  this._deferreds = [];
                  doResolve(fn, this);
                }
                function handle(self2, deferred) {
                  while (self2._state === 3) {
                    self2 = self2._value;
                  }
                  if (self2._state === 0) {
                    self2._deferreds.push(deferred);
                    return;
                  }
                  self2._handled = true;
                  asap(function() {
                    var cb = self2._state === 1 ? deferred.onFulfilled : deferred.onRejected;
                    if (cb === null) {
                      (self2._state === 1 ? resolve : reject)(deferred.promise, self2._value);
                      return;
                    }
                    var ret;
                    try {
                      ret = cb(self2._value);
                    } catch (e) {
                      reject(deferred.promise, e);
                      return;
                    }
                    resolve(deferred.promise, ret);
                  });
                }
                function resolve(self2, newValue) {
                  try {
                    if (newValue === self2)
                      throw new TypeError("A promise cannot be resolved with itself.");
                    if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
                      var then = newValue.then;
                      if (newValue instanceof Promise2) {
                        self2._state = 3;
                        self2._value = newValue;
                        finale(self2);
                        return;
                      } else if (typeof then === "function") {
                        doResolve(bind(then, newValue), self2);
                        return;
                      }
                    }
                    self2._state = 1;
                    self2._value = newValue;
                    finale(self2);
                  } catch (e) {
                    reject(self2, e);
                  }
                }
                function reject(self2, newValue) {
                  self2._state = 2;
                  self2._value = newValue;
                  finale(self2);
                }
                function finale(self2) {
                  if (self2._state === 2 && self2._deferreds.length === 0) {
                    asap(function() {
                      if (!self2._handled) {
                        onUnhandledRejection(self2._value);
                      }
                    });
                  }
                  for (var i = 0, len = self2._deferreds.length; i < len; i++) {
                    handle(self2, self2._deferreds[i]);
                  }
                  self2._deferreds = null;
                }
                function Handler(onFulfilled, onRejected, promise) {
                  this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
                  this.onRejected = typeof onRejected === "function" ? onRejected : null;
                  this.promise = promise;
                }
                function doResolve(fn, self2) {
                  var done = false;
                  try {
                    fn(function(value) {
                      if (done)
                        return;
                      done = true;
                      resolve(self2, value);
                    }, function(reason) {
                      if (done)
                        return;
                      done = true;
                      reject(self2, reason);
                    });
                  } catch (ex) {
                    if (done)
                      return;
                    done = true;
                    reject(self2, ex);
                  }
                }
                Promise2.prototype["catch"] = function(onRejected) {
                  return this.then(null, onRejected);
                };
                Promise2.prototype.then = function(onFulfilled, onRejected) {
                  var prom = new this.constructor(noop);
                  handle(this, new Handler(onFulfilled, onRejected, prom));
                  return prom;
                };
                Promise2.all = function(arr) {
                  var args = Array.prototype.slice.call(arr);
                  return new Promise2(function(resolve2, reject2) {
                    if (args.length === 0)
                      return resolve2([]);
                    var remaining = args.length;
                    function res(i2, val) {
                      try {
                        if (val && (typeof val === "object" || typeof val === "function")) {
                          var then = val.then;
                          if (typeof then === "function") {
                            then.call(val, function(val2) {
                              res(i2, val2);
                            }, reject2);
                            return;
                          }
                        }
                        args[i2] = val;
                        if (--remaining === 0) {
                          resolve2(args);
                        }
                      } catch (ex) {
                        reject2(ex);
                      }
                    }
                    for (var i = 0; i < args.length; i++) {
                      res(i, args[i]);
                    }
                  });
                };
                Promise2.resolve = function(value) {
                  if (value && typeof value === "object" && value.constructor === Promise2) {
                    return value;
                  }
                  return new Promise2(function(resolve2) {
                    resolve2(value);
                  });
                };
                Promise2.reject = function(value) {
                  return new Promise2(function(resolve2, reject2) {
                    reject2(value);
                  });
                };
                Promise2.race = function(values) {
                  return new Promise2(function(resolve2, reject2) {
                    for (var i = 0, len = values.length; i < len; i++) {
                      values[i].then(resolve2, reject2);
                    }
                  });
                };
                Promise2._setImmediateFn = function _setImmediateFn(fn) {
                  asap = fn;
                };
                Promise2._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
                  onUnhandledRejection = fn;
                };
                if (typeof module3 !== "undefined" && module3.exports) {
                  module3.exports = Promise2;
                } else if (!root.Promise) {
                  root.Promise = Promise2;
                }
              })(this);
            }).call(exports3, __webpack_require__(2).setImmediate);
          },
          function(module3, exports3, __webpack_require__) {
            (function(setImmediate, clearImmediate) {
              var nextTick = __webpack_require__(3).nextTick;
              var apply = Function.prototype.apply;
              var slice = Array.prototype.slice;
              var immediateIds = {};
              var nextImmediateId = 0;
              exports3.setTimeout = function() {
                return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
              };
              exports3.setInterval = function() {
                return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
              };
              exports3.clearTimeout = exports3.clearInterval = function(timeout) {
                timeout.close();
              };
              function Timeout(id, clearFn) {
                this._id = id;
                this._clearFn = clearFn;
              }
              Timeout.prototype.unref = Timeout.prototype.ref = function() {
              };
              Timeout.prototype.close = function() {
                this._clearFn.call(window, this._id);
              };
              exports3.enroll = function(item, msecs) {
                clearTimeout(item._idleTimeoutId);
                item._idleTimeout = msecs;
              };
              exports3.unenroll = function(item) {
                clearTimeout(item._idleTimeoutId);
                item._idleTimeout = -1;
              };
              exports3._unrefActive = exports3.active = function(item) {
                clearTimeout(item._idleTimeoutId);
                var msecs = item._idleTimeout;
                if (msecs >= 0) {
                  item._idleTimeoutId = setTimeout(function onTimeout() {
                    if (item._onTimeout)
                      item._onTimeout();
                  }, msecs);
                }
              };
              exports3.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
                var id = nextImmediateId++;
                var args = arguments.length < 2 ? false : slice.call(arguments, 1);
                immediateIds[id] = true;
                nextTick(function onNextTick() {
                  if (immediateIds[id]) {
                    if (args) {
                      fn.apply(null, args);
                    } else {
                      fn.call(null);
                    }
                    exports3.clearImmediate(id);
                  }
                });
                return id;
              };
              exports3.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
                delete immediateIds[id];
              };
            }).call(exports3, __webpack_require__(2).setImmediate, __webpack_require__(2).clearImmediate);
          },
          function(module3, exports3) {
            var process = module3.exports = {};
            var cachedSetTimeout;
            var cachedClearTimeout;
            (function() {
              try {
                cachedSetTimeout = setTimeout;
              } catch (e) {
                cachedSetTimeout = function() {
                  throw new Error("setTimeout is not defined");
                };
              }
              try {
                cachedClearTimeout = clearTimeout;
              } catch (e) {
                cachedClearTimeout = function() {
                  throw new Error("clearTimeout is not defined");
                };
              }
            })();
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
              if (!draining || !currentQueue) {
                return;
              }
              draining = false;
              if (currentQueue.length) {
                queue = currentQueue.concat(queue);
              } else {
                queueIndex = -1;
              }
              if (queue.length) {
                drainQueue();
              }
            }
            function drainQueue() {
              if (draining) {
                return;
              }
              var timeout = cachedSetTimeout(cleanUpNextTick);
              draining = true;
              var len = queue.length;
              while (len) {
                currentQueue = queue;
                queue = [];
                while (++queueIndex < len) {
                  if (currentQueue) {
                    currentQueue[queueIndex].run();
                  }
                }
                queueIndex = -1;
                len = queue.length;
              }
              currentQueue = null;
              draining = false;
              cachedClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
              var args = new Array(arguments.length - 1);
              if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                  args[i - 1] = arguments[i];
                }
              }
              queue.push(new Item(fun, args));
              if (queue.length === 1 && !draining) {
                cachedSetTimeout(drainQueue, 0);
              }
            };
            function Item(fun, array) {
              this.fun = fun;
              this.array = array;
            }
            Item.prototype.run = function() {
              this.fun.apply(null, this.array);
            };
            process.title = "browser";
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = "";
            process.versions = {};
            function noop() {
            }
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.binding = function(name) {
              throw new Error("process.binding is not supported");
            };
            process.cwd = function() {
              return "/";
            };
            process.chdir = function(dir) {
              throw new Error("process.chdir is not supported");
            };
            process.umask = function() {
              return 0;
            };
          },
          function(module3, exports3, __webpack_require__) {
            var Utils = __webpack_require__(5);
            var BaseTransition = {
              oldContainer: void 0,
              newContainer: void 0,
              newContainerLoading: void 0,
              extend: function(obj) {
                return Utils.extend(this, obj);
              },
              init: function(oldContainer, newContainer) {
                var _this = this;
                this.oldContainer = oldContainer;
                this._newContainerPromise = newContainer;
                this.deferred = Utils.deferred();
                this.newContainerReady = Utils.deferred();
                this.newContainerLoading = this.newContainerReady.promise;
                this.start();
                this._newContainerPromise.then(function(newContainer2) {
                  _this.newContainer = newContainer2;
                  _this.newContainerReady.resolve();
                });
                return this.deferred.promise;
              },
              done: function() {
                this.oldContainer.parentNode.removeChild(this.oldContainer);
                this.newContainer.style.visibility = "visible";
                this.deferred.resolve();
              },
              start: function() {
              }
            };
            module3.exports = BaseTransition;
          },
          function(module3, exports3) {
            var Utils = {
              getCurrentUrl: function() {
                return window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
              },
              cleanLink: function(url) {
                return url.replace(/#.*/, "");
              },
              xhrTimeout: 5e3,
              xhr: function(url) {
                var deferred = this.deferred();
                var req = new XMLHttpRequest();
                req.onreadystatechange = function() {
                  if (req.readyState === 4) {
                    if (req.status === 200) {
                      return deferred.resolve(req.responseText);
                    } else {
                      return deferred.reject(new Error("xhr: HTTP code is not 200"));
                    }
                  }
                };
                req.ontimeout = function() {
                  return deferred.reject(new Error("xhr: Timeout exceeded"));
                };
                req.open("GET", url);
                req.timeout = this.xhrTimeout;
                req.setRequestHeader("x-barba", "yes");
                req.send();
                return deferred.promise;
              },
              extend: function(obj, props) {
                var newObj = Object.create(obj);
                for (var prop in props) {
                  if (props.hasOwnProperty(prop)) {
                    newObj[prop] = props[prop];
                  }
                }
                return newObj;
              },
              deferred: function() {
                return new function() {
                  this.resolve = null;
                  this.reject = null;
                  this.promise = new Promise(function(resolve, reject) {
                    this.resolve = resolve;
                    this.reject = reject;
                  }.bind(this));
                }();
              },
              getPort: function(p) {
                var port = typeof p !== "undefined" ? p : window.location.port;
                var protocol = window.location.protocol;
                if (port != "")
                  return parseInt(port);
                if (protocol === "http:")
                  return 80;
                if (protocol === "https:")
                  return 443;
              }
            };
            module3.exports = Utils;
          },
          function(module3, exports3, __webpack_require__) {
            var Dispatcher = __webpack_require__(7);
            var Utils = __webpack_require__(5);
            var BaseView = {
              namespace: null,
              extend: function(obj) {
                return Utils.extend(this, obj);
              },
              init: function() {
                var _this = this;
                Dispatcher.on("initStateChange", function(newStatus, oldStatus) {
                  if (oldStatus && oldStatus.namespace === _this.namespace)
                    _this.onLeave();
                });
                Dispatcher.on("newPageReady", function(newStatus, oldStatus, container) {
                  _this.container = container;
                  if (newStatus.namespace === _this.namespace)
                    _this.onEnter();
                });
                Dispatcher.on("transitionCompleted", function(newStatus, oldStatus) {
                  if (newStatus.namespace === _this.namespace)
                    _this.onEnterCompleted();
                  if (oldStatus && oldStatus.namespace === _this.namespace)
                    _this.onLeaveCompleted();
                });
              },
              onEnter: function() {
              },
              onEnterCompleted: function() {
              },
              onLeave: function() {
              },
              onLeaveCompleted: function() {
              }
            };
            module3.exports = BaseView;
          },
          function(module3, exports3) {
            var Dispatcher = {
              events: {},
              on: function(e, f) {
                this.events[e] = this.events[e] || [];
                this.events[e].push(f);
              },
              off: function(e, f) {
                if (e in this.events === false)
                  return;
                this.events[e].splice(this.events[e].indexOf(f), 1);
              },
              trigger: function(e) {
                if (e in this.events === false)
                  return;
                for (var i = 0; i < this.events[e].length; i++) {
                  this.events[e][i].apply(this, Array.prototype.slice.call(arguments, 1));
                }
              }
            };
            module3.exports = Dispatcher;
          },
          function(module3, exports3, __webpack_require__) {
            var Utils = __webpack_require__(5);
            var BaseCache = {
              data: {},
              extend: function(obj) {
                return Utils.extend(this, obj);
              },
              set: function(key, val) {
                this.data[key] = val;
              },
              get: function(key) {
                return this.data[key];
              },
              reset: function() {
                this.data = {};
              }
            };
            module3.exports = BaseCache;
          },
          function(module3, exports3) {
            var HistoryManager = {
              history: [],
              add: function(url, namespace) {
                if (!namespace)
                  namespace = void 0;
                this.history.push({
                  url,
                  namespace
                });
              },
              currentStatus: function() {
                return this.history[this.history.length - 1];
              },
              prevStatus: function() {
                var history = this.history;
                if (history.length < 2)
                  return null;
                return history[history.length - 2];
              }
            };
            module3.exports = HistoryManager;
          },
          function(module3, exports3, __webpack_require__) {
            var Utils = __webpack_require__(5);
            var Dispatcher = __webpack_require__(7);
            var HideShowTransition = __webpack_require__(11);
            var BaseCache = __webpack_require__(8);
            var HistoryManager = __webpack_require__(9);
            var Dom = __webpack_require__(12);
            var Pjax = {
              Dom,
              History: HistoryManager,
              Cache: BaseCache,
              cacheEnabled: true,
              transitionProgress: false,
              ignoreClassLink: "no-barba",
              start: function() {
                this.init();
              },
              init: function() {
                var container = this.Dom.getContainer();
                var wrapper = this.Dom.getWrapper();
                wrapper.setAttribute("aria-live", "polite");
                this.History.add(this.getCurrentUrl(), this.Dom.getNamespace(container));
                Dispatcher.trigger("initStateChange", this.History.currentStatus());
                Dispatcher.trigger("newPageReady", this.History.currentStatus(), {}, container, this.Dom.currentHTML);
                Dispatcher.trigger("transitionCompleted", this.History.currentStatus());
                this.bindEvents();
              },
              bindEvents: function() {
                document.addEventListener("click", this.onLinkClick.bind(this));
                window.addEventListener("popstate", this.onStateChange.bind(this));
              },
              getCurrentUrl: function() {
                return Utils.cleanLink(Utils.getCurrentUrl());
              },
              goTo: function(url) {
                window.history.pushState(null, null, url);
                this.onStateChange();
              },
              forceGoTo: function(url) {
                window.location = url;
              },
              load: function(url) {
                var deferred = Utils.deferred();
                var _this = this;
                var xhr;
                xhr = this.Cache.get(url);
                if (!xhr) {
                  xhr = Utils.xhr(url);
                  this.Cache.set(url, xhr);
                }
                xhr.then(function(data) {
                  var container = _this.Dom.parseResponse(data);
                  _this.Dom.putContainer(container);
                  if (!_this.cacheEnabled)
                    _this.Cache.reset();
                  deferred.resolve(container);
                }, function() {
                  _this.forceGoTo(url);
                  deferred.reject();
                });
                return deferred.promise;
              },
              getHref: function(el) {
                if (!el) {
                  return void 0;
                }
                if (el.getAttribute && typeof el.getAttribute("xlink:href") === "string") {
                  return el.getAttribute("xlink:href");
                }
                if (typeof el.href === "string") {
                  return el.href;
                }
                return void 0;
              },
              onLinkClick: function(evt) {
                var el = evt.target;
                while (el && !this.getHref(el)) {
                  el = el.parentNode;
                }
                if (this.preventCheck(evt, el)) {
                  evt.stopPropagation();
                  evt.preventDefault();
                  Dispatcher.trigger("linkClicked", el, evt);
                  var href = this.getHref(el);
                  this.goTo(href);
                }
              },
              preventCheck: function(evt, element) {
                if (!window.history.pushState)
                  return false;
                var href = this.getHref(element);
                if (!element || !href)
                  return false;
                if (evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey)
                  return false;
                if (element.target && element.target === "_blank")
                  return false;
                if (window.location.protocol !== element.protocol || window.location.hostname !== element.hostname)
                  return false;
                if (Utils.getPort() !== Utils.getPort(element.port))
                  return false;
                if (href.indexOf("#") > -1)
                  return false;
                if (element.getAttribute && typeof element.getAttribute("download") === "string")
                  return false;
                if (Utils.cleanLink(href) == Utils.cleanLink(location.href))
                  return false;
                if (element.classList.contains(this.ignoreClassLink))
                  return false;
                return true;
              },
              getTransition: function() {
                return HideShowTransition;
              },
              onStateChange: function() {
                var newUrl = this.getCurrentUrl();
                if (this.transitionProgress)
                  this.forceGoTo(newUrl);
                if (this.History.currentStatus().url === newUrl)
                  return false;
                this.History.add(newUrl);
                var newContainer = this.load(newUrl);
                var transition = Object.create(this.getTransition());
                this.transitionProgress = true;
                Dispatcher.trigger("initStateChange", this.History.currentStatus(), this.History.prevStatus());
                var transitionInstance = transition.init(this.Dom.getContainer(), newContainer);
                newContainer.then(this.onNewContainerLoaded.bind(this));
                transitionInstance.then(this.onTransitionEnd.bind(this));
              },
              onNewContainerLoaded: function(container) {
                var currentStatus = this.History.currentStatus();
                currentStatus.namespace = this.Dom.getNamespace(container);
                Dispatcher.trigger("newPageReady", this.History.currentStatus(), this.History.prevStatus(), container, this.Dom.currentHTML);
              },
              onTransitionEnd: function() {
                this.transitionProgress = false;
                Dispatcher.trigger("transitionCompleted", this.History.currentStatus(), this.History.prevStatus());
              }
            };
            module3.exports = Pjax;
          },
          function(module3, exports3, __webpack_require__) {
            var BaseTransition = __webpack_require__(4);
            var HideShowTransition = BaseTransition.extend({
              start: function() {
                this.newContainerLoading.then(this.finish.bind(this));
              },
              finish: function() {
                document.body.scrollTop = 0;
                this.done();
              }
            });
            module3.exports = HideShowTransition;
          },
          function(module3, exports3) {
            var Dom = {
              dataNamespace: "namespace",
              wrapperId: "barba-wrapper",
              containerClass: "barba-container",
              currentHTML: document.documentElement.innerHTML,
              parseResponse: function(responseText) {
                this.currentHTML = responseText;
                var wrapper = document.createElement("div");
                wrapper.innerHTML = responseText;
                var titleEl = wrapper.querySelector("title");
                if (titleEl)
                  document.title = titleEl.textContent;
                return this.getContainer(wrapper);
              },
              getWrapper: function() {
                var wrapper = document.getElementById(this.wrapperId);
                if (!wrapper)
                  throw new Error("Barba.js: wrapper not found!");
                return wrapper;
              },
              getContainer: function(element) {
                if (!element)
                  element = document.body;
                if (!element)
                  throw new Error("Barba.js: DOM not ready!");
                var container = this.parseContainer(element);
                if (container && container.jquery)
                  container = container[0];
                if (!container)
                  throw new Error("Barba.js: no container found");
                return container;
              },
              getNamespace: function(element) {
                if (element && element.dataset) {
                  return element.dataset[this.dataNamespace];
                } else if (element) {
                  return element.getAttribute("data-" + this.dataNamespace);
                }
                return null;
              },
              putContainer: function(element) {
                element.style.visibility = "hidden";
                var wrapper = this.getWrapper();
                wrapper.appendChild(element);
              },
              parseContainer: function(element) {
                return element.querySelector("." + this.containerClass);
              }
            };
            module3.exports = Dom;
          },
          function(module3, exports3, __webpack_require__) {
            var Utils = __webpack_require__(5);
            var Pjax = __webpack_require__(10);
            var Prefetch = {
              ignoreClassLink: "no-barba-prefetch",
              init: function() {
                if (!window.history.pushState) {
                  return false;
                }
                document.body.addEventListener("mouseover", this.onLinkEnter.bind(this));
                document.body.addEventListener("touchstart", this.onLinkEnter.bind(this));
              },
              onLinkEnter: function(evt) {
                var el = evt.target;
                while (el && !Pjax.getHref(el)) {
                  el = el.parentNode;
                }
                if (!el || el.classList.contains(this.ignoreClassLink)) {
                  return;
                }
                var url = Pjax.getHref(el);
                if (Pjax.preventCheck(evt, el) && !Pjax.Cache.get(url)) {
                  var xhr = Utils.xhr(url);
                  Pjax.Cache.set(url, xhr);
                }
              }
            };
            module3.exports = Prefetch;
          }
        ]);
      });
    }
  });

  // node_modules/glightbox/dist/js/glightbox.min.js
  var require_glightbox_min = __commonJS({
    "node_modules/glightbox/dist/js/glightbox.min.js"(exports2, module2) {
      !function(e, t) {
        typeof exports2 == "object" && typeof module2 != "undefined" ? module2.exports = t() : typeof define == "function" && define.amd ? define(t) : (e = e || self).GLightbox = t();
      }(exports2, function() {
        "use strict";
        function e(t2) {
          return (e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e2) {
            return typeof e2;
          } : function(e2) {
            return e2 && typeof Symbol == "function" && e2.constructor === Symbol && e2 !== Symbol.prototype ? "symbol" : typeof e2;
          })(t2);
        }
        function t(e2, t2) {
          if (!(e2 instanceof t2))
            throw new TypeError("Cannot call a class as a function");
        }
        function i(e2, t2) {
          for (var i2 = 0; i2 < t2.length; i2++) {
            var n2 = t2[i2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function n(e2, t2, n2) {
          return t2 && i(e2.prototype, t2), n2 && i(e2, n2), e2;
        }
        var s = Date.now();
        function l() {
          var e2 = {}, t2 = true, i2 = 0, n2 = arguments.length;
          Object.prototype.toString.call(arguments[0]) === "[object Boolean]" && (t2 = arguments[0], i2++);
          for (var s2 = function(i3) {
            for (var n3 in i3)
              Object.prototype.hasOwnProperty.call(i3, n3) && (t2 && Object.prototype.toString.call(i3[n3]) === "[object Object]" ? e2[n3] = l(true, e2[n3], i3[n3]) : e2[n3] = i3[n3]);
          }; i2 < n2; i2++) {
            var o2 = arguments[i2];
            s2(o2);
          }
          return e2;
        }
        function o(e2, t2) {
          if ((k(e2) || e2 === window || e2 === document) && (e2 = [e2]), A(e2) || L(e2) || (e2 = [e2]), P(e2) != 0) {
            if (A(e2) && !L(e2))
              for (var i2 = e2.length, n2 = 0; n2 < i2 && t2.call(e2[n2], e2[n2], n2, e2) !== false; n2++)
                ;
            else if (L(e2)) {
              for (var s2 in e2)
                if (O(e2, s2) && t2.call(e2[s2], e2[s2], s2, e2) === false)
                  break;
            }
          }
        }
        function r(e2) {
          var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n2 = e2[s] = e2[s] || [], l2 = { all: n2, evt: null, found: null };
          return t2 && i2 && P(n2) > 0 && o(n2, function(e3, n3) {
            if (e3.eventName == t2 && e3.fn.toString() == i2.toString())
              return l2.found = true, l2.evt = n3, false;
          }), l2;
        }
        function a(e2) {
          var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i2 = t2.onElement, n2 = t2.withCallback, s2 = t2.avoidDuplicate, l2 = s2 === void 0 || s2, a2 = t2.once, h2 = a2 !== void 0 && a2, d2 = t2.useCapture, c2 = d2 !== void 0 && d2, u2 = arguments.length > 2 ? arguments[2] : void 0, g2 = i2 || [];
          function v2(e3) {
            T(n2) && n2.call(u2, e3, this), h2 && v2.destroy();
          }
          return C(g2) && (g2 = document.querySelectorAll(g2)), v2.destroy = function() {
            o(g2, function(t3) {
              var i3 = r(t3, e2, v2);
              i3.found && i3.all.splice(i3.evt, 1), t3.removeEventListener && t3.removeEventListener(e2, v2, c2);
            });
          }, o(g2, function(t3) {
            var i3 = r(t3, e2, v2);
            (t3.addEventListener && l2 && !i3.found || !l2) && (t3.addEventListener(e2, v2, c2), i3.all.push({ eventName: e2, fn: v2 }));
          }), v2;
        }
        function h(e2, t2) {
          o(t2.split(" "), function(t3) {
            return e2.classList.add(t3);
          });
        }
        function d(e2, t2) {
          o(t2.split(" "), function(t3) {
            return e2.classList.remove(t3);
          });
        }
        function c(e2, t2) {
          return e2.classList.contains(t2);
        }
        function u(e2, t2) {
          for (; e2 !== document.body; ) {
            if (!(e2 = e2.parentElement))
              return false;
            if (typeof e2.matches == "function" ? e2.matches(t2) : e2.msMatchesSelector(t2))
              return e2;
          }
        }
        function g(e2) {
          var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i2 = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
          if (!e2 || t2 === "")
            return false;
          if (t2 === "none")
            return T(i2) && i2(), false;
          var n2 = x(), s2 = t2.split(" ");
          o(s2, function(t3) {
            h(e2, "g" + t3);
          }), a(n2, { onElement: e2, avoidDuplicate: false, once: true, withCallback: function(e3, t3) {
            o(s2, function(e4) {
              d(t3, "g" + e4);
            }), T(i2) && i2();
          } });
        }
        function v(e2) {
          var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
          if (t2 === "")
            return e2.style.webkitTransform = "", e2.style.MozTransform = "", e2.style.msTransform = "", e2.style.OTransform = "", e2.style.transform = "", false;
          e2.style.webkitTransform = t2, e2.style.MozTransform = t2, e2.style.msTransform = t2, e2.style.OTransform = t2, e2.style.transform = t2;
        }
        function f(e2) {
          e2.style.display = "block";
        }
        function p(e2) {
          e2.style.display = "none";
        }
        function m(e2) {
          var t2 = document.createDocumentFragment(), i2 = document.createElement("div");
          for (i2.innerHTML = e2; i2.firstChild; )
            t2.appendChild(i2.firstChild);
          return t2;
        }
        function y() {
          return { width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight };
        }
        function x() {
          var e2, t2 = document.createElement("fakeelement"), i2 = { animation: "animationend", OAnimation: "oAnimationEnd", MozAnimation: "animationend", WebkitAnimation: "webkitAnimationEnd" };
          for (e2 in i2)
            if (t2.style[e2] !== void 0)
              return i2[e2];
        }
        function b(e2, t2, i2, n2) {
          if (e2())
            t2();
          else {
            var s2;
            i2 || (i2 = 100);
            var l2 = setInterval(function() {
              e2() && (clearInterval(l2), s2 && clearTimeout(s2), t2());
            }, i2);
            n2 && (s2 = setTimeout(function() {
              clearInterval(l2);
            }, n2));
          }
        }
        function S(e2, t2, i2) {
          if (I(e2))
            console.error("Inject assets error");
          else if (T(t2) && (i2 = t2, t2 = false), C(t2) && t2 in window)
            T(i2) && i2();
          else {
            var n2;
            if (e2.indexOf(".css") !== -1) {
              if ((n2 = document.querySelectorAll('link[href="' + e2 + '"]')) && n2.length > 0)
                return void (T(i2) && i2());
              var s2 = document.getElementsByTagName("head")[0], l2 = s2.querySelectorAll('link[rel="stylesheet"]'), o2 = document.createElement("link");
              return o2.rel = "stylesheet", o2.type = "text/css", o2.href = e2, o2.media = "all", l2 ? s2.insertBefore(o2, l2[0]) : s2.appendChild(o2), void (T(i2) && i2());
            }
            if ((n2 = document.querySelectorAll('script[src="' + e2 + '"]')) && n2.length > 0) {
              if (T(i2)) {
                if (C(t2))
                  return b(function() {
                    return window[t2] !== void 0;
                  }, function() {
                    i2();
                  }), false;
                i2();
              }
            } else {
              var r2 = document.createElement("script");
              r2.type = "text/javascript", r2.src = e2, r2.onload = function() {
                if (T(i2)) {
                  if (C(t2))
                    return b(function() {
                      return window[t2] !== void 0;
                    }, function() {
                      i2();
                    }), false;
                  i2();
                }
              }, document.body.appendChild(r2);
            }
          }
        }
        function w() {
          return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
        }
        function T(e2) {
          return typeof e2 == "function";
        }
        function C(e2) {
          return typeof e2 == "string";
        }
        function k(e2) {
          return !(!e2 || !e2.nodeType || e2.nodeType != 1);
        }
        function E(e2) {
          return Array.isArray(e2);
        }
        function A(e2) {
          return e2 && e2.length && isFinite(e2.length);
        }
        function L(t2) {
          return e(t2) === "object" && t2 != null && !T(t2) && !E(t2);
        }
        function I(e2) {
          return e2 == null;
        }
        function O(e2, t2) {
          return e2 !== null && hasOwnProperty.call(e2, t2);
        }
        function P(e2) {
          if (L(e2)) {
            if (e2.keys)
              return e2.keys().length;
            var t2 = 0;
            for (var i2 in e2)
              O(e2, i2) && t2++;
            return t2;
          }
          return e2.length;
        }
        function M(e2) {
          return !isNaN(parseFloat(e2)) && isFinite(e2);
        }
        function z() {
          var e2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, t2 = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
          if (!t2.length)
            return false;
          if (t2.length == 1)
            return t2[0];
          typeof e2 == "string" && (e2 = parseInt(e2));
          var i2 = [];
          o(t2, function(e3) {
            i2.push(e3.getAttribute("data-taborder"));
          });
          var n2 = Math.max.apply(Math, i2.map(function(e3) {
            return parseInt(e3);
          })), s2 = e2 < 0 ? 1 : e2 + 1;
          s2 > n2 && (s2 = "1");
          var l2 = i2.filter(function(e3) {
            return e3 >= parseInt(s2);
          }), r2 = l2.sort()[0];
          return document.querySelector('.gbtn[data-taborder="'.concat(r2, '"]'));
        }
        function X(e2) {
          if (e2.events.hasOwnProperty("keyboard"))
            return false;
          e2.events.keyboard = a("keydown", { onElement: window, withCallback: function(t2, i2) {
            var n2 = (t2 = t2 || window.event).keyCode;
            if (n2 == 9) {
              var s2 = document.querySelector(".gbtn.focused");
              if (!s2) {
                var l2 = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                if (l2 == "input" || l2 == "textarea" || l2 == "button")
                  return;
              }
              t2.preventDefault();
              var o2 = document.querySelectorAll(".gbtn[data-taborder]");
              if (!o2 || o2.length <= 0)
                return;
              if (!s2) {
                var r2 = z();
                return void (r2 && (r2.focus(), h(r2, "focused")));
              }
              var a2 = z(s2.getAttribute("data-taborder"));
              d(s2, "focused"), a2 && (a2.focus(), h(a2, "focused"));
            }
            n2 == 39 && e2.nextSlide(), n2 == 37 && e2.prevSlide(), n2 == 27 && e2.close();
          } });
        }
        function Y(e2) {
          return Math.sqrt(e2.x * e2.x + e2.y * e2.y);
        }
        function q(e2, t2) {
          var i2 = function(e3, t3) {
            var i3 = Y(e3) * Y(t3);
            if (i3 === 0)
              return 0;
            var n2 = function(e4, t4) {
              return e4.x * t4.x + e4.y * t4.y;
            }(e3, t3) / i3;
            return n2 > 1 && (n2 = 1), Math.acos(n2);
          }(e2, t2);
          return function(e3, t3) {
            return e3.x * t3.y - t3.x * e3.y;
          }(e2, t2) > 0 && (i2 *= -1), 180 * i2 / Math.PI;
        }
        var N = function() {
          function e2(i2) {
            t(this, e2), this.handlers = [], this.el = i2;
          }
          return n(e2, [{ key: "add", value: function(e3) {
            this.handlers.push(e3);
          } }, { key: "del", value: function(e3) {
            e3 || (this.handlers = []);
            for (var t2 = this.handlers.length; t2 >= 0; t2--)
              this.handlers[t2] === e3 && this.handlers.splice(t2, 1);
          } }, { key: "dispatch", value: function() {
            for (var e3 = 0, t2 = this.handlers.length; e3 < t2; e3++) {
              var i2 = this.handlers[e3];
              typeof i2 == "function" && i2.apply(this.el, arguments);
            }
          } }]), e2;
        }();
        function D(e2, t2) {
          var i2 = new N(e2);
          return i2.add(t2), i2;
        }
        var _ = function() {
          function e2(i2, n2) {
            t(this, e2), this.element = typeof i2 == "string" ? document.querySelector(i2) : i2, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, false), this.element.addEventListener("touchmove", this.move, false), this.element.addEventListener("touchend", this.end, false), this.element.addEventListener("touchcancel", this.cancel, false), this.preV = { x: null, y: null }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = false;
            var s2 = function() {
            };
            this.rotate = D(this.element, n2.rotate || s2), this.touchStart = D(this.element, n2.touchStart || s2), this.multipointStart = D(this.element, n2.multipointStart || s2), this.multipointEnd = D(this.element, n2.multipointEnd || s2), this.pinch = D(this.element, n2.pinch || s2), this.swipe = D(this.element, n2.swipe || s2), this.tap = D(this.element, n2.tap || s2), this.doubleTap = D(this.element, n2.doubleTap || s2), this.longTap = D(this.element, n2.longTap || s2), this.singleTap = D(this.element, n2.singleTap || s2), this.pressMove = D(this.element, n2.pressMove || s2), this.twoFingerPressMove = D(this.element, n2.twoFingerPressMove || s2), this.touchMove = D(this.element, n2.touchMove || s2), this.touchEnd = D(this.element, n2.touchEnd || s2), this.touchCancel = D(this.element, n2.touchCancel || s2), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = { x: null, y: null };
          }
          return n(e2, [{ key: "start", value: function(e3) {
            if (e3.touches) {
              if (e3.target && e3.target.nodeName && ["a", "button", "input"].indexOf(e3.target.nodeName.toLowerCase()) >= 0)
                console.log("ignore drag for this touched element", e3.target.nodeName.toLowerCase());
              else {
                this.now = Date.now(), this.x1 = e3.touches[0].pageX, this.y1 = e3.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e3, this.element), this.preTapPosition.x !== null && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                var t2 = this.preV;
                if (e3.touches.length > 1) {
                  this._cancelLongTap(), this._cancelSingleTap();
                  var i2 = { x: e3.touches[1].pageX - this.x1, y: e3.touches[1].pageY - this.y1 };
                  t2.x = i2.x, t2.y = i2.y, this.pinchStartLen = Y(t2), this.multipointStart.dispatch(e3, this.element);
                }
                this._preventTap = false, this.longTapTimeout = setTimeout(function() {
                  this.longTap.dispatch(e3, this.element), this._preventTap = true;
                }.bind(this), 750);
              }
            }
          } }, { key: "move", value: function(e3) {
            if (e3.touches) {
              var t2 = this.preV, i2 = e3.touches.length, n2 = e3.touches[0].pageX, s2 = e3.touches[0].pageY;
              if (this.isDoubleTap = false, i2 > 1) {
                var l2 = e3.touches[1].pageX, o2 = e3.touches[1].pageY, r2 = { x: e3.touches[1].pageX - n2, y: e3.touches[1].pageY - s2 };
                t2.x !== null && (this.pinchStartLen > 0 && (e3.zoom = Y(r2) / this.pinchStartLen, this.pinch.dispatch(e3, this.element)), e3.angle = q(r2, t2), this.rotate.dispatch(e3, this.element)), t2.x = r2.x, t2.y = r2.y, this.x2 !== null && this.sx2 !== null ? (e3.deltaX = (n2 - this.x2 + l2 - this.sx2) / 2, e3.deltaY = (s2 - this.y2 + o2 - this.sy2) / 2) : (e3.deltaX = 0, e3.deltaY = 0), this.twoFingerPressMove.dispatch(e3, this.element), this.sx2 = l2, this.sy2 = o2;
              } else {
                if (this.x2 !== null) {
                  e3.deltaX = n2 - this.x2, e3.deltaY = s2 - this.y2;
                  var a2 = Math.abs(this.x1 - this.x2), h2 = Math.abs(this.y1 - this.y2);
                  (a2 > 10 || h2 > 10) && (this._preventTap = true);
                } else
                  e3.deltaX = 0, e3.deltaY = 0;
                this.pressMove.dispatch(e3, this.element);
              }
              this.touchMove.dispatch(e3, this.element), this._cancelLongTap(), this.x2 = n2, this.y2 = s2, i2 > 1 && e3.preventDefault();
            }
          } }, { key: "end", value: function(e3) {
            if (e3.changedTouches) {
              this._cancelLongTap();
              var t2 = this;
              e3.touches.length < 2 && (this.multipointEnd.dispatch(e3, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e3.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
                t2.swipe.dispatch(e3, t2.element);
              }, 0)) : (this.tapTimeout = setTimeout(function() {
                t2._preventTap || t2.tap.dispatch(e3, t2.element), t2.isDoubleTap && (t2.doubleTap.dispatch(e3, t2.element), t2.isDoubleTap = false);
              }, 0), t2.isDoubleTap || (t2.singleTapTimeout = setTimeout(function() {
                t2.singleTap.dispatch(e3, t2.element);
              }, 250))), this.touchEnd.dispatch(e3, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
            }
          } }, { key: "cancelAll", value: function() {
            this._preventTap = true, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
          } }, { key: "cancel", value: function(e3) {
            this.cancelAll(), this.touchCancel.dispatch(e3, this.element);
          } }, { key: "_cancelLongTap", value: function() {
            clearTimeout(this.longTapTimeout);
          } }, { key: "_cancelSingleTap", value: function() {
            clearTimeout(this.singleTapTimeout);
          } }, { key: "_swipeDirection", value: function(e3, t2, i2, n2) {
            return Math.abs(e3 - t2) >= Math.abs(i2 - n2) ? e3 - t2 > 0 ? "Left" : "Right" : i2 - n2 > 0 ? "Up" : "Down";
          } }, { key: "on", value: function(e3, t2) {
            this[e3] && this[e3].add(t2);
          } }, { key: "off", value: function(e3, t2) {
            this[e3] && this[e3].del(t2);
          } }, { key: "destroy", value: function() {
            return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
          } }]), e2;
        }();
        function W(e2) {
          var t2 = function() {
            var e3, t3 = document.createElement("fakeelement"), i3 = { transition: "transitionend", OTransition: "oTransitionEnd", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
            for (e3 in i3)
              if (t3.style[e3] !== void 0)
                return i3[e3];
          }(), i2 = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n2 = c(e2, "gslide-media") ? e2 : e2.querySelector(".gslide-media"), s2 = u(n2, ".ginner-container"), l2 = e2.querySelector(".gslide-description");
          i2 > 769 && (n2 = s2), h(n2, "greset"), v(n2, "translate3d(0, 0, 0)"), a(t2, { onElement: n2, once: true, withCallback: function(e3, t3) {
            d(n2, "greset");
          } }), n2.style.opacity = "", l2 && (l2.style.opacity = "");
        }
        function B(e2) {
          if (e2.events.hasOwnProperty("touch"))
            return false;
          var t2, i2, n2, s2 = y(), l2 = s2.width, o2 = s2.height, r2 = false, a2 = null, g2 = null, f2 = null, p2 = false, m2 = 1, x2 = 1, b2 = false, S2 = false, w2 = null, T2 = null, C2 = null, k2 = null, E2 = 0, A2 = 0, L2 = false, I2 = false, O2 = {}, P2 = {}, M2 = 0, z2 = 0, X2 = document.getElementById("glightbox-slider"), Y2 = document.querySelector(".goverlay"), q2 = new _(X2, { touchStart: function(t3) {
            if (r2 = true, (c(t3.targetTouches[0].target, "ginner-container") || u(t3.targetTouches[0].target, ".gslide-desc") || t3.targetTouches[0].target.nodeName.toLowerCase() == "a") && (r2 = false), u(t3.targetTouches[0].target, ".gslide-inline") && !c(t3.targetTouches[0].target.parentNode, "gslide-inline") && (r2 = false), r2) {
              if (P2 = t3.targetTouches[0], O2.pageX = t3.targetTouches[0].pageX, O2.pageY = t3.targetTouches[0].pageY, M2 = t3.targetTouches[0].clientX, z2 = t3.targetTouches[0].clientY, a2 = e2.activeSlide, g2 = a2.querySelector(".gslide-media"), n2 = a2.querySelector(".gslide-inline"), f2 = null, c(g2, "gslide-image") && (f2 = g2.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (g2 = a2.querySelector(".ginner-container")), d(Y2, "greset"), t3.pageX > 20 && t3.pageX < window.innerWidth - 20)
                return;
              t3.preventDefault();
            }
          }, touchMove: function(s3) {
            if (r2 && (P2 = s3.targetTouches[0], !b2 && !S2)) {
              if (n2 && n2.offsetHeight > o2) {
                var a3 = O2.pageX - P2.pageX;
                if (Math.abs(a3) <= 13)
                  return false;
              }
              p2 = true;
              var h2, d2 = s3.targetTouches[0].clientX, c2 = s3.targetTouches[0].clientY, u2 = M2 - d2, m3 = z2 - c2;
              if (Math.abs(u2) > Math.abs(m3) ? (L2 = false, I2 = true) : (I2 = false, L2 = true), t2 = P2.pageX - O2.pageX, E2 = 100 * t2 / l2, i2 = P2.pageY - O2.pageY, A2 = 100 * i2 / o2, L2 && f2 && (h2 = 1 - Math.abs(i2) / o2, Y2.style.opacity = h2, e2.settings.touchFollowAxis && (E2 = 0)), I2 && (h2 = 1 - Math.abs(t2) / l2, g2.style.opacity = h2, e2.settings.touchFollowAxis && (A2 = 0)), !f2)
                return v(g2, "translate3d(".concat(E2, "%, 0, 0)"));
              v(g2, "translate3d(".concat(E2, "%, ").concat(A2, "%, 0)"));
            }
          }, touchEnd: function() {
            if (r2) {
              if (p2 = false, S2 || b2)
                return C2 = w2, void (k2 = T2);
              var t3 = Math.abs(parseInt(A2)), i3 = Math.abs(parseInt(E2));
              if (!(t3 > 29 && f2))
                return t3 < 29 && i3 < 25 ? (h(Y2, "greset"), Y2.style.opacity = 1, W(g2)) : void 0;
              e2.close();
            }
          }, multipointEnd: function() {
            setTimeout(function() {
              b2 = false;
            }, 50);
          }, multipointStart: function() {
            b2 = true, m2 = x2 || 1;
          }, pinch: function(e3) {
            if (!f2 || p2)
              return false;
            b2 = true, f2.scaleX = f2.scaleY = m2 * e3.zoom;
            var t3 = m2 * e3.zoom;
            if (S2 = true, t3 <= 1)
              return S2 = false, t3 = 1, k2 = null, C2 = null, w2 = null, T2 = null, void f2.setAttribute("style", "");
            t3 > 4.5 && (t3 = 4.5), f2.style.transform = "scale3d(".concat(t3, ", ").concat(t3, ", 1)"), x2 = t3;
          }, pressMove: function(e3) {
            if (S2 && !b2) {
              var t3 = P2.pageX - O2.pageX, i3 = P2.pageY - O2.pageY;
              C2 && (t3 += C2), k2 && (i3 += k2), w2 = t3, T2 = i3;
              var n3 = "translate3d(".concat(t3, "px, ").concat(i3, "px, 0)");
              x2 && (n3 += " scale3d(".concat(x2, ", ").concat(x2, ", 1)")), v(f2, n3);
            }
          }, swipe: function(t3) {
            if (!S2)
              if (b2)
                b2 = false;
              else {
                if (t3.direction == "Left") {
                  if (e2.index == e2.elements.length - 1)
                    return W(g2);
                  e2.nextSlide();
                }
                if (t3.direction == "Right") {
                  if (e2.index == 0)
                    return W(g2);
                  e2.prevSlide();
                }
              }
          } });
          e2.events.touch = q2;
        }
        var H = function() {
          function e2(i2, n2) {
            var s2 = this, l2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (t(this, e2), this.img = i2, this.slide = n2, this.onclose = l2, this.img.setZoomEvents)
              return false;
            this.active = false, this.zoomedIn = false, this.dragging = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e3) {
              return s2.dragStart(e3);
            }, false), this.img.addEventListener("mouseup", function(e3) {
              return s2.dragEnd(e3);
            }, false), this.img.addEventListener("mousemove", function(e3) {
              return s2.drag(e3);
            }, false), this.img.addEventListener("click", function(e3) {
              return s2.slide.classList.contains("dragging-nav") ? (s2.zoomOut(), false) : s2.zoomedIn ? void (s2.zoomedIn && !s2.dragging && s2.zoomOut()) : s2.zoomIn();
            }, false), this.img.setZoomEvents = true;
          }
          return n(e2, [{ key: "zoomIn", value: function() {
            var e3 = this.widowWidth();
            if (!(this.zoomedIn || e3 <= 768)) {
              var t2 = this.img;
              if (t2.setAttribute("data-style", t2.getAttribute("style")), t2.style.maxWidth = t2.naturalWidth + "px", t2.style.maxHeight = t2.naturalHeight + "px", t2.naturalWidth > e3) {
                var i2 = e3 / 2 - t2.naturalWidth / 2;
                this.setTranslate(this.img.parentNode, i2, 0);
              }
              this.slide.classList.add("zoomed"), this.zoomedIn = true;
            }
          } }, { key: "zoomOut", value: function() {
            this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && typeof this.onclose == "function" && this.onclose();
          } }, { key: "dragStart", value: function(e3) {
            e3.preventDefault(), this.zoomedIn ? (e3.type === "touchstart" ? (this.initialX = e3.touches[0].clientX - this.xOffset, this.initialY = e3.touches[0].clientY - this.yOffset) : (this.initialX = e3.clientX - this.xOffset, this.initialY = e3.clientY - this.yOffset), e3.target === this.img && (this.active = true, this.img.classList.add("dragging"))) : this.active = false;
          } }, { key: "dragEnd", value: function(e3) {
            var t2 = this;
            e3.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = false, setTimeout(function() {
              t2.dragging = false, t2.img.isDragging = false, t2.img.classList.remove("dragging");
            }, 100);
          } }, { key: "drag", value: function(e3) {
            this.active && (e3.preventDefault(), e3.type === "touchmove" ? (this.currentX = e3.touches[0].clientX - this.initialX, this.currentY = e3.touches[0].clientY - this.initialY) : (this.currentX = e3.clientX - this.initialX, this.currentY = e3.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = true, this.dragging = true, this.setTranslate(this.img, this.currentX, this.currentY));
          } }, { key: "onMove", value: function(e3) {
            if (this.zoomedIn) {
              var t2 = e3.clientX - this.img.naturalWidth / 2, i2 = e3.clientY - this.img.naturalHeight / 2;
              this.setTranslate(this.img, t2, i2);
            }
          } }, { key: "setTranslate", value: function(e3, t2, i2) {
            e3.style.transform = "translate3d(" + t2 + "px, " + i2 + "px, 0)";
          } }, { key: "widowWidth", value: function() {
            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          } }]), e2;
        }(), V = function() {
          function e2() {
            var i2 = this, n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            t(this, e2);
            var s2 = n2.dragEl, l2 = n2.toleranceX, o2 = l2 === void 0 ? 40 : l2, r2 = n2.toleranceY, a2 = r2 === void 0 ? 65 : r2, h2 = n2.slide, d2 = h2 === void 0 ? null : h2, c2 = n2.instance, u2 = c2 === void 0 ? null : c2;
            this.el = s2, this.active = false, this.dragging = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o2, this.toleranceY = a2, this.toleranceReached = false, this.dragContainer = this.el, this.slide = d2, this.instance = u2, this.el.addEventListener("mousedown", function(e3) {
              return i2.dragStart(e3);
            }, false), this.el.addEventListener("mouseup", function(e3) {
              return i2.dragEnd(e3);
            }, false), this.el.addEventListener("mousemove", function(e3) {
              return i2.drag(e3);
            }, false);
          }
          return n(e2, [{ key: "dragStart", value: function(e3) {
            if (this.slide.classList.contains("zoomed"))
              this.active = false;
            else {
              e3.type === "touchstart" ? (this.initialX = e3.touches[0].clientX - this.xOffset, this.initialY = e3.touches[0].clientY - this.yOffset) : (this.initialX = e3.clientX - this.xOffset, this.initialY = e3.clientY - this.yOffset);
              var t2 = e3.target.nodeName.toLowerCase();
              e3.target.classList.contains("nodrag") || u(e3.target, ".nodrag") || ["input", "select", "textarea", "button", "a"].indexOf(t2) !== -1 ? this.active = false : (e3.preventDefault(), (e3.target === this.el || t2 !== "img" && u(e3.target, ".gslide-inline")) && (this.active = true, this.el.classList.add("dragging"), this.dragContainer = u(e3.target, ".ginner-container")));
            }
          } }, { key: "dragEnd", value: function(e3) {
            var t2 = this;
            e3 && e3.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = false, this.doSlideChange && (this.instance.preventOutsideClick = true, this.doSlideChange == "right" && this.instance.prevSlide(), this.doSlideChange == "left" && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, true), setTimeout(function() {
              t2.instance.preventOutsideClick = false, t2.toleranceReached = false, t2.lastDirection = null, t2.dragging = false, t2.el.isDragging = false, t2.el.classList.remove("dragging"), t2.slide.classList.remove("dragging-nav"), t2.dragContainer.style.transform = "", t2.dragContainer.style.transition = "";
            }, 100);
          } }, { key: "drag", value: function(e3) {
            if (this.active) {
              e3.preventDefault(), this.slide.classList.add("dragging-nav"), e3.type === "touchmove" ? (this.currentX = e3.touches[0].clientX - this.initialX, this.currentY = e3.touches[0].clientY - this.initialY) : (this.currentX = e3.clientX - this.initialX, this.currentY = e3.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = true, this.dragging = true, this.doSlideChange = false, this.doSlideClose = false;
              var t2 = Math.abs(this.currentX), i2 = Math.abs(this.currentY);
              if (t2 > 0 && t2 >= Math.abs(this.currentY) && (!this.lastDirection || this.lastDirection == "x")) {
                this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                var n2 = this.shouldChange();
                if (!this.instance.settings.dragAutoSnap && n2 && (this.doSlideChange = n2), this.instance.settings.dragAutoSnap && n2)
                  return this.instance.preventOutsideClick = true, this.toleranceReached = true, this.active = false, this.instance.preventOutsideClick = true, this.dragEnd(null), n2 == "right" && this.instance.prevSlide(), void (n2 == "left" && this.instance.nextSlide());
              }
              if (this.toleranceY > 0 && i2 > 0 && i2 >= t2 && (!this.lastDirection || this.lastDirection == "y")) {
                this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                var s2 = this.shouldClose();
                return !this.instance.settings.dragAutoSnap && s2 && (this.doSlideClose = true), void (this.instance.settings.dragAutoSnap && s2 && this.instance.close());
              }
            }
          } }, { key: "shouldChange", value: function() {
            var e3 = false;
            if (Math.abs(this.currentX) >= this.toleranceX) {
              var t2 = this.currentX > 0 ? "right" : "left";
              (t2 == "left" && this.slide !== this.slide.parentNode.lastChild || t2 == "right" && this.slide !== this.slide.parentNode.firstChild) && (e3 = t2);
            }
            return e3;
          } }, { key: "shouldClose", value: function() {
            var e3 = false;
            return Math.abs(this.currentY) >= this.toleranceY && (e3 = true), e3;
          } }, { key: "setTranslate", value: function(e3, t2, i2) {
            var n2 = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
            e3.style.transition = n2 ? "all .2s ease" : "", e3.style.transform = "translate3d(".concat(t2, "px, ").concat(i2, "px, 0)");
          } }]), e2;
        }();
        function j(e2, t2, i2, n2) {
          var s2 = e2.querySelector(".gslide-media"), l2 = new Image(), o2 = "gSlideTitle_" + i2, r2 = "gSlideDesc_" + i2;
          l2.addEventListener("load", function() {
            T(n2) && n2();
          }, false), l2.src = t2.href, t2.sizes != "" && t2.srcset != "" && (l2.sizes = t2.sizes, l2.srcset = t2.srcset), l2.alt = "", I(t2.alt) || t2.alt === "" || (l2.alt = t2.alt), t2.title !== "" && l2.setAttribute("aria-labelledby", o2), t2.description !== "" && l2.setAttribute("aria-describedby", r2), t2.hasOwnProperty("_hasCustomWidth") && t2._hasCustomWidth && (l2.style.width = t2.width), t2.hasOwnProperty("_hasCustomHeight") && t2._hasCustomHeight && (l2.style.height = t2.height), s2.insertBefore(l2, s2.firstChild);
        }
        function F(e2, t2, i2, n2) {
          var s2 = this, l2 = e2.querySelector(".ginner-container"), o2 = "gvideo" + i2, r2 = e2.querySelector(".gslide-media"), a2 = this.getAllPlayers();
          h(l2, "gvideo-container"), r2.insertBefore(m('<div class="gvideo-wrapper"></div>'), r2.firstChild);
          var d2 = e2.querySelector(".gvideo-wrapper");
          S(this.settings.plyr.css, "Plyr");
          var c2 = t2.href, u2 = t2 == null ? void 0 : t2.videoProvider, g2 = false;
          r2.style.maxWidth = t2.width, S(this.settings.plyr.js, "Plyr", function() {
            if (!u2 && c2.match(/vimeo\.com\/([0-9]*)/) && (u2 = "vimeo"), !u2 && (c2.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c2.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c2.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) && (u2 = "youtube"), u2 === "local" || !u2) {
              u2 = "local";
              var l3 = '<video id="' + o2 + '" ';
              l3 += 'style="background:#000; max-width: '.concat(t2.width, ';" '), l3 += 'preload="metadata" ', l3 += 'x-webkit-airplay="allow" ', l3 += "playsinline ", l3 += "controls ", l3 += 'class="gvideo-local">', l3 += '<source src="'.concat(c2, '">'), g2 = m(l3 += "</video>");
            }
            var r3 = g2 || m('<div id="'.concat(o2, '" data-plyr-provider="').concat(u2, '" data-plyr-embed-id="').concat(c2, '"></div>'));
            h(d2, "".concat(u2, "-video gvideo")), d2.appendChild(r3), d2.setAttribute("data-id", o2), d2.setAttribute("data-index", i2);
            var v2 = O(s2.settings.plyr, "config") ? s2.settings.plyr.config : {}, f2 = new Plyr("#" + o2, v2);
            f2.on("ready", function(e3) {
              a2[o2] = e3.detail.plyr, T(n2) && n2();
            }), b(function() {
              return e2.querySelector("iframe") && e2.querySelector("iframe").dataset.ready == "true";
            }, function() {
              s2.resize(e2);
            }), f2.on("enterfullscreen", R), f2.on("exitfullscreen", R);
          });
        }
        function R(e2) {
          var t2 = u(e2.target, ".gslide-media");
          e2.type === "enterfullscreen" && h(t2, "fullscreen"), e2.type === "exitfullscreen" && d(t2, "fullscreen");
        }
        function G(e2, t2, i2, n2) {
          var s2, l2 = this, o2 = e2.querySelector(".gslide-media"), r2 = !(!O(t2, "href") || !t2.href) && t2.href.split("#").pop().trim(), d2 = !(!O(t2, "content") || !t2.content) && t2.content;
          if (d2 && (C(d2) && (s2 = m('<div class="ginlined-content">'.concat(d2, "</div>"))), k(d2))) {
            d2.style.display == "none" && (d2.style.display = "block");
            var c2 = document.createElement("div");
            c2.className = "ginlined-content", c2.appendChild(d2), s2 = c2;
          }
          if (r2) {
            var u2 = document.getElementById(r2);
            if (!u2)
              return false;
            var g2 = u2.cloneNode(true);
            g2.style.height = t2.height, g2.style.maxWidth = t2.width, h(g2, "ginlined-content"), s2 = g2;
          }
          if (!s2)
            return console.error("Unable to append inline slide content", t2), false;
          o2.style.height = t2.height, o2.style.width = t2.width, o2.appendChild(s2), this.events["inlineclose" + r2] = a("click", { onElement: o2.querySelectorAll(".gtrigger-close"), withCallback: function(e3) {
            e3.preventDefault(), l2.close();
          } }), T(n2) && n2();
        }
        function Z(e2, t2, i2, n2) {
          var s2 = e2.querySelector(".gslide-media"), l2 = function(e3) {
            var t3 = e3.url, i3 = e3.allow, n3 = e3.callback, s3 = e3.appendTo, l3 = document.createElement("iframe");
            return l3.className = "vimeo-video gvideo", l3.src = t3, l3.style.width = "100%", l3.style.height = "100%", i3 && l3.setAttribute("allow", i3), l3.onload = function() {
              l3.onload = null, h(l3, "node-ready"), T(n3) && n3();
            }, s3 && s3.appendChild(l3), l3;
          }({ url: t2.href, callback: n2 });
          s2.parentNode.style.maxWidth = t2.width, s2.parentNode.style.height = t2.height, s2.appendChild(l2);
        }
        var U = function() {
          function e2() {
            var i2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            t(this, e2), this.defaults = { href: "", sizes: "", srcset: "", title: "", type: "", videoProvider: "", description: "", alt: "", descPosition: "bottom", effect: "", width: "", height: "", content: false, zoomable: true, draggable: true }, L(i2) && (this.defaults = l(this.defaults, i2));
          }
          return n(e2, [{ key: "sourceType", value: function(e3) {
            var t2 = e3;
            if ((e3 = e3.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/) !== null)
              return "image";
            if (e3.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e3.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e3.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/))
              return "video";
            if (e3.match(/vimeo\.com\/([0-9]*)/))
              return "video";
            if (e3.match(/\.(mp4|ogg|webm|mov)/) !== null)
              return "video";
            if (e3.match(/\.(mp3|wav|wma|aac|ogg)/) !== null)
              return "audio";
            if (e3.indexOf("#") > -1 && t2.split("#").pop().trim() !== "")
              return "inline";
            return e3.indexOf("goajax=true") > -1 ? "ajax" : "external";
          } }, { key: "parseConfig", value: function(e3, t2) {
            var i2 = this, n2 = l({ descPosition: t2.descPosition }, this.defaults);
            if (L(e3) && !k(e3)) {
              O(e3, "type") || (O(e3, "content") && e3.content ? e3.type = "inline" : O(e3, "href") && (e3.type = this.sourceType(e3.href)));
              var s2 = l(n2, e3);
              return this.setSize(s2, t2), s2;
            }
            var r2 = "", a2 = e3.getAttribute("data-glightbox"), h2 = e3.nodeName.toLowerCase();
            if (h2 === "a" && (r2 = e3.href), h2 === "img" && (r2 = e3.src, n2.alt = e3.alt), n2.href = r2, o(n2, function(s3, l2) {
              O(t2, l2) && l2 !== "width" && (n2[l2] = t2[l2]);
              var o2 = e3.dataset[l2];
              I(o2) || (n2[l2] = i2.sanitizeValue(o2));
            }), n2.content && (n2.type = "inline"), !n2.type && r2 && (n2.type = this.sourceType(r2)), I(a2)) {
              if (!n2.title && h2 == "a") {
                var d2 = e3.title;
                I(d2) || d2 === "" || (n2.title = d2);
              }
              if (!n2.title && h2 == "img") {
                var c2 = e3.alt;
                I(c2) || c2 === "" || (n2.title = c2);
              }
            } else {
              var u2 = [];
              o(n2, function(e4, t3) {
                u2.push(";\\s?" + t3);
              }), u2 = u2.join("\\s?:|"), a2.trim() !== "" && o(n2, function(e4, t3) {
                var s3 = a2, l2 = new RegExp("s?" + t3 + "s?:s?(.*?)(" + u2 + "s?:|$)"), o2 = s3.match(l2);
                if (o2 && o2.length && o2[1]) {
                  var r3 = o2[1].trim().replace(/;\s*$/, "");
                  n2[t3] = i2.sanitizeValue(r3);
                }
              });
            }
            if (n2.description && n2.description.substring(0, 1) === ".") {
              var g2;
              try {
                g2 = document.querySelector(n2.description).innerHTML;
              } catch (e4) {
                if (!(e4 instanceof DOMException))
                  throw e4;
              }
              g2 && (n2.description = g2);
            }
            if (!n2.description) {
              var v2 = e3.querySelector(".glightbox-desc");
              v2 && (n2.description = v2.innerHTML);
            }
            return this.setSize(n2, t2, e3), this.slideConfig = n2, n2;
          } }, { key: "setSize", value: function(e3, t2) {
            var i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n2 = e3.type == "video" ? this.checkSize(t2.videosWidth) : this.checkSize(t2.width), s2 = this.checkSize(t2.height);
            return e3.width = O(e3, "width") && e3.width !== "" ? this.checkSize(e3.width) : n2, e3.height = O(e3, "height") && e3.height !== "" ? this.checkSize(e3.height) : s2, i2 && e3.type == "image" && (e3._hasCustomWidth = !!i2.dataset.width, e3._hasCustomHeight = !!i2.dataset.height), e3;
          } }, { key: "checkSize", value: function(e3) {
            return M(e3) ? "".concat(e3, "px") : e3;
          } }, { key: "sanitizeValue", value: function(e3) {
            return e3 !== "true" && e3 !== "false" ? e3 : e3 === "true";
          } }]), e2;
        }(), $ = function() {
          function e2(i2, n2, s2) {
            t(this, e2), this.element = i2, this.instance = n2, this.index = s2;
          }
          return n(e2, [{ key: "setContent", value: function() {
            var e3 = this, t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, i2 = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
            if (c(t2, "loaded"))
              return false;
            var n2 = this.instance.settings, s2 = this.slideConfig, l2 = w();
            T(n2.beforeSlideLoad) && n2.beforeSlideLoad({ index: this.index, slide: t2, player: false });
            var o2 = s2.type, r2 = s2.descPosition, a2 = t2.querySelector(".gslide-media"), d2 = t2.querySelector(".gslide-title"), u2 = t2.querySelector(".gslide-desc"), g2 = t2.querySelector(".gdesc-inner"), v2 = i2, f2 = "gSlideTitle_" + this.index, p2 = "gSlideDesc_" + this.index;
            if (T(n2.afterSlideLoad) && (v2 = function() {
              T(i2) && i2(), n2.afterSlideLoad({ index: e3.index, slide: t2, player: e3.instance.getSlidePlayerInstance(e3.index) });
            }), s2.title == "" && s2.description == "" ? g2 && g2.parentNode.parentNode.removeChild(g2.parentNode) : (d2 && s2.title !== "" ? (d2.id = f2, d2.innerHTML = s2.title) : d2.parentNode.removeChild(d2), u2 && s2.description !== "" ? (u2.id = p2, l2 && n2.moreLength > 0 ? (s2.smallDescription = this.slideShortDesc(s2.description, n2.moreLength, n2.moreText), u2.innerHTML = s2.smallDescription, this.descriptionEvents(u2, s2)) : u2.innerHTML = s2.description) : u2.parentNode.removeChild(u2), h(a2.parentNode, "desc-".concat(r2)), h(g2.parentNode, "description-".concat(r2))), h(a2, "gslide-".concat(o2)), h(t2, "loaded"), o2 !== "video") {
              if (o2 !== "external")
                return o2 === "inline" ? (G.apply(this.instance, [t2, s2, this.index, v2]), void (s2.draggable && new V({ dragEl: t2.querySelector(".gslide-inline"), toleranceX: n2.dragToleranceX, toleranceY: n2.dragToleranceY, slide: t2, instance: this.instance }))) : void (o2 !== "image" ? T(v2) && v2() : j(t2, s2, this.index, function() {
                  var i3 = t2.querySelector("img");
                  s2.draggable && new V({ dragEl: i3, toleranceX: n2.dragToleranceX, toleranceY: n2.dragToleranceY, slide: t2, instance: e3.instance }), s2.zoomable && i3.naturalWidth > i3.offsetWidth && (h(i3, "zoomable"), new H(i3, t2, function() {
                    e3.instance.resize();
                  })), T(v2) && v2();
                }));
              Z.apply(this, [t2, s2, this.index, v2]);
            } else
              F.apply(this.instance, [t2, s2, this.index, v2]);
          } }, { key: "slideShortDesc", value: function(e3) {
            var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50, i2 = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], n2 = document.createElement("div");
            n2.innerHTML = e3;
            var s2 = n2.innerText, l2 = i2;
            if ((e3 = s2.trim()).length <= t2)
              return e3;
            var o2 = e3.substr(0, t2 - 1);
            return l2 ? (n2 = null, o2 + '... <a href="#" class="desc-more">' + i2 + "</a>") : o2;
          } }, { key: "descriptionEvents", value: function(e3, t2) {
            var i2 = this, n2 = e3.querySelector(".desc-more");
            if (!n2)
              return false;
            a("click", { onElement: n2, withCallback: function(e4, n3) {
              e4.preventDefault();
              var s2 = document.body, l2 = u(n3, ".gslide-desc");
              if (!l2)
                return false;
              l2.innerHTML = t2.description, h(s2, "gdesc-open");
              var o2 = a("click", { onElement: [s2, u(l2, ".gslide-description")], withCallback: function(e5, n4) {
                e5.target.nodeName.toLowerCase() !== "a" && (d(s2, "gdesc-open"), h(s2, "gdesc-closed"), l2.innerHTML = t2.smallDescription, i2.descriptionEvents(l2, t2), setTimeout(function() {
                  d(s2, "gdesc-closed");
                }, 400), o2.destroy());
              } });
            } });
          } }, { key: "create", value: function() {
            return m(this.instance.settings.slideHTML);
          } }, { key: "getConfig", value: function() {
            k(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
            var e3 = new U(this.instance.settings.slideExtraAttributes);
            return this.slideConfig = e3.parseConfig(this.element, this.instance.settings), this.slideConfig;
          } }]), e2;
        }(), J = w(), K = w() !== null || document.createTouch !== void 0 || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, Q = document.getElementsByTagName("html")[0], ee = { selector: ".glightbox", elements: null, skin: "clean", theme: "clean", closeButton: true, startAt: null, autoplayVideos: true, autofocusVideos: true, descPosition: "bottom", width: "900px", height: "506px", videosWidth: "960px", beforeSlideChange: null, afterSlideChange: null, beforeSlideLoad: null, afterSlideLoad: null, slideInserted: null, slideRemoved: null, slideExtraAttributes: null, onOpen: null, onClose: null, loop: false, zoomable: true, draggable: true, dragAutoSnap: false, dragToleranceX: 40, dragToleranceY: 65, preload: true, oneSlidePerOpen: false, touchNavigation: true, touchFollowAxis: true, keyboardNavigation: true, closeOnOutsideClick: true, plugins: false, plyr: { css: "https://cdn.plyr.io/3.6.12/plyr.css", js: "https://cdn.plyr.io/3.6.12/plyr.js", config: { ratio: "16:9", fullscreen: { enabled: true, iosNative: true }, youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3 }, vimeo: { byline: false, portrait: false, title: false, transparent: false } } }, openEffect: "zoom", closeEffect: "zoom", slideEffect: "slide", moreText: "See more", moreLength: 60, cssEfects: { fade: { in: "fadeIn", out: "fadeOut" }, zoom: { in: "zoomIn", out: "zoomOut" }, slide: { in: "slideInRight", out: "slideOutLeft" }, slideBack: { in: "slideInLeft", out: "slideOutRight" }, none: { in: "none", out: "none" } }, svg: { close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>', next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>', prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>' }, slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>', lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>' }, te = function() {
          function e2() {
            var i2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            t(this, e2), this.customOptions = i2, this.settings = l(ee, i2), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = false;
          }
          return n(e2, [{ key: "init", value: function() {
            var e3 = this, t2 = this.getSelector();
            t2 && (this.baseEvents = a("click", { onElement: t2, withCallback: function(t3, i2) {
              t3.preventDefault(), e3.open(i2);
            } })), this.elements = this.getElements();
          } }, { key: "open", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            if (this.elements.length === 0)
              return false;
            this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
            var i2 = M(t2) ? t2 : this.settings.startAt;
            if (k(e3)) {
              var n2 = e3.getAttribute("data-gallery");
              n2 && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n2)), I(i2) && (i2 = this.getElementIndex(e3)) < 0 && (i2 = 0);
            }
            M(i2) || (i2 = 0), this.build(), g(this.overlay, this.settings.openEffect === "none" ? "none" : this.settings.cssEfects.fade.in);
            var s2 = document.body, l2 = window.innerWidth - document.documentElement.clientWidth;
            if (l2 > 0) {
              var o2 = document.createElement("style");
              o2.type = "text/css", o2.className = "gcss-styles", o2.innerText = ".gscrollbar-fixer {margin-right: ".concat(l2, "px}"), document.head.appendChild(o2), h(s2, "gscrollbar-fixer");
            }
            h(s2, "glightbox-open"), h(Q, "glightbox-open"), J && (h(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i2, true), this.elements.length === 1 ? (h(this.prevButton, "glightbox-button-hidden"), h(this.nextButton, "glightbox-button-hidden")) : (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = true, this.trigger("open"), T(this.settings.onOpen) && this.settings.onOpen(), K && this.settings.touchNavigation && B(this), this.settings.keyboardNavigation && X(this);
          } }, { key: "openAt", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            this.open(null, e3);
          } }, { key: "showSlide", value: function() {
            var e3 = this, t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, i2 = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
            f(this.loader), this.index = parseInt(t2);
            var n2 = this.slidesContainer.querySelector(".current");
            n2 && d(n2, "current"), this.slideAnimateOut();
            var s2 = this.slidesContainer.querySelectorAll(".gslide")[t2];
            if (c(s2, "loaded"))
              this.slideAnimateIn(s2, i2), p(this.loader);
            else {
              f(this.loader);
              var l2 = this.elements[t2], o2 = { index: this.index, slide: s2, slideNode: s2, slideConfig: l2.slideConfig, slideIndex: this.index, trigger: l2.node, player: null };
              this.trigger("slide_before_load", o2), l2.instance.setContent(s2, function() {
                p(e3.loader), e3.resize(), e3.slideAnimateIn(s2, i2), e3.trigger("slide_after_load", o2);
              });
            }
            this.slideDescription = s2.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && c(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t2 + 1), this.preloadSlide(t2 - 1)), this.updateNavigationClasses(), this.activeSlide = s2;
          } }, { key: "preloadSlide", value: function(e3) {
            var t2 = this;
            if (e3 < 0 || e3 > this.elements.length - 1)
              return false;
            if (I(this.elements[e3]))
              return false;
            var i2 = this.slidesContainer.querySelectorAll(".gslide")[e3];
            if (c(i2, "loaded"))
              return false;
            var n2 = this.elements[e3], s2 = n2.type, l2 = { index: e3, slide: i2, slideNode: i2, slideConfig: n2.slideConfig, slideIndex: e3, trigger: n2.node, player: null };
            this.trigger("slide_before_load", l2), s2 === "video" || s2 === "external" ? setTimeout(function() {
              n2.instance.setContent(i2, function() {
                t2.trigger("slide_after_load", l2);
              });
            }, 200) : n2.instance.setContent(i2, function() {
              t2.trigger("slide_after_load", l2);
            });
          } }, { key: "prevSlide", value: function() {
            this.goToSlide(this.index - 1);
          } }, { key: "nextSlide", value: function() {
            this.goToSlide(this.index + 1);
          } }, { key: "goToSlide", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e3 < 0 || e3 > this.elements.length - 1))
              return false;
            e3 < 0 ? e3 = this.elements.length - 1 : e3 >= this.elements.length && (e3 = 0), this.showSlide(e3);
          } }, { key: "insertSlide", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            t2 < 0 && (t2 = this.elements.length);
            var i2 = new $(e3, this, t2), n2 = i2.getConfig(), s2 = l({}, n2), o2 = i2.create(), r2 = this.elements.length - 1;
            s2.index = t2, s2.node = false, s2.instance = i2, s2.slideConfig = n2, this.elements.splice(t2, 0, s2);
            var a2 = null, h2 = null;
            if (this.slidesContainer) {
              if (t2 > r2)
                this.slidesContainer.appendChild(o2);
              else {
                var d2 = this.slidesContainer.querySelectorAll(".gslide")[t2];
                this.slidesContainer.insertBefore(o2, d2);
              }
              (this.settings.preload && this.index == 0 && t2 == 0 || this.index - 1 == t2 || this.index + 1 == t2) && this.preloadSlide(t2), this.index === 0 && t2 === 0 && (this.index = 1), this.updateNavigationClasses(), a2 = this.slidesContainer.querySelectorAll(".gslide")[t2], h2 = this.getSlidePlayerInstance(t2), s2.slideNode = a2;
            }
            this.trigger("slide_inserted", { index: t2, slide: a2, slideNode: a2, slideConfig: n2, slideIndex: t2, trigger: null, player: h2 }), T(this.settings.slideInserted) && this.settings.slideInserted({ index: t2, slide: a2, player: h2 });
          } }, { key: "removeSlide", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
            if (e3 < 0 || e3 > this.elements.length - 1)
              return false;
            var t2 = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e3];
            t2 && (this.getActiveSlideIndex() == e3 && (e3 == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t2.parentNode.removeChild(t2)), this.elements.splice(e3, 1), this.trigger("slide_removed", e3), T(this.settings.slideRemoved) && this.settings.slideRemoved(e3);
          } }, { key: "slideAnimateIn", value: function(e3, t2) {
            var i2 = this, n2 = e3.querySelector(".gslide-media"), s2 = e3.querySelector(".gslide-description"), l2 = { index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, slideNode: this.prevActiveSlide, slideIndex: this.prevActiveSlide, slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig, trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, o2 = { index: this.index, slide: this.activeSlide, slideNode: this.activeSlide, slideConfig: this.elements[this.index].slideConfig, slideIndex: this.index, trigger: this.elements[this.index].node, player: this.getSlidePlayerInstance(this.index) };
            if (n2.offsetWidth > 0 && s2 && (p(s2), s2.style.display = ""), d(e3, this.effectsClasses), t2)
              g(e3, this.settings.cssEfects[this.settings.openEffect].in, function() {
                i2.settings.autoplayVideos && i2.slidePlayerPlay(e3), i2.trigger("slide_changed", { prev: l2, current: o2 }), T(i2.settings.afterSlideChange) && i2.settings.afterSlideChange.apply(i2, [l2, o2]);
              });
            else {
              var r2 = this.settings.slideEffect, a2 = r2 !== "none" ? this.settings.cssEfects[r2].in : r2;
              this.prevActiveSlideIndex > this.index && this.settings.slideEffect == "slide" && (a2 = this.settings.cssEfects.slideBack.in), g(e3, a2, function() {
                i2.settings.autoplayVideos && i2.slidePlayerPlay(e3), i2.trigger("slide_changed", { prev: l2, current: o2 }), T(i2.settings.afterSlideChange) && i2.settings.afterSlideChange.apply(i2, [l2, o2]);
              });
            }
            setTimeout(function() {
              i2.resize(e3);
            }, 100), h(e3, "current");
          } }, { key: "slideAnimateOut", value: function() {
            if (!this.prevActiveSlide)
              return false;
            var e3 = this.prevActiveSlide;
            d(e3, this.effectsClasses), h(e3, "prev");
            var t2 = this.settings.slideEffect, i2 = t2 !== "none" ? this.settings.cssEfects[t2].out : t2;
            this.slidePlayerPause(e3), this.trigger("slide_before_change", { prev: { index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, slideNode: this.prevActiveSlide, slideIndex: this.prevActiveSlideIndex, slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig, trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, current: { index: this.index, slide: this.activeSlide, slideNode: this.activeSlide, slideIndex: this.index, slideConfig: this.elements[this.index].slideConfig, trigger: this.elements[this.index].node, player: this.getSlidePlayerInstance(this.index) } }), T(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [{ index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, { index: this.index, slide: this.activeSlide, player: this.getSlidePlayerInstance(this.index) }]), this.prevActiveSlideIndex > this.index && this.settings.slideEffect == "slide" && (i2 = this.settings.cssEfects.slideBack.out), g(e3, i2, function() {
              var t3 = e3.querySelector(".ginner-container"), i3 = e3.querySelector(".gslide-media"), n2 = e3.querySelector(".gslide-description");
              t3.style.transform = "", i3.style.transform = "", d(i3, "greset"), i3.style.opacity = "", n2 && (n2.style.opacity = ""), d(e3, "prev");
            });
          } }, { key: "getAllPlayers", value: function() {
            return this.videoPlayers;
          } }, { key: "getSlidePlayerInstance", value: function(e3) {
            var t2 = "gvideo" + e3, i2 = this.getAllPlayers();
            return !(!O(i2, t2) || !i2[t2]) && i2[t2];
          } }, { key: "stopSlideVideo", value: function(e3) {
            if (k(e3)) {
              var t2 = e3.querySelector(".gvideo-wrapper");
              t2 && (e3 = t2.getAttribute("data-index"));
            }
            console.log("stopSlideVideo is deprecated, use slidePlayerPause");
            var i2 = this.getSlidePlayerInstance(e3);
            i2 && i2.playing && i2.pause();
          } }, { key: "slidePlayerPause", value: function(e3) {
            if (k(e3)) {
              var t2 = e3.querySelector(".gvideo-wrapper");
              t2 && (e3 = t2.getAttribute("data-index"));
            }
            var i2 = this.getSlidePlayerInstance(e3);
            i2 && i2.playing && i2.pause();
          } }, { key: "playSlideVideo", value: function(e3) {
            if (k(e3)) {
              var t2 = e3.querySelector(".gvideo-wrapper");
              t2 && (e3 = t2.getAttribute("data-index"));
            }
            console.log("playSlideVideo is deprecated, use slidePlayerPlay");
            var i2 = this.getSlidePlayerInstance(e3);
            i2 && !i2.playing && i2.play();
          } }, { key: "slidePlayerPlay", value: function(e3) {
            var t2;
            if (!J || (t2 = this.settings.plyr.config) !== null && t2 !== void 0 && t2.muted) {
              if (k(e3)) {
                var i2 = e3.querySelector(".gvideo-wrapper");
                i2 && (e3 = i2.getAttribute("data-index"));
              }
              var n2 = this.getSlidePlayerInstance(e3);
              n2 && !n2.playing && (n2.play(), this.settings.autofocusVideos && n2.elements.container.focus());
            }
          } }, { key: "setElements", value: function(e3) {
            var t2 = this;
            this.settings.elements = false;
            var i2 = [];
            e3 && e3.length && o(e3, function(e4, n2) {
              var s2 = new $(e4, t2, n2), o2 = s2.getConfig(), r2 = l({}, o2);
              r2.slideConfig = o2, r2.instance = s2, r2.index = n2, i2.push(r2);
            }), this.elements = i2, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (o(this.elements, function() {
              var e4 = m(t2.settings.slideHTML);
              t2.slidesContainer.appendChild(e4);
            }), this.showSlide(0, true)));
          } }, { key: "getElementIndex", value: function(e3) {
            var t2 = false;
            return o(this.elements, function(i2, n2) {
              if (O(i2, "node") && i2.node == e3)
                return t2 = n2, true;
            }), t2;
          } }, { key: "getElements", value: function() {
            var e3 = this, t2 = [];
            this.elements = this.elements ? this.elements : [], !I(this.settings.elements) && E(this.settings.elements) && this.settings.elements.length && o(this.settings.elements, function(i3, n2) {
              var s2 = new $(i3, e3, n2), o2 = s2.getConfig(), r2 = l({}, o2);
              r2.node = false, r2.index = n2, r2.instance = s2, r2.slideConfig = o2, t2.push(r2);
            });
            var i2 = false;
            return this.getSelector() && (i2 = document.querySelectorAll(this.getSelector())), i2 ? (o(i2, function(i3, n2) {
              var s2 = new $(i3, e3, n2), o2 = s2.getConfig(), r2 = l({}, o2);
              r2.node = i3, r2.index = n2, r2.instance = s2, r2.slideConfig = o2, r2.gallery = i3.getAttribute("data-gallery"), t2.push(r2);
            }), t2) : t2;
          } }, { key: "getGalleryElements", value: function(e3, t2) {
            return e3.filter(function(e4) {
              return e4.gallery == t2;
            });
          } }, { key: "getSelector", value: function() {
            return !this.settings.elements && (this.settings.selector && this.settings.selector.substring(0, 5) == "data-" ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
          } }, { key: "getActiveSlide", value: function() {
            return this.slidesContainer.querySelectorAll(".gslide")[this.index];
          } }, { key: "getActiveSlideIndex", value: function() {
            return this.index;
          } }, { key: "getAnimationClasses", value: function() {
            var e3 = [];
            for (var t2 in this.settings.cssEfects)
              if (this.settings.cssEfects.hasOwnProperty(t2)) {
                var i2 = this.settings.cssEfects[t2];
                e3.push("g".concat(i2.in)), e3.push("g".concat(i2.out));
              }
            return e3.join(" ");
          } }, { key: "build", value: function() {
            var e3 = this;
            if (this.built)
              return false;
            var t2 = document.body.childNodes, i2 = [];
            o(t2, function(e4) {
              e4.parentNode == document.body && e4.nodeName.charAt(0) !== "#" && e4.hasAttribute && !e4.hasAttribute("aria-hidden") && (i2.push(e4), e4.setAttribute("aria-hidden", "true"));
            });
            var n2 = O(this.settings.svg, "next") ? this.settings.svg.next : "", s2 = O(this.settings.svg, "prev") ? this.settings.svg.prev : "", l2 = O(this.settings.svg, "close") ? this.settings.svg.close : "", r2 = this.settings.lightboxHTML;
            r2 = m(r2 = (r2 = (r2 = r2.replace(/{nextSVG}/g, n2)).replace(/{prevSVG}/g, s2)).replace(/{closeSVG}/g, l2)), document.body.appendChild(r2);
            var d2 = document.getElementById("glightbox-body");
            this.modal = d2;
            var g2 = d2.querySelector(".gclose");
            this.prevButton = d2.querySelector(".gprev"), this.nextButton = d2.querySelector(".gnext"), this.overlay = d2.querySelector(".goverlay"), this.loader = d2.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i2, this.events = {}, h(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && g2 && (this.events.close = a("click", { onElement: g2, withCallback: function(t3, i3) {
              t3.preventDefault(), e3.close();
            } })), g2 && !this.settings.closeButton && g2.parentNode.removeChild(g2), this.nextButton && (this.events.next = a("click", { onElement: this.nextButton, withCallback: function(t3, i3) {
              t3.preventDefault(), e3.nextSlide();
            } })), this.prevButton && (this.events.prev = a("click", { onElement: this.prevButton, withCallback: function(t3, i3) {
              t3.preventDefault(), e3.prevSlide();
            } })), this.settings.closeOnOutsideClick && (this.events.outClose = a("click", { onElement: d2, withCallback: function(t3, i3) {
              e3.preventOutsideClick || c(document.body, "glightbox-mobile") || u(t3.target, ".ginner-container") || u(t3.target, ".gbtn") || c(t3.target, "gnext") || c(t3.target, "gprev") || e3.close();
            } })), o(this.elements, function(t3, i3) {
              e3.slidesContainer.appendChild(t3.instance.create()), t3.slideNode = e3.slidesContainer.querySelectorAll(".gslide")[i3];
            }), K && h(document.body, "glightbox-touch"), this.events.resize = a("resize", { onElement: window, withCallback: function() {
              e3.resize();
            } }), this.built = true;
          } }, { key: "resize", value: function() {
            var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            if ((e3 = e3 || this.activeSlide) && !c(e3, "zoomed")) {
              var t2 = y(), i2 = e3.querySelector(".gvideo-wrapper"), n2 = e3.querySelector(".gslide-image"), s2 = this.slideDescription, l2 = t2.width, o2 = t2.height;
              if (l2 <= 768 ? h(document.body, "glightbox-mobile") : d(document.body, "glightbox-mobile"), i2 || n2) {
                var r2 = false;
                if (s2 && (c(s2, "description-bottom") || c(s2, "description-top")) && !c(s2, "gabsolute") && (r2 = true), n2) {
                  if (l2 <= 768)
                    n2.querySelector("img");
                  else if (r2) {
                    var a2 = s2.offsetHeight, u2 = n2.querySelector("img");
                    u2.setAttribute("style", "max-height: calc(100vh - ".concat(a2, "px)")), s2.setAttribute("style", "max-width: ".concat(u2.offsetWidth, "px;"));
                  }
                }
                if (i2) {
                  var g2 = O(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                  if (!g2) {
                    var v2 = i2.clientWidth, f2 = i2.clientHeight, p2 = v2 / f2;
                    g2 = "".concat(v2 / p2, ":").concat(f2 / p2);
                  }
                  var m2 = g2.split(":"), x2 = this.settings.videosWidth, b2 = this.settings.videosWidth, S2 = (b2 = M(x2) || x2.indexOf("px") !== -1 ? parseInt(x2) : x2.indexOf("vw") !== -1 ? l2 * parseInt(x2) / 100 : x2.indexOf("vh") !== -1 ? o2 * parseInt(x2) / 100 : x2.indexOf("%") !== -1 ? l2 * parseInt(x2) / 100 : parseInt(i2.clientWidth)) / (parseInt(m2[0]) / parseInt(m2[1]));
                  if (S2 = Math.floor(S2), r2 && (o2 -= s2.offsetHeight), b2 > l2 || S2 > o2 || o2 < S2 && l2 > b2) {
                    var w2 = i2.offsetWidth, T2 = i2.offsetHeight, C2 = o2 / T2, k2 = { width: w2 * C2, height: T2 * C2 };
                    i2.parentNode.setAttribute("style", "max-width: ".concat(k2.width, "px")), r2 && s2.setAttribute("style", "max-width: ".concat(k2.width, "px;"));
                  } else
                    i2.parentNode.style.maxWidth = "".concat(x2), r2 && s2.setAttribute("style", "max-width: ".concat(x2, ";"));
                }
              }
            }
          } }, { key: "reload", value: function() {
            this.init();
          } }, { key: "updateNavigationClasses", value: function() {
            var e3 = this.loop();
            d(this.nextButton, "disabled"), d(this.prevButton, "disabled"), this.index == 0 && this.elements.length - 1 == 0 ? (h(this.prevButton, "disabled"), h(this.nextButton, "disabled")) : this.index !== 0 || e3 ? this.index !== this.elements.length - 1 || e3 || h(this.nextButton, "disabled") : h(this.prevButton, "disabled");
          } }, { key: "loop", value: function() {
            var e3 = O(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
            return e3 = O(this.settings, "loop") ? this.settings.loop : e3, e3;
          } }, { key: "close", value: function() {
            var e3 = this;
            if (!this.lightboxOpen) {
              if (this.events) {
                for (var t2 in this.events)
                  this.events.hasOwnProperty(t2) && this.events[t2].destroy();
                this.events = null;
              }
              return false;
            }
            if (this.closing)
              return false;
            this.closing = true, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && o(this.bodyHiddenChildElms, function(e4) {
              e4.removeAttribute("aria-hidden");
            }), h(this.modal, "glightbox-closing"), g(this.overlay, this.settings.openEffect == "none" ? "none" : this.settings.cssEfects.fade.out), g(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
              if (e3.activeSlide = null, e3.prevActiveSlideIndex = null, e3.prevActiveSlide = null, e3.built = false, e3.events) {
                for (var t3 in e3.events)
                  e3.events.hasOwnProperty(t3) && e3.events[t3].destroy();
                e3.events = null;
              }
              var i2 = document.body;
              d(Q, "glightbox-open"), d(i2, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e3.modal.parentNode.removeChild(e3.modal), e3.trigger("close"), T(e3.settings.onClose) && e3.settings.onClose();
              var n2 = document.querySelector(".gcss-styles");
              n2 && n2.parentNode.removeChild(n2), e3.lightboxOpen = false, e3.closing = null;
            });
          } }, { key: "destroy", value: function() {
            this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
          } }, { key: "on", value: function(e3, t2) {
            var i2 = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
            if (!e3 || !T(t2))
              throw new TypeError("Event name and callback must be defined");
            this.apiEvents.push({ evt: e3, once: i2, callback: t2 });
          } }, { key: "once", value: function(e3, t2) {
            this.on(e3, t2, true);
          } }, { key: "trigger", value: function(e3) {
            var t2 = this, i2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n2 = [];
            o(this.apiEvents, function(t3, s2) {
              var l2 = t3.evt, o2 = t3.once, r2 = t3.callback;
              l2 == e3 && (r2(i2), o2 && n2.push(s2));
            }), n2.length && o(n2, function(e4) {
              return t2.apiEvents.splice(e4, 1);
            });
          } }, { key: "clearAllEvents", value: function() {
            this.apiEvents.splice(0, this.apiEvents.length);
          } }, { key: "version", value: function() {
            return "3.1.0";
          } }]), e2;
        }();
        return function() {
          var e2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t2 = new te(e2);
          return t2.init(), t2;
        };
      });
    }
  });

  // node_modules/sticky-js/dist/sticky.compile.js
  var require_sticky_compile = __commonJS({
    "node_modules/sticky-js/dist/sticky.compile.js"(exports2, module2) {
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor)
            descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          _defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Sticky2 = /* @__PURE__ */ function() {
        function Sticky3() {
          var selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
          var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          _classCallCheck(this, Sticky3);
          this.selector = selector;
          this.elements = [];
          this.version = "1.3.0";
          this.vp = this.getViewportSize();
          this.body = document.querySelector("body");
          this.options = {
            wrap: options.wrap || false,
            wrapWith: options.wrapWith || "<span></span>",
            marginTop: options.marginTop || 0,
            marginBottom: options.marginBottom || 0,
            stickyFor: options.stickyFor || 0,
            stickyClass: options.stickyClass || null,
            stickyContainer: options.stickyContainer || "body"
          };
          this.updateScrollTopPosition = this.updateScrollTopPosition.bind(this);
          this.updateScrollTopPosition();
          window.addEventListener("load", this.updateScrollTopPosition);
          window.addEventListener("scroll", this.updateScrollTopPosition);
          this.run();
        }
        _createClass(Sticky3, [{
          key: "run",
          value: function run() {
            var _this = this;
            var pageLoaded = setInterval(function() {
              if (document.readyState === "complete") {
                clearInterval(pageLoaded);
                var elements = document.querySelectorAll(_this.selector);
                _this.forEach(elements, function(element) {
                  return _this.renderElement(element);
                });
              }
            }, 10);
          }
        }, {
          key: "renderElement",
          value: function renderElement(element) {
            var _this2 = this;
            element.sticky = {};
            element.sticky.active = false;
            element.sticky.marginTop = parseInt(element.getAttribute("data-margin-top")) || this.options.marginTop;
            element.sticky.marginBottom = parseInt(element.getAttribute("data-margin-bottom")) || this.options.marginBottom;
            element.sticky.stickyFor = parseInt(element.getAttribute("data-sticky-for")) || this.options.stickyFor;
            element.sticky.stickyClass = element.getAttribute("data-sticky-class") || this.options.stickyClass;
            element.sticky.wrap = element.hasAttribute("data-sticky-wrap") ? true : this.options.wrap;
            element.sticky.stickyContainer = this.options.stickyContainer;
            element.sticky.container = this.getStickyContainer(element);
            element.sticky.container.rect = this.getRectangle(element.sticky.container);
            element.sticky.rect = this.getRectangle(element);
            if (element.tagName.toLowerCase() === "img") {
              element.onload = function() {
                return element.sticky.rect = _this2.getRectangle(element);
              };
            }
            if (element.sticky.wrap) {
              this.wrapElement(element);
            }
            this.activate(element);
          }
        }, {
          key: "wrapElement",
          value: function wrapElement(element) {
            element.insertAdjacentHTML("beforebegin", element.getAttribute("data-sticky-wrapWith") || this.options.wrapWith);
            element.previousSibling.appendChild(element);
          }
        }, {
          key: "activate",
          value: function activate(element) {
            if (element.sticky.rect.top + element.sticky.rect.height < element.sticky.container.rect.top + element.sticky.container.rect.height && element.sticky.stickyFor < this.vp.width && !element.sticky.active) {
              element.sticky.active = true;
            }
            if (this.elements.indexOf(element) < 0) {
              this.elements.push(element);
            }
            if (!element.sticky.resizeEvent) {
              this.initResizeEvents(element);
              element.sticky.resizeEvent = true;
            }
            if (!element.sticky.scrollEvent) {
              this.initScrollEvents(element);
              element.sticky.scrollEvent = true;
            }
            this.setPosition(element);
          }
        }, {
          key: "initResizeEvents",
          value: function initResizeEvents(element) {
            var _this3 = this;
            element.sticky.resizeListener = function() {
              return _this3.onResizeEvents(element);
            };
            window.addEventListener("resize", element.sticky.resizeListener);
          }
        }, {
          key: "destroyResizeEvents",
          value: function destroyResizeEvents(element) {
            window.removeEventListener("resize", element.sticky.resizeListener);
          }
        }, {
          key: "onResizeEvents",
          value: function onResizeEvents(element) {
            this.vp = this.getViewportSize();
            element.sticky.rect = this.getRectangle(element);
            element.sticky.container.rect = this.getRectangle(element.sticky.container);
            if (element.sticky.rect.top + element.sticky.rect.height < element.sticky.container.rect.top + element.sticky.container.rect.height && element.sticky.stickyFor < this.vp.width && !element.sticky.active) {
              element.sticky.active = true;
            } else if (element.sticky.rect.top + element.sticky.rect.height >= element.sticky.container.rect.top + element.sticky.container.rect.height || element.sticky.stickyFor >= this.vp.width && element.sticky.active) {
              element.sticky.active = false;
            }
            this.setPosition(element);
          }
        }, {
          key: "initScrollEvents",
          value: function initScrollEvents(element) {
            var _this4 = this;
            element.sticky.scrollListener = function() {
              return _this4.onScrollEvents(element);
            };
            window.addEventListener("scroll", element.sticky.scrollListener);
          }
        }, {
          key: "destroyScrollEvents",
          value: function destroyScrollEvents(element) {
            window.removeEventListener("scroll", element.sticky.scrollListener);
          }
        }, {
          key: "onScrollEvents",
          value: function onScrollEvents(element) {
            if (element.sticky && element.sticky.active) {
              this.setPosition(element);
            }
          }
        }, {
          key: "setPosition",
          value: function setPosition(element) {
            this.css(element, {
              position: "",
              width: "",
              top: "",
              left: ""
            });
            if (this.vp.height < element.sticky.rect.height || !element.sticky.active) {
              return;
            }
            if (!element.sticky.rect.width) {
              element.sticky.rect = this.getRectangle(element);
            }
            if (element.sticky.wrap) {
              this.css(element.parentNode, {
                display: "block",
                width: element.sticky.rect.width + "px",
                height: element.sticky.rect.height + "px"
              });
            }
            if (element.sticky.rect.top === 0 && element.sticky.container === this.body) {
              this.css(element, {
                position: "fixed",
                top: element.sticky.rect.top + "px",
                left: element.sticky.rect.left + "px",
                width: element.sticky.rect.width + "px"
              });
              if (element.sticky.stickyClass) {
                element.classList.add(element.sticky.stickyClass);
              }
            } else if (this.scrollTop > element.sticky.rect.top - element.sticky.marginTop) {
              this.css(element, {
                position: "fixed",
                width: element.sticky.rect.width + "px",
                left: element.sticky.rect.left + "px"
              });
              if (this.scrollTop + element.sticky.rect.height + element.sticky.marginTop > element.sticky.container.rect.top + element.sticky.container.offsetHeight - element.sticky.marginBottom) {
                if (element.sticky.stickyClass) {
                  element.classList.remove(element.sticky.stickyClass);
                }
                this.css(element, {
                  top: element.sticky.container.rect.top + element.sticky.container.offsetHeight - (this.scrollTop + element.sticky.rect.height + element.sticky.marginBottom) + "px"
                });
              } else {
                if (element.sticky.stickyClass) {
                  element.classList.add(element.sticky.stickyClass);
                }
                this.css(element, {
                  top: element.sticky.marginTop + "px"
                });
              }
            } else {
              if (element.sticky.stickyClass) {
                element.classList.remove(element.sticky.stickyClass);
              }
              this.css(element, {
                position: "",
                width: "",
                top: "",
                left: ""
              });
              if (element.sticky.wrap) {
                this.css(element.parentNode, {
                  display: "",
                  width: "",
                  height: ""
                });
              }
            }
          }
        }, {
          key: "update",
          value: function update() {
            var _this5 = this;
            this.forEach(this.elements, function(element) {
              element.sticky.rect = _this5.getRectangle(element);
              element.sticky.container.rect = _this5.getRectangle(element.sticky.container);
              _this5.activate(element);
              _this5.setPosition(element);
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this6 = this;
            window.removeEventListener("load", this.updateScrollTopPosition);
            window.removeEventListener("scroll", this.updateScrollTopPosition);
            this.forEach(this.elements, function(element) {
              _this6.destroyResizeEvents(element);
              _this6.destroyScrollEvents(element);
              delete element.sticky;
            });
          }
        }, {
          key: "getStickyContainer",
          value: function getStickyContainer(element) {
            var container = element.parentNode;
            while (!container.hasAttribute("data-sticky-container") && !container.parentNode.querySelector(element.sticky.stickyContainer) && container !== this.body) {
              container = container.parentNode;
            }
            return container;
          }
        }, {
          key: "getRectangle",
          value: function getRectangle(element) {
            this.css(element, {
              position: "",
              width: "",
              top: "",
              left: ""
            });
            var width = Math.max(element.offsetWidth, element.clientWidth, element.scrollWidth);
            var height = Math.max(element.offsetHeight, element.clientHeight, element.scrollHeight);
            var top = 0;
            var left = 0;
            do {
              top += element.offsetTop || 0;
              left += element.offsetLeft || 0;
              element = element.offsetParent;
            } while (element);
            return {
              top,
              left,
              width,
              height
            };
          }
        }, {
          key: "getViewportSize",
          value: function getViewportSize() {
            return {
              width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
              height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
            };
          }
        }, {
          key: "updateScrollTopPosition",
          value: function updateScrollTopPosition() {
            this.scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0) || 0;
          }
        }, {
          key: "forEach",
          value: function forEach2(array, callback) {
            for (var i = 0, len = array.length; i < len; i++) {
              callback(array[i]);
            }
          }
        }, {
          key: "css",
          value: function css(element, properties) {
            for (var property in properties) {
              if (properties.hasOwnProperty(property)) {
                element.style[property] = properties[property];
              }
            }
          }
        }]);
        return Sticky3;
      }();
      (function(root, factory) {
        if (typeof exports2 !== "undefined") {
          module2.exports = factory;
        } else if (typeof define === "function" && define.amd) {
          define([], function() {
            return factory;
          });
        } else {
          root.Sticky = factory;
        }
      })(exports2, Sticky2);
    }
  });

  // node_modules/sticky-js/index.js
  var require_sticky_js = __commonJS({
    "node_modules/sticky-js/index.js"(exports2, module2) {
      var Sticky2 = require_sticky_compile();
      module2.exports = Sticky2;
    }
  });

  // node_modules/object-fit-images/dist/ofi.common-js.js
  var require_ofi_common_js = __commonJS({
    "node_modules/object-fit-images/dist/ofi.common-js.js"(exports2, module2) {
      "use strict";
      var OFI = "bfred-it:object-fit-images";
      var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
      var testImg = typeof Image === "undefined" ? { style: { "object-position": 1 } } : new Image();
      var supportsObjectFit = "object-fit" in testImg.style;
      var supportsObjectPosition = "object-position" in testImg.style;
      var supportsOFI = "background-size" in testImg.style;
      var supportsCurrentSrc = typeof testImg.currentSrc === "string";
      var nativeGetAttribute = testImg.getAttribute;
      var nativeSetAttribute = testImg.setAttribute;
      var autoModeEnabled = false;
      function createPlaceholder(w, h) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
      }
      function polyfillCurrentSrc(el) {
        if (el.srcset && !supportsCurrentSrc && window.picturefill) {
          var pf = window.picturefill._;
          if (!el[pf.ns] || !el[pf.ns].evaled) {
            pf.fillImg(el, { reselect: true });
          }
          if (!el[pf.ns].curSrc) {
            el[pf.ns].supported = false;
            pf.fillImg(el, { reselect: true });
          }
          el.currentSrc = el[pf.ns].curSrc || el.src;
        }
      }
      function getStyle(el) {
        var style = getComputedStyle(el).fontFamily;
        var parsed;
        var props = {};
        while ((parsed = propRegex.exec(style)) !== null) {
          props[parsed[1]] = parsed[2];
        }
        return props;
      }
      function setPlaceholder(img, width, height) {
        var placeholder = createPlaceholder(width || 1, height || 0);
        if (nativeGetAttribute.call(img, "src") !== placeholder) {
          nativeSetAttribute.call(img, "src", placeholder);
        }
      }
      function onImageReady(img, callback) {
        if (img.naturalWidth) {
          callback(img);
        } else {
          setTimeout(onImageReady, 100, img, callback);
        }
      }
      function fixOne(el) {
        var style = getStyle(el);
        var ofi = el[OFI];
        style["object-fit"] = style["object-fit"] || "fill";
        if (!ofi.img) {
          if (style["object-fit"] === "fill") {
            return;
          }
          if (!ofi.skipTest && supportsObjectFit && !style["object-position"]) {
            return;
          }
        }
        if (!ofi.img) {
          ofi.img = new Image(el.width, el.height);
          ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
          ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;
          nativeSetAttribute.call(el, "data-ofi-src", el.src);
          if (el.srcset) {
            nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
          }
          setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
          if (el.srcset) {
            el.srcset = "";
          }
          try {
            keepSrcUsable(el);
          } catch (err) {
            if (window.console) {
              console.warn("https://bit.ly/ofi-old-browser");
            }
          }
        }
        polyfillCurrentSrc(ofi.img);
        el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
        el.style.backgroundPosition = style["object-position"] || "center";
        el.style.backgroundRepeat = "no-repeat";
        el.style.backgroundOrigin = "content-box";
        if (/scale-down/.test(style["object-fit"])) {
          onImageReady(ofi.img, function() {
            if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
              el.style.backgroundSize = "contain";
            } else {
              el.style.backgroundSize = "auto";
            }
          });
        } else {
          el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
        }
        onImageReady(ofi.img, function(img) {
          setPlaceholder(el, img.naturalWidth, img.naturalHeight);
        });
      }
      function keepSrcUsable(el) {
        var descriptors = {
          get: function get(prop) {
            return el[OFI].img[prop ? prop : "src"];
          },
          set: function set(value, prop) {
            el[OFI].img[prop ? prop : "src"] = value;
            nativeSetAttribute.call(el, "data-ofi-" + prop, value);
            fixOne(el);
            return value;
          }
        };
        Object.defineProperty(el, "src", descriptors);
        Object.defineProperty(el, "currentSrc", {
          get: function() {
            return descriptors.get("currentSrc");
          }
        });
        Object.defineProperty(el, "srcset", {
          get: function() {
            return descriptors.get("srcset");
          },
          set: function(ss) {
            return descriptors.set(ss, "srcset");
          }
        });
      }
      function hijackAttributes() {
        function getOfiImageMaybe(el, name) {
          return el[OFI] && el[OFI].img && (name === "src" || name === "srcset") ? el[OFI].img : el;
        }
        if (!supportsObjectPosition) {
          HTMLImageElement.prototype.getAttribute = function(name) {
            return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
          };
          HTMLImageElement.prototype.setAttribute = function(name, value) {
            return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
          };
        }
      }
      function fix(imgs, opts) {
        var startAutoMode = !autoModeEnabled && !imgs;
        opts = opts || {};
        imgs = imgs || "img";
        if (supportsObjectPosition && !opts.skipTest || !supportsOFI) {
          return false;
        }
        if (imgs === "img") {
          imgs = document.getElementsByTagName("img");
        } else if (typeof imgs === "string") {
          imgs = document.querySelectorAll(imgs);
        } else if (!("length" in imgs)) {
          imgs = [imgs];
        }
        for (var i = 0; i < imgs.length; i++) {
          imgs[i][OFI] = imgs[i][OFI] || {
            skipTest: opts.skipTest
          };
          fixOne(imgs[i]);
        }
        if (startAutoMode) {
          document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") {
              fix(e.target, {
                skipTest: opts.skipTest
              });
            }
          }, true);
          autoModeEnabled = true;
          imgs = "img";
        }
        if (opts.watchMQ) {
          window.addEventListener("resize", fix.bind(null, imgs, {
            skipTest: opts.skipTest
          }));
        }
      }
      fix.supportsObjectFit = supportsObjectFit;
      fix.supportsObjectPosition = supportsObjectPosition;
      hijackAttributes();
      module2.exports = fix;
    }
  });

  // assets/js/src/store/store.js
  var Store = {
    CLSEP: "-----------------------",
    theBody: null,
    theContainer: null,
    firstLoadDelay: 2e3,
    ScrollDirection: 1,
    scrolled_y: 0,
    prev_scrolled_y: 0,
    ticking: false,
    scrollbar: false,
    scrollbarstate: false,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    Accordions: [],
    Navigation: null,
    ScrollItems: [],
    ParallaxItems: [],
    MapIsLoaded: false,
    MapItems: [],
    VimeoOptions: {},
    VimeoInfos: [],
    VimeoApi: null,
    VimeoCurrent: null,
    GSEkey: "",
    GSEcx: {
      fr: "",
      en: ""
    },
    GSE: {},
    RecaptchaIsLoaded: false,
    RecaptchaIsRendered: false,
    Recaptcha: {}
  };
  var store_default = Store;

  // assets/js/src/acolyte.js
  var import_barba6 = __toModule(require_barba());

  // assets/js/src/ajax/ajax.js
  var import_barba4 = __toModule(require_barba());

  // assets/js/src/ajax/transition.js
  var import_barba = __toModule(require_barba());
  var TSpagedefault = import_barba.default.BaseTransition.extend({
    valid: function() {
      var prev = import_barba.default.HistoryManager.prevStatus();
      return prev.namespace === "pagedefault";
    },
    start: function() {
      console.log("Transition-from: pagedefault");
      Promise.all([this.newContainerLoading, this.slideOut()]).then(this.slideIn.bind(this));
    },
    slideOut: function() {
      return new Promise(function(resolve, reject) {
        window.setTimeout(function() {
          resolve();
        }, 250);
      });
    },
    slideIn: function() {
      window.scrollTo(0, 0);
      this.done();
    }
  });
  var TSmilieu = import_barba.default.BaseTransition.extend({
    valid: function() {
      var prev = import_barba.default.HistoryManager.prevStatus();
      return prev.namespace === "milieu";
    },
    start: function() {
      console.log("Transition-from: milieu");
      Promise.all([this.newContainerLoading, this.slideOut()]).then(this.slideIn.bind(this));
    },
    slideOut: function() {
      return new Promise(function(resolve, reject) {
        window.setTimeout(function() {
          resolve();
        }, 250 * 4);
      });
    },
    slideIn: function() {
      window.scrollTo(0, 0);
      this.done();
    }
  });

  // assets/js/src/navigation/navigation.js
  var import_barba2 = __toModule(require_barba());
  var Navigation = class {
    constructor(_params) {
      this.elements = __spreadValues({}, _params.elements), this.watching = null, this.states = {
        burger: false,
        compact: false,
        visibility: true,
        subnav: false
      };
      this.settings = {
        activeClass: "is-current-page"
      };
    }
    static init() {
      const siteNav = store_default.theBody.getElementsByClassName("js-siteNav")[0];
      const burger = store_default.theBody.getElementsByClassName("js-burger")[0];
      let header = store_default.theContainer.getElementsByClassName("js-header");
      let header_height = store_default.screenHeight;
      if (header.length > 0) {
        header.length > 0 ? header = header[0] : null;
        header_height = header.scrollHeight;
      }
      const params = {
        elements: {
          main: siteNav,
          burger,
          header: {
            element: header,
            height: header_height
          }
        }
      };
      const obj = new Navigation(params);
      store_default.Navigation = obj;
      obj.burgerInit();
      obj.initScrollWatcher();
      obj.createGroups();
      obj.subnavInit();
    }
    burgerInit() {
      const burger = this.elements.burger;
      burger.addEventListener("click", this.burgerToggle.bind(this));
    }
    burgerToggle() {
      const currentState = this.states.burger;
      if (currentState === false) {
        this.navigationToggle(currentState);
        return;
      }
      this.navigationToggle("close");
    }
    navigationToggle(state) {
      const currentState = state;
      const main = this.elements.main;
      const burger = this.elements.burger;
      this.states.burger = !currentState;
      if (currentState) {
        main.classList.remove("is-nav-active");
        burger.classList.remove("is-nav-active");
        return;
      }
      main.classList.add("is-nav-active");
      burger.classList.add("is-nav-active");
    }
    subnavInit() {
      const main = this.elements.main;
      const subnavsToggle = main.querySelectorAll(".js-subNavToggle");
      if (subnavsToggle.length > 0) {
        subnavsToggle.forEach((toggle) => {
          const parentLi = toggle.parentElement;
          toggle.addEventListener("click", () => {
            const currentState = this.states.subnav;
            this.states.subnav = !currentState;
            if (currentState) {
              parentLi.classList.remove("is-subnav-active");
              return;
            }
            parentLi.classList.add("is-subnav-active");
          });
        });
      }
    }
    initScrollWatcher() {
      const scroll_wrapper = this.elements.main.getElementsByClassName("js-secondary-scroll");
      if (scroll_wrapper.length > 0) {
        const group = scroll_wrapper[0].parentElement;
        const button_left = group.getElementsByClassName("js-secondary-scroll-button-left");
        const button_right = group.getElementsByClassName("js-secondary-scroll-button-right");
        scroll_wrapper[0].addEventListener("scroll", (e) => {
          const element = e.srcElement;
          const element_scroll_width = element.scrollWidth;
          const element_width = element.offsetWidth;
          const real_total_width = element_scroll_width - element_width;
          const current_scroll = element.scrollLeft;
          if (current_scroll > 50) {
            group.classList.add("has-scroll-from-left");
          } else {
            group.classList.remove("has-scroll-from-left");
          }
          if (real_total_width - 50 < current_scroll) {
            group.classList.add("has-scroll-from-right");
          } else {
            group.classList.remove("has-scroll-from-right");
          }
        });
        button_left[0].addEventListener("click", (e) => {
          const element = scroll_wrapper[0];
          const element_scroll_width = element.scrollWidth;
          const element_width = element.offsetWidth;
          const real_total_width = element_scroll_width - element_width;
          const current_scroll = element.scrollLeft;
          const x = 0;
          element.scroll(0, 0);
        });
        button_right[0].addEventListener("click", (e) => {
          const element = scroll_wrapper[0];
          const element_scroll_width = element.scrollWidth;
          const element_width = element.offsetWidth;
          const real_total_width = element_scroll_width - element_width;
          const current_scroll = element.scrollLeft;
          const x = 0;
          element.scroll(current_scroll + element_width, 0);
        });
      }
    }
    watch(y) {
      this.checkVisibility(y);
      const state = this.states.compact;
      this.states.compact = !state;
      if (y > 100) {
        this.elements.main.classList.add("is-compact");
        return;
      }
      this.elements.main.classList.remove("is-compact");
    }
    checkVisibility(y) {
      const trigger = this.elements.header.height;
      if (y > trigger) {
        this.states.visibility = false;
        this.elements.main.classList.add("is-hidden");
        store_default.theBody.classList.add("is-nav-hidden");
        return;
      }
      this.states.visibility = true;
      this.elements.main.classList.remove("is-hidden");
      store_default.theBody.classList.remove("is-nav-hidden");
    }
    createGroups() {
      let nav_groups = [];
      const raw_nav_groups = this.elements.main.querySelectorAll("ul");
      raw_nav_groups.forEach((raw_nav_group) => {
        const raw_nav_group_items = raw_nav_group.children;
        for (let i = raw_nav_group_items.length - 1; i >= 0; i--) {
          const raw_nav_group_item = raw_nav_group_items[i];
          const raw_nav_group_item_link = raw_nav_group_item.querySelector("a");
          const absolute_url = raw_nav_group_item_link.href;
          const url_object = new URL(absolute_url);
          const url_pathname = url_object.pathname;
          const url_pathname_parsed = url_pathname.replace(/\\|\//g, "");
          const obj = {
            item: raw_nav_group_item,
            link: raw_nav_group_item_link,
            url_object,
            url_pathname_parsed,
            states: {
              active: false,
              has_sub_nav: false
            }
          };
          nav_groups.push(obj);
        }
      });
      this.watching = nav_groups;
    }
    setActiveLink() {
      const activeClass = this.settings.activeClass;
      this.watching.forEach((group) => {
        group.states.active = false;
        group.item.classList.remove(activeClass);
      });
      const current_url = window.location.pathname;
      const current_url_parsed = current_url.replace(/\\|\//g, "");
      this.watching.forEach((group) => {
        const item = group.item;
        const parsed_url = group.url_pathname_parsed;
        if (current_url_parsed) {
          const match = current_url_parsed.includes(parsed_url);
          if (match) {
            item.classList.add(activeClass);
            group.states.active = true;
          }
        }
      });
    }
    static checkRedirect() {
      let redirect = store_default.theContainer.getElementsByClassName("js-redirect");
      if (redirect.length > 0) {
        redirect = redirect[0];
        const redirectFrom = redirect.dataset.redirectFrom;
        const redirectTo = redirect.dataset.redirectTo;
        const finalRedirect = `${redirectTo}/`;
        import_barba2.default.Pjax.goTo(finalRedirect);
      }
    }
  };

  // assets/js/src/lightbox/lightbox.js
  var import_glightbox = __toModule(require_glightbox_min());
  var Lightbox = class {
    constructor() {
    }
    static setup() {
      (0, import_glightbox.default)({ selector: ".js-lightbox-video" });
      let gallery = null;
      const images = store_default.theContainer.getElementsByClassName("js-lightbox-images-item");
      if (images.length > 0) {
        const button = store_default.theContainer.getElementsByClassName("js-lightbox-button")[0];
        let elements = [];
        for (let i = images.length - 1; i >= 0; i--) {
          const img = images[i];
          const obj = {
            href: img.dataset.href,
            type: img.dataset.type
          };
          elements.push(obj);
        }
        gallery = (0, import_glightbox.default)({
          elements: [...elements]
        });
        button.addEventListener("click", gallery.open.bind(gallery));
      }
      const plans = store_default.theContainer.getElementsByClassName("js-lightbox-plan");
      const plans_button = store_default.theContainer.getElementsByClassName("js-lightbox-plan-button");
      let plan_gallery = null;
      if (plans.length > 0 && plans_button.length > 0) {
        let elements = [];
        for (let i = 0; i < plans.length; i++) {
          const plan = plans[i];
          const obj = {
            href: plan.dataset.href,
            type: plan.dataset.type
          };
          elements.push(obj);
        }
        plan_gallery = (0, import_glightbox.default)({
          elements: [...elements]
        });
        for (let i = 0; i < plans_button.length; i++) {
          const button = plans_button[i];
          button.addEventListener("click", () => {
            const index = parseInt(button.dataset.index);
            plan_gallery.openAt(index);
          });
        }
      }
      (0, import_glightbox.default)({ selector: ".js-lightbox-iframe" });
    }
  };

  // node_modules/slim-select/dist/slimselect.min.mjs
  var exports = {};
  !function(e, t) {
    typeof exports == "object" && typeof module == "object" ? module.exports = t() : typeof define == "function" && define.amd ? define([], t) : typeof exports == "object" ? exports.SlimSelect = t() : e.SlimSelect = t();
  }(window, function() {
    return n = {}, s.m = i = [function(e, t, i2) {
      "use strict";
      function n2(e2, t2) {
        t2 = t2 || { bubbles: false, cancelable: false, detail: void 0 };
        var i3 = document.createEvent("CustomEvent");
        return i3.initCustomEvent(e2, t2.bubbles, t2.cancelable, t2.detail), i3;
      }
      t.__esModule = true, t.kebabCase = t.highlight = t.isValueInArrayOfObjects = t.debounce = t.putContent = t.ensureElementInView = t.hasClassInTree = void 0, t.hasClassInTree = function(e2, t2) {
        function n3(e3, t3) {
          return t3 && e3 && e3.classList && e3.classList.contains(t3) ? e3 : null;
        }
        return n3(e2, t2) || function e3(t3, i3) {
          return t3 && t3 !== document ? n3(t3, i3) ? t3 : e3(t3.parentNode, i3) : null;
        }(e2, t2);
      }, t.ensureElementInView = function(e2, t2) {
        var i3 = e2.scrollTop + e2.offsetTop, n3 = i3 + e2.clientHeight, s2 = t2.offsetTop, t2 = s2 + t2.clientHeight;
        s2 < i3 ? e2.scrollTop -= i3 - s2 : n3 < t2 && (e2.scrollTop += t2 - n3);
      }, t.putContent = function(e2, t2, i3) {
        var n3 = e2.offsetHeight, s2 = e2.getBoundingClientRect(), e2 = i3 ? s2.top : s2.top - n3, n3 = i3 ? s2.bottom : s2.bottom + n3;
        return e2 <= 0 ? "below" : n3 >= window.innerHeight ? "above" : i3 ? t2 : "below";
      }, t.debounce = function(s2, a, o) {
        var l;
        return a === void 0 && (a = 100), o === void 0 && (o = false), function() {
          for (var e2 = [], t2 = 0; t2 < arguments.length; t2++)
            e2[t2] = arguments[t2];
          var i3 = self, n3 = o && !l;
          clearTimeout(l), l = setTimeout(function() {
            l = null, o || s2.apply(i3, e2);
          }, a), n3 && s2.apply(i3, e2);
        };
      }, t.isValueInArrayOfObjects = function(e2, t2, i3) {
        if (!Array.isArray(e2))
          return e2[t2] === i3;
        for (var n3 = 0, s2 = e2; n3 < s2.length; n3++) {
          var a = s2[n3];
          if (a && a[t2] && a[t2] === i3)
            return true;
        }
        return false;
      }, t.highlight = function(e2, t2, i3) {
        var n3 = e2, s2 = new RegExp("(" + t2.trim() + ")(?![^<]*>[^<>]*</)", "i");
        if (!e2.match(s2))
          return e2;
        var a = e2.match(s2).index, t2 = a + e2.match(s2)[0].toString().length, t2 = e2.substring(a, t2);
        return n3 = n3.replace(s2, '<mark class="'.concat(i3, '">').concat(t2, "</mark>"));
      }, t.kebabCase = function(e2) {
        var t2 = e2.replace(/[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g, function(e3) {
          return "-" + e3.toLowerCase();
        });
        return e2[0] === e2[0].toUpperCase() ? t2.substring(1) : t2;
      }, typeof (t = window).CustomEvent != "function" && (n2.prototype = t.Event.prototype, t.CustomEvent = n2);
    }, function(e, t, i2) {
      "use strict";
      t.__esModule = true, t.validateOption = t.validateData = t.Data = void 0;
      var n2 = (s2.prototype.newOption = function(e2) {
        return { id: e2.id || String(Math.floor(1e8 * Math.random())), value: e2.value || "", text: e2.text || "", innerHTML: e2.innerHTML || "", selected: e2.selected || false, display: e2.display === void 0 || e2.display, disabled: e2.disabled || false, placeholder: e2.placeholder || false, class: e2.class || void 0, data: e2.data || {}, mandatory: e2.mandatory || false };
      }, s2.prototype.add = function(e2) {
        this.data.push({ id: String(Math.floor(1e8 * Math.random())), value: e2.value, text: e2.text, innerHTML: "", selected: false, display: true, disabled: false, placeholder: false, class: void 0, mandatory: e2.mandatory, data: {} });
      }, s2.prototype.parseSelectData = function() {
        this.data = [];
        for (var e2 = 0, t2 = this.main.select.element.childNodes; e2 < t2.length; e2++) {
          var i3 = t2[e2];
          if (i3.nodeName === "OPTGROUP") {
            for (var n3 = { label: i3.label, options: [] }, s3 = 0, a = i3.childNodes; s3 < a.length; s3++) {
              var o, l = a[s3];
              l.nodeName === "OPTION" && (o = this.pullOptionData(l), n3.options.push(o), o.placeholder && o.text.trim() !== "" && (this.main.config.placeholderText = o.text));
            }
            this.data.push(n3);
          } else
            i3.nodeName === "OPTION" && (o = this.pullOptionData(i3), this.data.push(o), o.placeholder && o.text.trim() !== "" && (this.main.config.placeholderText = o.text));
        }
      }, s2.prototype.pullOptionData = function(e2) {
        return { id: !!e2.dataset && e2.dataset.id || String(Math.floor(1e8 * Math.random())), value: e2.value, text: e2.text, innerHTML: e2.innerHTML, selected: e2.selected, disabled: e2.disabled, placeholder: e2.dataset.placeholder === "true", class: e2.className, style: e2.style.cssText, data: e2.dataset, mandatory: !!e2.dataset && e2.dataset.mandatory === "true" };
      }, s2.prototype.setSelectedFromSelect = function() {
        if (this.main.config.isMultiple) {
          for (var e2 = [], t2 = 0, i3 = this.main.select.element.options; t2 < i3.length; t2++) {
            var n3 = i3[t2];
            !n3.selected || (n3 = this.getObjectFromData(n3.value, "value")) && n3.id && e2.push(n3.id);
          }
          this.setSelected(e2, "id");
        } else {
          var s3 = this.main.select.element;
          s3.selectedIndex !== -1 && (s3 = s3.options[s3.selectedIndex].value, this.setSelected(s3, "value"));
        }
      }, s2.prototype.setSelected = function(e2, t2) {
        t2 === void 0 && (t2 = "id");
        for (var i3 = 0, n3 = this.data; i3 < n3.length; i3++) {
          var s3 = n3[i3];
          if (s3.hasOwnProperty("label")) {
            if (s3.hasOwnProperty("options")) {
              var a = s3.options;
              if (a)
                for (var o = 0, l = a; o < l.length; o++) {
                  var r2 = l[o];
                  r2.placeholder || (r2.selected = this.shouldBeSelected(r2, e2, t2));
                }
            }
          } else
            s3.selected = this.shouldBeSelected(s3, e2, t2);
        }
      }, s2.prototype.shouldBeSelected = function(e2, t2, i3) {
        if (i3 === void 0 && (i3 = "id"), Array.isArray(t2))
          for (var n3 = 0, s3 = t2; n3 < s3.length; n3++) {
            var a = s3[n3];
            if (i3 in e2 && String(e2[i3]) === String(a))
              return true;
          }
        else if (i3 in e2 && String(e2[i3]) === String(t2))
          return true;
        return false;
      }, s2.prototype.getSelected = function() {
        for (var e2 = { text: "", placeholder: this.main.config.placeholderText }, t2 = [], i3 = 0, n3 = this.data; i3 < n3.length; i3++) {
          var s3 = n3[i3];
          if (s3.hasOwnProperty("label")) {
            if (s3.hasOwnProperty("options")) {
              var a = s3.options;
              if (a)
                for (var o = 0, l = a; o < l.length; o++) {
                  var r2 = l[o];
                  r2.selected && (this.main.config.isMultiple ? t2.push(r2) : e2 = r2);
                }
            }
          } else
            s3.selected && (this.main.config.isMultiple ? t2.push(s3) : e2 = s3);
        }
        return this.main.config.isMultiple ? t2 : e2;
      }, s2.prototype.addToSelected = function(e2, t2) {
        if (t2 === void 0 && (t2 = "id"), this.main.config.isMultiple) {
          var i3 = [], n3 = this.getSelected();
          if (Array.isArray(n3))
            for (var s3 = 0, a = n3; s3 < a.length; s3++) {
              var o = a[s3];
              i3.push(o[t2]);
            }
          i3.push(e2), this.setSelected(i3, t2);
        }
      }, s2.prototype.removeFromSelected = function(e2, t2) {
        if (t2 === void 0 && (t2 = "id"), this.main.config.isMultiple) {
          for (var i3 = [], n3 = 0, s3 = this.getSelected(); n3 < s3.length; n3++) {
            var a = s3[n3];
            String(a[t2]) !== String(e2) && i3.push(a[t2]);
          }
          this.setSelected(i3, t2);
        }
      }, s2.prototype.onDataChange = function() {
        this.main.onChange && this.isOnChangeEnabled && this.main.onChange(JSON.parse(JSON.stringify(this.getSelected())));
      }, s2.prototype.getObjectFromData = function(e2, t2) {
        t2 === void 0 && (t2 = "id");
        for (var i3 = 0, n3 = this.data; i3 < n3.length; i3++) {
          var s3 = n3[i3];
          if (t2 in s3 && String(s3[t2]) === String(e2))
            return s3;
          if (s3.hasOwnProperty("options")) {
            if (s3.options)
              for (var a = 0, o = s3.options; a < o.length; a++) {
                var l = o[a];
                if (String(l[t2]) === String(e2))
                  return l;
              }
          }
        }
        return null;
      }, s2.prototype.search = function(n3) {
        var s3, e2;
        (this.searchValue = n3).trim() !== "" ? (s3 = this.main.config.searchFilter, e2 = this.data.slice(0), n3 = n3.trim(), e2 = e2.map(function(e3) {
          if (e3.hasOwnProperty("options")) {
            var t2 = e3, i3 = [];
            if ((i3 = t2.options ? t2.options.filter(function(e4) {
              return s3(e4, n3);
            }) : i3).length !== 0) {
              t2 = Object.assign({}, t2);
              return t2.options = i3, t2;
            }
          }
          if (e3.hasOwnProperty("text") && s3(e3, n3))
            return e3;
          return null;
        }), this.filtered = e2.filter(function(e3) {
          return e3;
        })) : this.filtered = null;
      }, s2);
      function s2(e2) {
        this.contentOpen = false, this.contentPosition = "below", this.isOnChangeEnabled = true, this.main = e2.main, this.searchValue = "", this.data = [], this.filtered = null, this.parseSelectData(), this.setSelectedFromSelect();
      }
      function r(e2) {
        return e2.text !== void 0 || (console.error("Data object option must have at least have a text value. Check object: " + JSON.stringify(e2)), false);
      }
      t.Data = n2, t.validateData = function(e2) {
        if (!e2)
          return console.error("Data must be an array of objects"), false;
        for (var t2 = 0, i3 = 0, n3 = e2; i3 < n3.length; i3++) {
          var s3 = n3[i3];
          if (s3.hasOwnProperty("label")) {
            if (s3.hasOwnProperty("options")) {
              var a = s3.options;
              if (a)
                for (var o = 0, l = a; o < l.length; o++)
                  r(l[o]) || t2++;
            }
          } else
            r(s3) || t2++;
        }
        return t2 === 0;
      }, t.validateOption = r;
    }, function(e, t, i2) {
      "use strict";
      t.__esModule = true;
      var n2 = i2(3), s2 = i2(4), a = i2(5), r = i2(1), o = i2(0), i2 = (l.prototype.validate = function(e2) {
        e2 = typeof e2.select == "string" ? document.querySelector(e2.select) : e2.select;
        if (!e2)
          throw new Error("Could not find select element");
        if (e2.tagName !== "SELECT")
          throw new Error("Element isnt of type select");
        return e2;
      }, l.prototype.selected = function() {
        if (this.config.isMultiple) {
          for (var e2 = [], t2 = 0, i3 = s3 = this.data.getSelected(); t2 < i3.length; t2++) {
            var n3 = i3[t2];
            e2.push(n3.value);
          }
          return e2;
        }
        var s3;
        return (s3 = this.data.getSelected()) ? s3.value : "";
      }, l.prototype.set = function(e2, t2, i3, n3) {
        t2 === void 0 && (t2 = "value"), i3 === void 0 && (i3 = true), n3 === void 0 && (n3 = true), this.config.isMultiple && !Array.isArray(e2) ? this.data.addToSelected(e2, t2) : this.data.setSelected(e2, t2), this.select.setValue(), this.data.onDataChange(), this.render(), (i3 = this.config.hideSelectedOption && this.config.isMultiple && this.data.getSelected().length === this.data.data.length ? true : i3) && this.close();
      }, l.prototype.setSelected = function(e2, t2, i3, n3) {
        this.set(e2, t2 = t2 === void 0 ? "value" : t2, i3 = i3 === void 0 ? true : i3, n3 = n3 === void 0 ? true : n3);
      }, l.prototype.setData = function(e2) {
        if ((0, r.validateData)(e2)) {
          for (var t2 = JSON.parse(JSON.stringify(e2)), i3 = this.data.getSelected(), n3 = 0; n3 < t2.length; n3++)
            t2[n3].value || t2[n3].placeholder || (t2[n3].value = t2[n3].text);
          if (this.config.isAjax && i3)
            if (this.config.isMultiple)
              for (var s3 = 0, a2 = i3.reverse(); s3 < a2.length; s3++) {
                var o2 = a2[s3];
                t2.unshift(o2);
              }
            else {
              t2.unshift(i3);
              for (n3 = 0; n3 < t2.length; n3++)
                t2[n3].placeholder || t2[n3].value !== i3.value || t2[n3].text !== i3.text || t2.splice(n3, 1);
              for (var l2 = false, n3 = 0; n3 < t2.length; n3++)
                t2[n3].placeholder && (l2 = true);
              l2 || t2.unshift({ text: "", placeholder: true });
            }
          this.select.create(t2), this.data.parseSelectData(), this.data.setSelectedFromSelect();
        } else
          console.error("Validation problem on: #" + this.select.element.id);
      }, l.prototype.addData = function(e2) {
        (0, r.validateData)([e2]) ? (this.data.add(this.data.newOption(e2)), this.select.create(this.data.data), this.data.parseSelectData(), this.data.setSelectedFromSelect(), this.render()) : console.error("Validation problem on: #" + this.select.element.id);
      }, l.prototype.open = function() {
        var e2, t2 = this;
        this.config.isEnabled && (this.data.contentOpen || this.config.hideSelectedOption && this.config.isMultiple && this.data.getSelected().length === this.data.data.length || (this.beforeOpen && this.beforeOpen(), this.config.isMultiple && this.slim.multiSelected ? this.slim.multiSelected.plus.classList.add("ss-cross") : this.slim.singleSelected && (this.slim.singleSelected.arrowIcon.arrow.classList.remove("arrow-down"), this.slim.singleSelected.arrowIcon.arrow.classList.add("arrow-up")), this.slim[this.config.isMultiple ? "multiSelected" : "singleSelected"].container.classList.add(this.data.contentPosition === "above" ? this.config.openAbove : this.config.openBelow), this.config.addToBody && (e2 = this.slim.container.getBoundingClientRect(), this.slim.content.style.top = e2.top + e2.height + window.scrollY + "px", this.slim.content.style.left = e2.left + window.scrollX + "px", this.slim.content.style.width = e2.width + "px"), this.slim.content.classList.add(this.config.open), this.config.showContent.toLowerCase() === "up" || this.config.showContent.toLowerCase() !== "down" && (0, o.putContent)(this.slim.content, this.data.contentPosition, this.data.contentOpen) === "above" ? this.moveContentAbove() : this.moveContentBelow(), this.config.isMultiple || (e2 = this.data.getSelected()) && (e2 = e2.id, (e2 = this.slim.list.querySelector('[data-id="' + e2 + '"]')) && (0, o.ensureElementInView)(this.slim.list, e2)), setTimeout(function() {
          t2.data.contentOpen = true, t2.config.searchFocus && t2.slim.search.input.focus(), t2.afterOpen && t2.afterOpen();
        }, this.config.timeoutDelay)));
      }, l.prototype.close = function() {
        var e2 = this;
        this.data.contentOpen && (this.beforeClose && this.beforeClose(), this.config.isMultiple && this.slim.multiSelected ? (this.slim.multiSelected.container.classList.remove(this.config.openAbove), this.slim.multiSelected.container.classList.remove(this.config.openBelow), this.slim.multiSelected.plus.classList.remove("ss-cross")) : this.slim.singleSelected && (this.slim.singleSelected.container.classList.remove(this.config.openAbove), this.slim.singleSelected.container.classList.remove(this.config.openBelow), this.slim.singleSelected.arrowIcon.arrow.classList.add("arrow-down"), this.slim.singleSelected.arrowIcon.arrow.classList.remove("arrow-up")), this.slim.content.classList.remove(this.config.open), this.data.contentOpen = false, this.search(""), setTimeout(function() {
          e2.slim.content.removeAttribute("style"), e2.data.contentPosition = "below", e2.config.isMultiple && e2.slim.multiSelected ? (e2.slim.multiSelected.container.classList.remove(e2.config.openAbove), e2.slim.multiSelected.container.classList.remove(e2.config.openBelow)) : e2.slim.singleSelected && (e2.slim.singleSelected.container.classList.remove(e2.config.openAbove), e2.slim.singleSelected.container.classList.remove(e2.config.openBelow)), e2.slim.search.input.blur(), e2.afterClose && e2.afterClose();
        }, this.config.timeoutDelay));
      }, l.prototype.moveContentAbove = function() {
        var e2 = 0;
        this.config.isMultiple && this.slim.multiSelected ? e2 = this.slim.multiSelected.container.offsetHeight : this.slim.singleSelected && (e2 = this.slim.singleSelected.container.offsetHeight);
        var t2 = e2 + this.slim.content.offsetHeight - 1;
        this.slim.content.style.margin = "-" + t2 + "px 0 0 0", this.slim.content.style.height = t2 - e2 + 1 + "px", this.slim.content.style.transformOrigin = "center bottom", this.data.contentPosition = "above", this.config.isMultiple && this.slim.multiSelected ? (this.slim.multiSelected.container.classList.remove(this.config.openBelow), this.slim.multiSelected.container.classList.add(this.config.openAbove)) : this.slim.singleSelected && (this.slim.singleSelected.container.classList.remove(this.config.openBelow), this.slim.singleSelected.container.classList.add(this.config.openAbove));
      }, l.prototype.moveContentBelow = function() {
        this.data.contentPosition = "below", this.config.isMultiple && this.slim.multiSelected ? (this.slim.multiSelected.container.classList.remove(this.config.openAbove), this.slim.multiSelected.container.classList.add(this.config.openBelow)) : this.slim.singleSelected && (this.slim.singleSelected.container.classList.remove(this.config.openAbove), this.slim.singleSelected.container.classList.add(this.config.openBelow));
      }, l.prototype.enable = function() {
        this.config.isEnabled = true, this.config.isMultiple && this.slim.multiSelected ? this.slim.multiSelected.container.classList.remove(this.config.disabled) : this.slim.singleSelected && this.slim.singleSelected.container.classList.remove(this.config.disabled), this.select.triggerMutationObserver = false, this.select.element.disabled = false, this.slim.search.input.disabled = false, this.select.triggerMutationObserver = true;
      }, l.prototype.disable = function() {
        this.config.isEnabled = false, this.config.isMultiple && this.slim.multiSelected ? this.slim.multiSelected.container.classList.add(this.config.disabled) : this.slim.singleSelected && this.slim.singleSelected.container.classList.add(this.config.disabled), this.select.triggerMutationObserver = false, this.select.element.disabled = true, this.slim.search.input.disabled = true, this.select.triggerMutationObserver = true;
      }, l.prototype.search = function(t2) {
        var i3;
        this.data.searchValue !== t2 && (this.slim.search.input.value = t2, this.config.isAjax ? ((i3 = this).config.isSearching = true, this.render(), this.ajax && this.ajax(t2, function(e2) {
          i3.config.isSearching = false, Array.isArray(e2) ? (e2.unshift({ text: "", placeholder: true }), i3.setData(e2), i3.data.search(t2), i3.render()) : typeof e2 == "string" ? i3.slim.options(e2) : i3.render();
        })) : (this.data.search(t2), this.render()));
      }, l.prototype.setSearchText = function(e2) {
        this.config.searchText = e2;
      }, l.prototype.render = function() {
        this.config.isMultiple ? this.slim.values() : (this.slim.placeholder(), this.slim.deselect()), this.slim.options();
      }, l.prototype.destroy = function(e2) {
        var t2 = (e2 = e2 === void 0 ? null : e2) ? document.querySelector("." + e2 + ".ss-main") : this.slim.container, i3 = e2 ? document.querySelector("[data-ssid=".concat(e2, "]")) : this.select.element;
        t2 && i3 && (document.removeEventListener("click", this.documentClick), this.config.showContent === "auto" && window.removeEventListener("scroll", this.windowScroll, false), i3.style.display = "", delete i3.dataset.ssid, i3.slim = null, t2.parentElement && t2.parentElement.removeChild(t2), !this.config.addToBody || (e2 = e2 ? document.querySelector("." + e2 + ".ss-content") : this.slim.content) && document.body.removeChild(e2));
      }, l);
      function l(e2) {
        var t2 = this;
        this.ajax = null, this.addable = null, this.beforeOnChange = null, this.onChange = null, this.beforeOpen = null, this.afterOpen = null, this.beforeClose = null, this.afterClose = null, this.windowScroll = (0, o.debounce)(function(e3) {
          t2.data.contentOpen && ((0, o.putContent)(t2.slim.content, t2.data.contentPosition, t2.data.contentOpen) === "above" ? t2.moveContentAbove() : t2.moveContentBelow());
        }), this.documentClick = function(e3) {
          e3.target && !(0, o.hasClassInTree)(e3.target, t2.config.id) && t2.close();
        };
        var i3 = this.validate(e2);
        i3.dataset.ssid && this.destroy(i3.dataset.ssid), e2.ajax && (this.ajax = e2.ajax), e2.addable && (this.addable = e2.addable), this.config = new n2.Config({ select: i3, isAjax: !!e2.ajax, showSearch: e2.showSearch, searchPlaceholder: e2.searchPlaceholder, searchText: e2.searchText, searchingText: e2.searchingText, searchFocus: e2.searchFocus, searchHighlight: e2.searchHighlight, searchFilter: e2.searchFilter, closeOnSelect: e2.closeOnSelect, showContent: e2.showContent, placeholderText: e2.placeholder, allowDeselect: e2.allowDeselect, allowDeselectOption: e2.allowDeselectOption, hideSelectedOption: e2.hideSelectedOption, deselectLabel: e2.deselectLabel, isEnabled: e2.isEnabled, valuesUseText: e2.valuesUseText, showOptionTooltips: e2.showOptionTooltips, selectByGroup: e2.selectByGroup, limit: e2.limit, timeoutDelay: e2.timeoutDelay, addToBody: e2.addToBody }), this.select = new s2.Select({ select: i3, main: this }), this.data = new r.Data({ main: this }), this.slim = new a.Slim({ main: this }), this.select.element.parentNode && this.select.element.parentNode.insertBefore(this.slim.container, this.select.element.nextSibling), e2.data ? this.setData(e2.data) : this.render(), document.addEventListener("click", this.documentClick), this.config.showContent === "auto" && window.addEventListener("scroll", this.windowScroll, false), e2.beforeOnChange && (this.beforeOnChange = e2.beforeOnChange), e2.onChange && (this.onChange = e2.onChange), e2.beforeOpen && (this.beforeOpen = e2.beforeOpen), e2.afterOpen && (this.afterOpen = e2.afterOpen), e2.beforeClose && (this.beforeClose = e2.beforeClose), e2.afterClose && (this.afterClose = e2.afterClose), this.config.isEnabled || this.disable();
      }
      t.default = i2;
    }, function(e, t, i2) {
      "use strict";
      t.__esModule = true, t.Config = void 0;
      var n2 = (s2.prototype.searchFilter = function(e2, t2) {
        return e2.text.toLowerCase().indexOf(t2.toLowerCase()) !== -1;
      }, s2);
      function s2(e2) {
        this.id = "", this.isMultiple = false, this.isAjax = false, this.isSearching = false, this.showSearch = true, this.searchFocus = true, this.searchHighlight = false, this.closeOnSelect = true, this.showContent = "auto", this.searchPlaceholder = "Search", this.searchText = "No Results", this.searchingText = "Searching...", this.placeholderText = "Select Value", this.allowDeselect = false, this.allowDeselectOption = false, this.hideSelectedOption = false, this.deselectLabel = "x", this.isEnabled = true, this.valuesUseText = false, this.showOptionTooltips = false, this.selectByGroup = false, this.limit = 0, this.timeoutDelay = 200, this.addToBody = false, this.main = "ss-main", this.singleSelected = "ss-single-selected", this.arrow = "ss-arrow", this.multiSelected = "ss-multi-selected", this.add = "ss-add", this.plus = "ss-plus", this.values = "ss-values", this.value = "ss-value", this.valueText = "ss-value-text", this.valueDelete = "ss-value-delete", this.content = "ss-content", this.open = "ss-open", this.openAbove = "ss-open-above", this.openBelow = "ss-open-below", this.search = "ss-search", this.searchHighlighter = "ss-search-highlight", this.addable = "ss-addable", this.list = "ss-list", this.optgroup = "ss-optgroup", this.optgroupLabel = "ss-optgroup-label", this.optgroupLabelSelectable = "ss-optgroup-label-selectable", this.option = "ss-option", this.optionSelected = "ss-option-selected", this.highlighted = "ss-highlighted", this.disabled = "ss-disabled", this.hide = "ss-hide", this.id = "ss-" + Math.floor(1e5 * Math.random()), this.style = e2.select.style.cssText, this.class = e2.select.className.split(" "), this.isMultiple = e2.select.multiple, this.isAjax = e2.isAjax, this.showSearch = e2.showSearch !== false, this.searchFocus = e2.searchFocus !== false, this.searchHighlight = e2.searchHighlight === true, this.closeOnSelect = e2.closeOnSelect !== false, e2.showContent && (this.showContent = e2.showContent), this.isEnabled = e2.isEnabled !== false, e2.searchPlaceholder && (this.searchPlaceholder = e2.searchPlaceholder), e2.searchText && (this.searchText = e2.searchText), e2.searchingText && (this.searchingText = e2.searchingText), e2.placeholderText && (this.placeholderText = e2.placeholderText), this.allowDeselect = e2.allowDeselect === true, this.allowDeselectOption = e2.allowDeselectOption === true, this.hideSelectedOption = e2.hideSelectedOption === true, e2.deselectLabel && (this.deselectLabel = e2.deselectLabel), e2.valuesUseText && (this.valuesUseText = e2.valuesUseText), e2.showOptionTooltips && (this.showOptionTooltips = e2.showOptionTooltips), e2.selectByGroup && (this.selectByGroup = e2.selectByGroup), e2.limit && (this.limit = e2.limit), e2.searchFilter && (this.searchFilter = e2.searchFilter), e2.timeoutDelay != null && (this.timeoutDelay = e2.timeoutDelay), this.addToBody = e2.addToBody === true;
      }
      t.Config = n2;
    }, function(e, t, i2) {
      "use strict";
      t.__esModule = true, t.Select = void 0;
      var n2 = i2(0), i2 = (s2.prototype.setValue = function() {
        if (this.main.data.getSelected()) {
          if (this.main.config.isMultiple)
            for (var e2 = this.main.data.getSelected(), t2 = 0, i3 = this.element.options; t2 < i3.length; t2++) {
              var n3 = i3[t2];
              n3.selected = false;
              for (var s3 = 0, a = e2; s3 < a.length; s3++)
                a[s3].value === n3.value && (n3.selected = true);
            }
          else {
            e2 = this.main.data.getSelected();
            this.element.value = e2 ? e2.value : "";
          }
          this.main.data.isOnChangeEnabled = false, this.element.dispatchEvent(new CustomEvent("change", { bubbles: true })), this.main.data.isOnChangeEnabled = true;
        }
      }, s2.prototype.addAttributes = function() {
        this.element.tabIndex = -1, this.element.style.display = "none", this.element.dataset.ssid = this.main.config.id, this.element.setAttribute("aria-hidden", "true");
      }, s2.prototype.addEventListeners = function() {
        var t2 = this;
        this.element.addEventListener("change", function(e2) {
          t2.main.data.setSelectedFromSelect(), t2.main.render();
        });
      }, s2.prototype.addMutationObserver = function() {
        var t2 = this;
        this.main.config.isAjax || (this.mutationObserver = new MutationObserver(function(e2) {
          t2.triggerMutationObserver && (t2.main.data.parseSelectData(), t2.main.data.setSelectedFromSelect(), t2.main.render(), e2.forEach(function(e3) {
            e3.attributeName === "class" && t2.main.slim.updateContainerDivClass(t2.main.slim.container);
          }));
        }), this.observeMutationObserver());
      }, s2.prototype.observeMutationObserver = function() {
        this.mutationObserver && this.mutationObserver.observe(this.element, { attributes: true, childList: true, characterData: true });
      }, s2.prototype.disconnectMutationObserver = function() {
        this.mutationObserver && this.mutationObserver.disconnect();
      }, s2.prototype.create = function(e2) {
        this.element.innerHTML = "";
        for (var t2 = 0, i3 = e2; t2 < i3.length; t2++) {
          var n3 = i3[t2];
          if (n3.hasOwnProperty("options")) {
            var s3 = n3, a = document.createElement("optgroup");
            if (a.label = s3.label, s3.options)
              for (var o = 0, l = s3.options; o < l.length; o++) {
                var r = l[o];
                a.appendChild(this.createOption(r));
              }
            this.element.appendChild(a);
          } else
            this.element.appendChild(this.createOption(n3));
        }
      }, s2.prototype.createOption = function(t2) {
        var i3 = document.createElement("option");
        return i3.value = t2.value !== "" ? t2.value : t2.text, i3.innerHTML = t2.innerHTML || t2.text, t2.selected && (i3.selected = t2.selected), t2.display === false && (i3.style.display = "none"), t2.disabled && (i3.disabled = true), t2.placeholder && i3.setAttribute("data-placeholder", "true"), t2.mandatory && i3.setAttribute("data-mandatory", "true"), t2.class && t2.class.split(" ").forEach(function(e2) {
          i3.classList.add(e2);
        }), t2.data && typeof t2.data == "object" && Object.keys(t2.data).forEach(function(e2) {
          i3.setAttribute("data-" + (0, n2.kebabCase)(e2), t2.data[e2]);
        }), i3;
      }, s2);
      function s2(e2) {
        this.triggerMutationObserver = true, this.element = e2.select, this.main = e2.main, this.element.disabled && (this.main.config.isEnabled = false), this.addAttributes(), this.addEventListeners(), this.mutationObserver = null, this.addMutationObserver(), this.element.slim = e2.main;
      }
      t.Select = i2;
    }, function(e, t, i2) {
      "use strict";
      t.__esModule = true, t.Slim = void 0;
      var n2 = i2(0), o = i2(1), i2 = (s2.prototype.containerDiv = function() {
        var e2 = document.createElement("div");
        return e2.style.cssText = this.main.config.style, this.updateContainerDivClass(e2), e2;
      }, s2.prototype.updateContainerDivClass = function(e2) {
        this.main.config.class = this.main.select.element.className.split(" "), e2.className = "", e2.classList.add(this.main.config.id), e2.classList.add(this.main.config.main);
        for (var t2 = 0, i3 = this.main.config.class; t2 < i3.length; t2++) {
          var n3 = i3[t2];
          n3.trim() !== "" && e2.classList.add(n3);
        }
      }, s2.prototype.singleSelectedDiv = function() {
        var t2 = this, e2 = document.createElement("div");
        e2.classList.add(this.main.config.singleSelected);
        var i3 = document.createElement("span");
        i3.classList.add("placeholder"), e2.appendChild(i3);
        var n3 = document.createElement("span");
        n3.innerHTML = this.main.config.deselectLabel, n3.classList.add("ss-deselect"), n3.onclick = function(e3) {
          e3.stopPropagation(), t2.main.config.isEnabled && t2.main.set("");
        }, e2.appendChild(n3);
        var s3 = document.createElement("span");
        s3.classList.add(this.main.config.arrow);
        var a = document.createElement("span");
        return a.classList.add("arrow-down"), s3.appendChild(a), e2.appendChild(s3), e2.onclick = function() {
          t2.main.config.isEnabled && (t2.main.data.contentOpen ? t2.main.close() : t2.main.open());
        }, { container: e2, placeholder: i3, deselect: n3, arrowIcon: { container: s3, arrow: a } };
      }, s2.prototype.placeholder = function() {
        var e2, t2 = this.main.data.getSelected();
        t2 === null || t2 && t2.placeholder ? ((e2 = document.createElement("span")).classList.add(this.main.config.disabled), e2.innerHTML = this.main.config.placeholderText, this.singleSelected && (this.singleSelected.placeholder.innerHTML = e2.outerHTML)) : (e2 = "", t2 && (e2 = t2.innerHTML && this.main.config.valuesUseText !== true ? t2.innerHTML : t2.text), this.singleSelected && (this.singleSelected.placeholder.innerHTML = t2 ? e2 : ""));
      }, s2.prototype.deselect = function() {
        this.singleSelected && (!this.main.config.allowDeselect || this.main.selected() === "" ? this.singleSelected.deselect.classList.add("ss-hide") : this.singleSelected.deselect.classList.remove("ss-hide"));
      }, s2.prototype.multiSelectedDiv = function() {
        var t2 = this, e2 = document.createElement("div");
        e2.classList.add(this.main.config.multiSelected);
        var i3 = document.createElement("div");
        i3.classList.add(this.main.config.values), e2.appendChild(i3);
        var n3 = document.createElement("div");
        n3.classList.add(this.main.config.add);
        var s3 = document.createElement("span");
        return s3.classList.add(this.main.config.plus), s3.onclick = function(e3) {
          t2.main.data.contentOpen && (t2.main.close(), e3.stopPropagation());
        }, n3.appendChild(s3), e2.appendChild(n3), e2.onclick = function(e3) {
          t2.main.config.isEnabled && (e3.target.classList.contains(t2.main.config.valueDelete) || (t2.main.data.contentOpen ? t2.main.close() : t2.main.open()));
        }, { container: e2, values: i3, add: n3, plus: s3 };
      }, s2.prototype.values = function() {
        if (this.multiSelected) {
          for (var e2 = this.multiSelected.values.childNodes, t2 = this.main.data.getSelected(), i3 = [], n3 = 0, s3 = e2; n3 < s3.length; n3++) {
            for (var a = s3[n3], o2 = true, l = 0, r = t2; l < r.length; l++) {
              var c = r[l];
              String(c.id) === String(a.dataset.id) && (o2 = false);
            }
            o2 && i3.push(a);
          }
          for (var d = 0, h = i3; d < h.length; d++) {
            var u = h[d];
            u.classList.add("ss-out"), this.multiSelected.values.removeChild(u);
          }
          for (var p, e2 = this.multiSelected.values.childNodes, c = 0; c < t2.length; c++) {
            o2 = false;
            for (var m = 0, f = e2; m < f.length; m++) {
              a = f[m];
              String(t2[c].id) === String(a.dataset.id) && (o2 = true);
            }
            o2 || (e2.length !== 0 && HTMLElement.prototype.insertAdjacentElement ? c === 0 ? this.multiSelected.values.insertBefore(this.valueDiv(t2[c]), e2[c]) : e2[c - 1].insertAdjacentElement("afterend", this.valueDiv(t2[c])) : this.multiSelected.values.appendChild(this.valueDiv(t2[c])));
          }
          t2.length === 0 && ((p = document.createElement("span")).classList.add(this.main.config.disabled), p.innerHTML = this.main.config.placeholderText, this.multiSelected.values.innerHTML = p.outerHTML);
        }
      }, s2.prototype.valueDiv = function(s3) {
        var a = this, e2 = document.createElement("div");
        e2.classList.add(this.main.config.value), e2.dataset.id = s3.id;
        var t2 = document.createElement("span");
        return t2.classList.add(this.main.config.valueText), t2.innerHTML = s3.innerHTML && this.main.config.valuesUseText !== true ? s3.innerHTML : s3.text, e2.appendChild(t2), s3.mandatory || ((t2 = document.createElement("span")).classList.add(this.main.config.valueDelete), t2.innerHTML = this.main.config.deselectLabel, t2.onclick = function(e3) {
          e3.preventDefault(), e3.stopPropagation();
          var t3 = false;
          if (a.main.beforeOnChange || (t3 = true), a.main.beforeOnChange) {
            for (var e3 = a.main.data.getSelected(), i3 = JSON.parse(JSON.stringify(e3)), n3 = 0; n3 < i3.length; n3++)
              i3[n3].id === s3.id && i3.splice(n3, 1);
            a.main.beforeOnChange(i3) !== false && (t3 = true);
          }
          t3 && (a.main.data.removeFromSelected(s3.id, "id"), a.main.render(), a.main.select.setValue(), a.main.data.onDataChange());
        }, e2.appendChild(t2)), e2;
      }, s2.prototype.contentDiv = function() {
        var e2 = document.createElement("div");
        return e2.classList.add(this.main.config.content), e2;
      }, s2.prototype.searchDiv = function() {
        var n3 = this, e2 = document.createElement("div"), s3 = document.createElement("input"), a = document.createElement("div");
        e2.classList.add(this.main.config.search);
        var t2 = { container: e2, input: s3 };
        return this.main.config.showSearch || (e2.classList.add(this.main.config.hide), s3.readOnly = true), s3.type = "search", s3.placeholder = this.main.config.searchPlaceholder, s3.tabIndex = 0, s3.setAttribute("aria-label", this.main.config.searchPlaceholder), s3.setAttribute("autocapitalize", "off"), s3.setAttribute("autocomplete", "off"), s3.setAttribute("autocorrect", "off"), s3.onclick = function(e3) {
          setTimeout(function() {
            e3.target.value === "" && n3.main.search("");
          }, 10);
        }, s3.onkeydown = function(e3) {
          e3.key === "ArrowUp" ? (n3.main.open(), n3.highlightUp(), e3.preventDefault()) : e3.key === "ArrowDown" ? (n3.main.open(), n3.highlightDown(), e3.preventDefault()) : e3.key === "Tab" ? n3.main.data.contentOpen ? n3.main.close() : setTimeout(function() {
            n3.main.close();
          }, n3.main.config.timeoutDelay) : e3.key === "Enter" && e3.preventDefault();
        }, s3.onkeyup = function(e3) {
          var t3 = e3.target;
          if (e3.key === "Enter") {
            if (n3.main.addable && e3.ctrlKey)
              return a.click(), e3.preventDefault(), void e3.stopPropagation();
            var i3 = n3.list.querySelector("." + n3.main.config.highlighted);
            i3 && i3.click();
          } else
            e3.key === "ArrowUp" || e3.key === "ArrowDown" || (e3.key === "Escape" ? n3.main.close() : n3.main.config.showSearch && n3.main.data.contentOpen ? n3.main.search(t3.value) : s3.value = "");
          e3.preventDefault(), e3.stopPropagation();
        }, s3.onfocus = function() {
          n3.main.open();
        }, e2.appendChild(s3), this.main.addable && (a.classList.add(this.main.config.addable), a.innerHTML = "+", a.onclick = function(e3) {
          var t3;
          n3.main.addable && (e3.preventDefault(), e3.stopPropagation(), (e3 = n3.search.input.value).trim() !== "" ? (e3 = n3.main.addable(e3), t3 = "", e3 && (typeof e3 == "object" ? (0, o.validateOption)(e3) && (n3.main.addData(e3), t3 = e3.value || e3.text) : (n3.main.addData(n3.main.data.newOption({ text: e3, value: e3 })), t3 = e3), n3.main.search(""), setTimeout(function() {
            n3.main.set(t3, "value", false, false);
          }, 100), n3.main.config.closeOnSelect && setTimeout(function() {
            n3.main.close();
          }, 100))) : n3.search.input.focus());
        }, e2.appendChild(a), t2.addable = a), t2;
      }, s2.prototype.highlightUp = function() {
        var e2 = this.list.querySelector("." + this.main.config.highlighted), t2 = null;
        if (e2)
          for (t2 = e2.previousSibling; t2 !== null && t2.classList.contains(this.main.config.disabled); )
            t2 = t2.previousSibling;
        else
          var i3 = this.list.querySelectorAll("." + this.main.config.option + ":not(." + this.main.config.disabled + ")"), t2 = i3[i3.length - 1];
        (t2 = t2 && t2.classList.contains(this.main.config.optgroupLabel) ? null : t2) !== null || (i3 = e2.parentNode).classList.contains(this.main.config.optgroup) && (!i3.previousSibling || (i3 = i3.previousSibling.querySelectorAll("." + this.main.config.option + ":not(." + this.main.config.disabled + ")")).length && (t2 = i3[i3.length - 1])), t2 && (e2 && e2.classList.remove(this.main.config.highlighted), t2.classList.add(this.main.config.highlighted), (0, n2.ensureElementInView)(this.list, t2));
      }, s2.prototype.highlightDown = function() {
        var e2, t2 = this.list.querySelector("." + this.main.config.highlighted), i3 = null;
        if (t2)
          for (i3 = t2.nextSibling; i3 !== null && i3.classList.contains(this.main.config.disabled); )
            i3 = i3.nextSibling;
        else
          i3 = this.list.querySelector("." + this.main.config.option + ":not(." + this.main.config.disabled + ")");
        i3 !== null || t2 === null || (e2 = t2.parentNode).classList.contains(this.main.config.optgroup) && e2.nextSibling && (i3 = e2.nextSibling.querySelector("." + this.main.config.option + ":not(." + this.main.config.disabled + ")")), i3 && (t2 && t2.classList.remove(this.main.config.highlighted), i3.classList.add(this.main.config.highlighted), (0, n2.ensureElementInView)(this.list, i3));
      }, s2.prototype.listDiv = function() {
        var e2 = document.createElement("div");
        return e2.classList.add(this.main.config.list), e2.setAttribute("role", "listbox"), e2;
      }, s2.prototype.options = function(e2) {
        e2 === void 0 && (e2 = "");
        var t2 = this.main.data.filtered || this.main.data.data;
        if ((this.list.innerHTML = "") !== e2)
          return (i3 = document.createElement("div")).classList.add(this.main.config.option), i3.classList.add(this.main.config.disabled), i3.innerHTML = e2, void this.list.appendChild(i3);
        if (this.main.config.isAjax && this.main.config.isSearching)
          return (i3 = document.createElement("div")).classList.add(this.main.config.option), i3.classList.add(this.main.config.disabled), i3.innerHTML = this.main.config.searchingText, void this.list.appendChild(i3);
        if (t2.length === 0) {
          var i3 = document.createElement("div");
          return i3.classList.add(this.main.config.option), i3.classList.add(this.main.config.disabled), i3.innerHTML = this.main.config.searchText, void this.list.appendChild(i3);
        }
        for (var r = this, n3 = 0, s3 = t2; n3 < s3.length; n3++)
          !function(e3) {
            if (e3.hasOwnProperty("label")) {
              var t3 = e3, s4 = document.createElement("div");
              s4.classList.add(r.main.config.optgroup);
              var i4 = document.createElement("div");
              i4.classList.add(r.main.config.optgroupLabel), r.main.config.selectByGroup && r.main.config.isMultiple && i4.classList.add(r.main.config.optgroupLabelSelectable), i4.innerHTML = t3.label, s4.appendChild(i4);
              t3 = t3.options;
              if (t3) {
                for (var a, n4 = 0, o2 = t3; n4 < o2.length; n4++) {
                  var l = o2[n4];
                  s4.appendChild(r.option(l));
                }
                r.main.config.selectByGroup && r.main.config.isMultiple && (a = r, i4.addEventListener("click", function(e4) {
                  e4.preventDefault(), e4.stopPropagation();
                  for (var t4 = 0, i5 = s4.children; t4 < i5.length; t4++) {
                    var n5 = i5[t4];
                    n5.className.indexOf(a.main.config.option) !== -1 && n5.click();
                  }
                }));
              }
              r.list.appendChild(s4);
            } else
              r.list.appendChild(r.option(e3));
          }(s3[n3]);
      }, s2.prototype.option = function(o2) {
        if (o2.placeholder) {
          var e2 = document.createElement("div");
          return e2.classList.add(this.main.config.option), e2.classList.add(this.main.config.hide), e2;
        }
        var t2 = document.createElement("div");
        t2.classList.add(this.main.config.option), t2.setAttribute("role", "option"), o2.class && o2.class.split(" ").forEach(function(e3) {
          t2.classList.add(e3);
        }), o2.style && (t2.style.cssText = o2.style);
        var l = this.main.data.getSelected();
        t2.dataset.id = o2.id, this.main.config.searchHighlight && this.main.slim && o2.innerHTML && this.main.slim.search.input.value.trim() !== "" ? t2.innerHTML = (0, n2.highlight)(o2.innerHTML, this.main.slim.search.input.value, this.main.config.searchHighlighter) : o2.innerHTML && (t2.innerHTML = o2.innerHTML), this.main.config.showOptionTooltips && t2.textContent && t2.setAttribute("title", t2.textContent);
        var r = this;
        t2.addEventListener("click", function(e3) {
          e3.preventDefault(), e3.stopPropagation();
          var t3 = this.dataset.id;
          if (o2.selected === true && r.main.config.allowDeselectOption) {
            var i3 = false;
            if (r.main.beforeOnChange && r.main.config.isMultiple || (i3 = true), r.main.beforeOnChange && r.main.config.isMultiple) {
              for (var n3 = r.main.data.getSelected(), s3 = JSON.parse(JSON.stringify(n3)), a = 0; a < s3.length; a++)
                s3[a].id === t3 && s3.splice(a, 1);
              r.main.beforeOnChange(s3) !== false && (i3 = true);
            }
            i3 && (r.main.config.isMultiple ? (r.main.data.removeFromSelected(t3, "id"), r.main.render(), r.main.select.setValue(), r.main.data.onDataChange()) : r.main.set(""));
          } else
            o2.disabled || o2.selected || r.main.config.limit && Array.isArray(l) && r.main.config.limit <= l.length || (r.main.beforeOnChange ? (n3 = void 0, (i3 = JSON.parse(JSON.stringify(r.main.data.getObjectFromData(t3)))).selected = true, r.main.config.isMultiple ? (n3 = JSON.parse(JSON.stringify(l))).push(i3) : n3 = JSON.parse(JSON.stringify(i3)), r.main.beforeOnChange(n3) !== false && r.main.set(t3, "id", r.main.config.closeOnSelect)) : r.main.set(t3, "id", r.main.config.closeOnSelect));
        });
        e2 = l && (0, n2.isValueInArrayOfObjects)(l, "id", o2.id);
        return (o2.disabled || e2) && (t2.onclick = null, r.main.config.allowDeselectOption || t2.classList.add(this.main.config.disabled), r.main.config.hideSelectedOption && t2.classList.add(this.main.config.hide)), e2 ? t2.classList.add(this.main.config.optionSelected) : t2.classList.remove(this.main.config.optionSelected), t2;
      }, s2);
      function s2(e2) {
        this.main = e2.main, this.container = this.containerDiv(), this.content = this.contentDiv(), this.search = this.searchDiv(), this.list = this.listDiv(), this.options(), this.singleSelected = null, this.multiSelected = null, this.main.config.isMultiple ? (this.multiSelected = this.multiSelectedDiv(), this.multiSelected && this.container.appendChild(this.multiSelected.container)) : (this.singleSelected = this.singleSelectedDiv(), this.container.appendChild(this.singleSelected.container)), this.main.config.addToBody ? (this.content.classList.add(this.main.config.id), document.body.appendChild(this.content)) : this.container.appendChild(this.content), this.content.appendChild(this.search.container), this.content.appendChild(this.list);
      }
      t.Slim = i2;
    }], s.c = n, s.d = function(e, t, i2) {
      s.o(e, t) || Object.defineProperty(e, t, { enumerable: true, get: i2 });
    }, s.r = function(e) {
      typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: true });
    }, s.t = function(t, e) {
      if (1 & e && (t = s(t)), 8 & e)
        return t;
      if (4 & e && typeof t == "object" && t && t.__esModule)
        return t;
      var i2 = Object.create(null);
      if (s.r(i2), Object.defineProperty(i2, "default", { enumerable: true, value: t }), 2 & e && typeof t != "string")
        for (var n2 in t)
          s.d(i2, n2, function(e2) {
            return t[e2];
          }.bind(null, n2));
      return i2;
    }, s.n = function(e) {
      var t = e && e.__esModule ? function() {
        return e.default;
      } : function() {
        return e;
      };
      return s.d(t, "a", t), t;
    }, s.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, s.p = "", s(s.s = 2).default;
    function s(e) {
      if (n[e])
        return n[e].exports;
      var t = n[e] = { i: e, l: false, exports: {} };
      return i[e].call(t.exports, t, t.exports, s), t.l = true, t.exports;
    }
    var i, n;
  });
  var slimselect_min_default = exports.SlimSelect;

  // assets/js/src/select/select.js
  var Select = class {
    constructor() {
    }
    static setup() {
      const elements = store_default.theContainer.getElementsByClassName("js-select");
      for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        new slimselect_min_default({
          select: element,
          showSearch: false
        });
      }
    }
  };

  // node_modules/tiny-slider/src/helpers/raf.js
  var win = window;
  var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
  };

  // node_modules/tiny-slider/src/helpers/caf.js
  var win2 = window;
  var caf = win2.cancelAnimationFrame || win2.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
  };

  // node_modules/tiny-slider/src/helpers/extend.js
  function extend() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for (; i < length; i++) {
      if ((obj = arguments[i]) !== null) {
        for (name in obj) {
          copy = obj[name];
          if (target === copy) {
            continue;
          } else if (copy !== void 0) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  }

  // node_modules/tiny-slider/src/helpers/checkStorageValue.js
  function checkStorageValue(value) {
    return ["true", "false"].indexOf(value) >= 0 ? JSON.parse(value) : value;
  }

  // node_modules/tiny-slider/src/helpers/setLocalStorage.js
  function setLocalStorage(storage, key, value, access) {
    if (access) {
      try {
        storage.setItem(key, value);
      } catch (e) {
      }
    }
    return value;
  }

  // node_modules/tiny-slider/src/helpers/getSlideId.js
  function getSlideId() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return "tns" + window.tnsId;
  }

  // node_modules/tiny-slider/src/helpers/getBody.js
  function getBody() {
    var doc = document, body = doc.body;
    if (!body) {
      body = doc.createElement("body");
      body.fake = true;
    }
    return body;
  }

  // node_modules/tiny-slider/src/helpers/docElement.js
  var docElement = document.documentElement;

  // node_modules/tiny-slider/src/helpers/setFakeBody.js
  function setFakeBody(body) {
    var docOverflow = "";
    if (body.fake) {
      docOverflow = docElement.style.overflow;
      body.style.background = "";
      body.style.overflow = docElement.style.overflow = "hidden";
      docElement.appendChild(body);
    }
    return docOverflow;
  }

  // node_modules/tiny-slider/src/helpers/resetFakeBody.js
  function resetFakeBody(body, docOverflow) {
    if (body.fake) {
      body.remove();
      docElement.style.overflow = docOverflow;
      docElement.offsetHeight;
    }
  }

  // node_modules/tiny-slider/src/helpers/calc.js
  function calc() {
    var doc = document, body = getBody(), docOverflow = setFakeBody(body), div = doc.createElement("div"), result = false;
    body.appendChild(div);
    try {
      var str = "(10px * 10)", vals = ["calc" + str, "-moz-calc" + str, "-webkit-calc" + str], val;
      for (var i = 0; i < 3; i++) {
        val = vals[i];
        div.style.width = val;
        if (div.offsetWidth === 100) {
          result = val.replace(str, "");
          break;
        }
      }
    } catch (e) {
    }
    body.fake ? resetFakeBody(body, docOverflow) : div.remove();
    return result;
  }

  // node_modules/tiny-slider/src/helpers/percentageLayout.js
  function percentageLayout() {
    var doc = document, body = getBody(), docOverflow = setFakeBody(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "", count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for (var i = 0; i < count; i++) {
      str += "<div></div>";
    }
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();
    return supported;
  }

  // node_modules/tiny-slider/src/helpers/mediaquerySupport.js
  function mediaquerySupport() {
    if (window.matchMedia || window.msMatchMedia) {
      return true;
    }
    var doc = document, body = getBody(), docOverflow = setFakeBody(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", position;
    style.type = "text/css";
    div.className = "tns-mq-test";
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(doc.createTextNode(rule));
    }
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle["position"];
    body.fake ? resetFakeBody(body, docOverflow) : div.remove();
    return position === "absolute";
  }

  // node_modules/tiny-slider/src/helpers/createStyleSheet.js
  function createStyleSheet(media, nonce) {
    var style = document.createElement("style");
    if (media) {
      style.setAttribute("media", media);
    }
    if (nonce) {
      style.setAttribute("nonce", nonce);
    }
    document.querySelector("head").appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
  }

  // node_modules/tiny-slider/src/helpers/addCSSRule.js
  function addCSSRule(sheet, selector, rules, index) {
    "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
  }

  // node_modules/tiny-slider/src/helpers/removeCSSRule.js
  function removeCSSRule(sheet, index) {
    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
  }

  // node_modules/tiny-slider/src/helpers/getCssRulesLength.js
  function getCssRulesLength(sheet) {
    var rule = "insertRule" in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
  }

  // node_modules/tiny-slider/src/helpers/toDegree.js
  function toDegree(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
  }

  // node_modules/tiny-slider/src/helpers/getTouchDirection.js
  function getTouchDirection(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) {
      direction = "horizontal";
    } else if (gap <= range) {
      direction = "vertical";
    }
    return direction;
  }

  // node_modules/tiny-slider/src/helpers/forEach.js
  function forEach(arr, callback, scope) {
    for (var i = 0, l = arr.length; i < l; i++) {
      callback.call(scope, arr[i], i);
    }
  }

  // node_modules/tiny-slider/src/helpers/classListSupport.js
  var classListSupport = "classList" in document.createElement("_");

  // node_modules/tiny-slider/src/helpers/hasClass.js
  var hasClass = classListSupport ? function(el, str) {
    return el.classList.contains(str);
  } : function(el, str) {
    return el.className.indexOf(str) >= 0;
  };

  // node_modules/tiny-slider/src/helpers/addClass.js
  var addClass = classListSupport ? function(el, str) {
    if (!hasClass(el, str)) {
      el.classList.add(str);
    }
  } : function(el, str) {
    if (!hasClass(el, str)) {
      el.className += " " + str;
    }
  };

  // node_modules/tiny-slider/src/helpers/removeClass.js
  var removeClass = classListSupport ? function(el, str) {
    if (hasClass(el, str)) {
      el.classList.remove(str);
    }
  } : function(el, str) {
    if (hasClass(el, str)) {
      el.className = el.className.replace(str, "");
    }
  };

  // node_modules/tiny-slider/src/helpers/hasAttr.js
  function hasAttr(el, attr) {
    return el.hasAttribute(attr);
  }

  // node_modules/tiny-slider/src/helpers/getAttr.js
  function getAttr(el, attr) {
    return el.getAttribute(attr);
  }

  // node_modules/tiny-slider/src/helpers/isNodeList.js
  function isNodeList(el) {
    return typeof el.item !== "undefined";
  }

  // node_modules/tiny-slider/src/helpers/setAttrs.js
  function setAttrs(els, attrs) {
    els = isNodeList(els) || els instanceof Array ? els : [els];
    if (Object.prototype.toString.call(attrs) !== "[object Object]") {
      return;
    }
    for (var i = els.length; i--; ) {
      for (var key in attrs) {
        els[i].setAttribute(key, attrs[key]);
      }
    }
  }

  // node_modules/tiny-slider/src/helpers/removeAttrs.js
  function removeAttrs(els, attrs) {
    els = isNodeList(els) || els instanceof Array ? els : [els];
    attrs = attrs instanceof Array ? attrs : [attrs];
    var attrLength = attrs.length;
    for (var i = els.length; i--; ) {
      for (var j = attrLength; j--; ) {
        els[i].removeAttribute(attrs[j]);
      }
    }
  }

  // node_modules/tiny-slider/src/helpers/arrayFromNodeList.js
  function arrayFromNodeList(nl) {
    var arr = [];
    for (var i = 0, l = nl.length; i < l; i++) {
      arr.push(nl[i]);
    }
    return arr;
  }

  // node_modules/tiny-slider/src/helpers/hideElement.js
  function hideElement(el, forceHide) {
    if (el.style.display !== "none") {
      el.style.display = "none";
    }
  }

  // node_modules/tiny-slider/src/helpers/showElement.js
  function showElement(el, forceHide) {
    if (el.style.display === "none") {
      el.style.display = "";
    }
  }

  // node_modules/tiny-slider/src/helpers/isVisible.js
  function isVisible(el) {
    return window.getComputedStyle(el).display !== "none";
  }

  // node_modules/tiny-slider/src/helpers/whichProperty.js
  function whichProperty(props) {
    if (typeof props === "string") {
      var arr = [props], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = ["Webkit", "Moz", "ms", "O"];
      prefixes.forEach(function(prefix) {
        if (prefix !== "ms" || props === "transform") {
          arr.push(prefix + Props);
        }
      });
      props = arr;
    }
    var el = document.createElement("fakeelement"), len = props.length;
    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      if (el.style[prop] !== void 0) {
        return prop;
      }
    }
    return false;
  }

  // node_modules/tiny-slider/src/helpers/has3DTransforms.js
  function has3DTransforms(tf) {
    if (!tf) {
      return false;
    }
    if (!window.getComputedStyle) {
      return false;
    }
    var doc = document, body = getBody(), docOverflow = setFakeBody(body), el = doc.createElement("p"), has3d, cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
    cssTF += "transform";
    body.insertBefore(el, null);
    el.style[tf] = "translate3d(1px,1px,1px)";
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? resetFakeBody(body, docOverflow) : el.remove();
    return has3d !== void 0 && has3d.length > 0 && has3d !== "none";
  }

  // node_modules/tiny-slider/src/helpers/getEndProperty.js
  function getEndProperty(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) {
      endProp = "webkit" + propOut + "End";
    } else if (/^O/.test(propIn)) {
      endProp = "o" + propOut + "End";
    } else if (propIn) {
      endProp = propOut.toLowerCase() + "end";
    }
    return endProp;
  }

  // node_modules/tiny-slider/src/helpers/passiveOption.js
  var supportsPassive = false;
  try {
    opts = Object.defineProperty({}, "passive", {
      get: function() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {
  }
  var opts;
  var passiveOption = supportsPassive ? { passive: true } : false;

  // node_modules/tiny-slider/src/helpers/addEvents.js
  function addEvents(el, obj, preventScrolling) {
    for (var prop in obj) {
      var option = ["touchstart", "touchmove"].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
      el.addEventListener(prop, obj[prop], option);
    }
  }

  // node_modules/tiny-slider/src/helpers/removeEvents.js
  function removeEvents(el, obj) {
    for (var prop in obj) {
      var option = ["touchstart", "touchmove"].indexOf(prop) >= 0 ? passiveOption : false;
      el.removeEventListener(prop, obj[prop], option);
    }
  }

  // node_modules/tiny-slider/src/helpers/events.js
  function Events() {
    return {
      topics: {},
      on: function(eventName, fn) {
        this.topics[eventName] = this.topics[eventName] || [];
        this.topics[eventName].push(fn);
      },
      off: function(eventName, fn) {
        if (this.topics[eventName]) {
          for (var i = 0; i < this.topics[eventName].length; i++) {
            if (this.topics[eventName][i] === fn) {
              this.topics[eventName].splice(i, 1);
              break;
            }
          }
        }
      },
      emit: function(eventName, data) {
        data.type = eventName;
        if (this.topics[eventName]) {
          this.topics[eventName].forEach(function(fn) {
            fn(data, eventName);
          });
        }
      }
    };
  }

  // node_modules/tiny-slider/src/helpers/jsTransform.js
  function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
      duration -= tick;
      from += positionTick;
      element.style[attr] = prefix + from + unit + postfix;
      if (duration > 0) {
        setTimeout(moveElement, tick);
      } else {
        callback();
      }
    }
  }

  // node_modules/tiny-slider/src/tiny-slider.js
  if (!Object.keys) {
    Object.keys = function(object) {
      var keys = [];
      for (var name in object) {
        if (Object.prototype.hasOwnProperty.call(object, name)) {
          keys.push(name);
        }
      }
      return keys;
    };
  }
  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
  var tns = function(options) {
    options = extend({
      container: ".slider",
      mode: "carousel",
      axis: "horizontal",
      items: 1,
      gutter: 0,
      edgePadding: 0,
      fixedWidth: false,
      autoWidth: false,
      viewportMax: false,
      slideBy: 1,
      center: false,
      controls: true,
      controlsPosition: "top",
      controlsText: ["prev", "next"],
      controlsContainer: false,
      prevButton: false,
      nextButton: false,
      nav: true,
      navPosition: "top",
      navContainer: false,
      navAsThumbnails: false,
      arrowKeys: false,
      speed: 300,
      autoplay: false,
      autoplayPosition: "top",
      autoplayTimeout: 5e3,
      autoplayDirection: "forward",
      autoplayText: ["start", "stop"],
      autoplayHoverPause: false,
      autoplayButton: false,
      autoplayButtonOutput: true,
      autoplayResetOnVisibility: true,
      animateIn: "tns-fadeIn",
      animateOut: "tns-fadeOut",
      animateNormal: "tns-normal",
      animateDelay: false,
      loop: true,
      rewind: false,
      autoHeight: false,
      responsive: false,
      lazyload: false,
      lazyloadSelector: ".tns-lazy-img",
      touch: true,
      mouseDrag: false,
      swipeAngle: 15,
      nested: false,
      preventActionWhenRunning: false,
      preventScrollOnTouch: false,
      freezable: true,
      onInit: false,
      useLocalStorage: true,
      nonce: false
    }, options || {});
    var doc = document, win3 = window, KEYS = {
      ENTER: 13,
      SPACE: 32,
      LEFT: 37,
      RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
      var browserInfo = navigator.userAgent;
      var uid = new Date();
      try {
        tnsStorage = win3.localStorage;
        if (tnsStorage) {
          tnsStorage.setItem(uid, uid);
          localStorageAccess = tnsStorage.getItem(uid) == uid;
          tnsStorage.removeItem(uid);
        } else {
          localStorageAccess = false;
        }
        if (!localStorageAccess) {
          tnsStorage = {};
        }
      } catch (e) {
        localStorageAccess = false;
      }
      if (localStorageAccess) {
        if (tnsStorage["tnsApp"] && tnsStorage["tnsApp"] !== browserInfo) {
          ["tC", "tPL", "tMQ", "tTf", "t3D", "tTDu", "tTDe", "tADu", "tADe", "tTE", "tAE"].forEach(function(item) {
            tnsStorage.removeItem(item);
          });
        }
        localStorage["tnsApp"] = browserInfo;
      }
    }
    var CALC = tnsStorage["tC"] ? checkStorageValue(tnsStorage["tC"]) : setLocalStorage(tnsStorage, "tC", calc(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage["tPL"] ? checkStorageValue(tnsStorage["tPL"]) : setLocalStorage(tnsStorage, "tPL", percentageLayout(), localStorageAccess), CSSMQ = tnsStorage["tMQ"] ? checkStorageValue(tnsStorage["tMQ"]) : setLocalStorage(tnsStorage, "tMQ", mediaquerySupport(), localStorageAccess), TRANSFORM = tnsStorage["tTf"] ? checkStorageValue(tnsStorage["tTf"]) : setLocalStorage(tnsStorage, "tTf", whichProperty("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage["t3D"] ? checkStorageValue(tnsStorage["t3D"]) : setLocalStorage(tnsStorage, "t3D", has3DTransforms(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage["tTDu"] ? checkStorageValue(tnsStorage["tTDu"]) : setLocalStorage(tnsStorage, "tTDu", whichProperty("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage["tTDe"] ? checkStorageValue(tnsStorage["tTDe"]) : setLocalStorage(tnsStorage, "tTDe", whichProperty("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage["tADu"] ? checkStorageValue(tnsStorage["tADu"]) : setLocalStorage(tnsStorage, "tADu", whichProperty("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage["tADe"] ? checkStorageValue(tnsStorage["tADe"]) : setLocalStorage(tnsStorage, "tADe", whichProperty("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage["tTE"] ? checkStorageValue(tnsStorage["tTE"]) : setLocalStorage(tnsStorage, "tTE", getEndProperty(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage["tAE"] ? checkStorageValue(tnsStorage["tAE"]) : setLocalStorage(tnsStorage, "tAE", getEndProperty(ANIMATIONDURATION, "Animation"), localStorageAccess);
    var supportConsoleWarn = win3.console && typeof win3.console.warn === "function", tnsList = ["container", "controlsContainer", "prevButton", "nextButton", "navContainer", "autoplayButton"], optionsElements = {};
    tnsList.forEach(function(item) {
      if (typeof options[item] === "string") {
        var str = options[item], el = doc.querySelector(str);
        optionsElements[item] = str;
        if (el && el.nodeName) {
          options[item] = el;
        } else {
          if (supportConsoleWarn) {
            console.warn("Can't find", options[item]);
          }
          return;
        }
      }
    });
    if (options.container.children.length < 1) {
      if (supportConsoleWarn) {
        console.warn("No slides found in", options.container);
      }
      return;
    }
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === "carousel" ? true : false;
    if (responsive) {
      if (0 in responsive) {
        options = extend(options, responsive[0]);
        delete responsive[0];
      }
      var responsiveTem = {};
      for (var key in responsive) {
        var val = responsive[key];
        val = typeof val === "number" ? { items: val } : val;
        responsiveTem[key] = val;
      }
      responsive = responsiveTem;
      responsiveTem = null;
    }
    function updateOptions(obj) {
      for (var key2 in obj) {
        if (!carousel) {
          if (key2 === "slideBy") {
            obj[key2] = "page";
          }
          if (key2 === "edgePadding") {
            obj[key2] = false;
          }
          if (key2 === "autoHeight") {
            obj[key2] = false;
          }
        }
        if (key2 === "responsive") {
          updateOptions(obj[key2]);
        }
      }
    }
    if (!carousel) {
      updateOptions(options);
    }
    if (!carousel) {
      options.axis = "horizontal";
      options.slideBy = "page";
      options.edgePadding = false;
      var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === "horizontal" ? true : false, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) {
      setBreakpointZone();
    }
    if (carousel) {
      container.className += " tns-vpfix";
    }
    var autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = !autoWidth ? Math.floor(getOption("items")) : 1, slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = createStyleSheet(null, getOption("nonce")), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", getIndexMax = function() {
      if (fixedWidth) {
        return function() {
          return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
      } else if (autoWidth) {
        return function() {
          for (var i = 0; i < slideCountNew; i++) {
            if (slidePositions[i] >= -rightBoundary) {
              return i;
            }
          }
        };
      } else {
        return function() {
          if (center && carousel && !loop) {
            return slideCount - 1;
          } else {
            return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
          }
        };
      }
    }(), index = getStartIndex(getOption("startIndex")), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? "?" : true, running = false, onInit = options.onInit, events = new Events(), newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || getSlideId(), disable = getOption("disable"), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
      "click": onControlsClick,
      "keydown": onControlsKeydown
    }, navEvents = {
      "click": onNavClick,
      "keydown": onNavKeydown
    }, hoverEvents = {
      "mouseover": mouseoverPause,
      "mouseout": mouseoutRestart
    }, visibilityEvent = { "visibilitychange": onVisibilityChange }, docmentKeydownEvent = { "keydown": onDocumentKeydown }, touchEvents = {
      "touchstart": onPanStart,
      "touchmove": onPanMove,
      "touchend": onPanEnd,
      "touchcancel": onPanEnd
    }, dragEvents = {
      "mousedown": onPanStart,
      "mousemove": onPanMove,
      "mouseup": onPanEnd,
      "mouseleave": onPanEnd
    }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", slideClonedClass = "tns-slide-cloned", imgCompleteClass = "tns-complete", imgEvents = {
      "load": onImgLoaded,
      "error": onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === "force" ? true : false;
    if (hasControls) {
      var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "", prevIsButton, nextIsButton;
    }
    if (hasNav) {
      var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
    }
    if (hasAutoplay) {
      var autoplayDirection = options.autoplayDirection === "forward" ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = ["<span class='tns-visually-hidden'>", " animation</span>"], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    }
    if (hasTouch || hasMouseDrag) {
      var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function(a, b) {
        return a.x - b.x;
      } : function(a, b) {
        return a.y - b.y;
      };
    }
    if (!autoWidth) {
      resetVariblesWhenDisable(disable || freeze);
    }
    if (TRANSFORM) {
      transformAttr = TRANSFORM;
      transformPrefix = "translate";
      if (HAS3DTRANSFORMS) {
        transformPrefix += horizontal ? "3d(" : "3d(0px, ";
        transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)";
      } else {
        transformPrefix += horizontal ? "X(" : "Y(";
        transformPostfix = ")";
      }
    }
    if (carousel) {
      container.className = container.className.replace("tns-vpfix", "");
    }
    initStructure();
    initSheet();
    initSliderTransform();
    function resetVariblesWhenDisable(condition) {
      if (condition) {
        controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
      }
    }
    function getCurrentSlide() {
      var tem = carousel ? index - cloneCount : index;
      while (tem < 0) {
        tem += slideCount;
      }
      return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
      ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
      return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
      if (i == null) {
        i = index;
      }
      if (carousel) {
        i -= cloneCount;
      }
      while (i < 0) {
        i += slideCount;
      }
      return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
      var absIndex = getAbsIndex(), result;
      result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
      if (!loop && carousel && index === indexMax) {
        result = pages - 1;
      }
      return result;
    }
    function getItemsMax() {
      if (autoWidth || fixedWidth && !viewportMax) {
        return slideCount - 1;
      } else {
        var str = fixedWidth ? "fixedWidth" : "items", arr = [];
        if (fixedWidth || options[str] < slideCount) {
          arr.push(options[str]);
        }
        if (responsive) {
          for (var bp in responsive) {
            var tem = responsive[bp][str];
            if (tem && (fixedWidth || tem < slideCount)) {
              arr.push(tem);
            }
          }
        }
        if (!arr.length) {
          arr.push(0);
        }
        return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
      }
    }
    function getCloneCountForLoop() {
      var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
      result = Math.max(itemsMax, result);
      return hasOption("edgePadding") ? result + 1 : result;
    }
    function getWindowWidth() {
      return win3.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
      return pos === "top" ? "afterbegin" : "beforeend";
    }
    function getClientWidth(el) {
      if (el == null) {
        return;
      }
      var div = doc.createElement("div"), rect, width;
      el.appendChild(div);
      rect = div.getBoundingClientRect();
      width = rect.right - rect.left;
      div.remove();
      return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
      var gap = edgePadding ? edgePadding * 2 - gutter : 0;
      return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
      if (options[item]) {
        return true;
      } else {
        if (responsive) {
          for (var bp in responsive) {
            if (responsive[bp][item]) {
              return true;
            }
          }
        }
        return false;
      }
    }
    function getOption(item, ww) {
      if (ww == null) {
        ww = windowWidth;
      }
      if (item === "items" && fixedWidth) {
        return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
      } else {
        var result = options[item];
        if (responsive) {
          for (var bp in responsive) {
            if (ww >= parseInt(bp)) {
              if (item in responsive[bp]) {
                result = responsive[bp][item];
              }
            }
          }
        }
        if (item === "slideBy" && result === "page") {
          result = getOption("items");
        }
        if (!carousel && (item === "slideBy" || item === "items")) {
          result = Math.floor(result);
        }
        return result;
      }
    }
    function getSlideMarginLeft(i) {
      return CALC ? CALC + "(" + i * 100 + "% / " + slideCountNew + ")" : i * 100 / slideCountNew + "%";
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
      var str = "";
      if (edgePaddingTem !== void 0) {
        var gap = edgePaddingTem;
        if (gutterTem) {
          gap -= gutterTem;
        }
        str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
      } else if (gutterTem && !fixedWidthTem) {
        var gutterTemUnit = "-" + gutterTem + "px", dir = horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0";
        str = "margin: 0 " + dir + ";";
      }
      if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) {
        str += getTransitionDurationStyle(speedTem);
      }
      return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
      if (fixedWidthTem) {
        return (fixedWidthTem + gutterTem) * slideCountNew + "px";
      } else {
        return CALC ? CALC + "(" + slideCountNew * 100 + "% / " + itemsTem + ")" : slideCountNew * 100 / itemsTem + "%";
      }
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
      var width;
      if (fixedWidthTem) {
        width = fixedWidthTem + gutterTem + "px";
      } else {
        if (!carousel) {
          itemsTem = Math.floor(itemsTem);
        }
        var dividend = carousel ? slideCountNew : itemsTem;
        width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
      }
      width = "width:" + width;
      return nested !== "inner" ? width + ";" : width + " !important;";
    }
    function getSlideGutterStyle(gutterTem) {
      var str = "";
      if (gutterTem !== false) {
        var prop = horizontal ? "padding-" : "margin-", dir = horizontal ? "right" : "bottom";
        str = prop + dir + ": " + gutterTem + "px;";
      }
      return str;
    }
    function getCSSPrefix(name, num) {
      var prefix = name.substring(0, name.length - num).toLowerCase();
      if (prefix) {
        prefix = "-" + prefix + "-";
      }
      return prefix;
    }
    function getTransitionDurationStyle(speed2) {
      return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed2 / 1e3 + "s;";
    }
    function getAnimationDurationStyle(speed2) {
      return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed2 / 1e3 + "s;";
    }
    function initStructure() {
      var classOuter = "tns-outer", classInner = "tns-inner", hasGutter = hasOption("gutter");
      outerWrapper.className = classOuter;
      innerWrapper.className = classInner;
      outerWrapper.id = slideId + "-ow";
      innerWrapper.id = slideId + "-iw";
      if (container.id === "") {
        container.id = slideId;
      }
      newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel";
      newContainerClasses += CALC ? " tns-calc" : " tns-no-calc";
      if (autoWidth) {
        newContainerClasses += " tns-autowidth";
      }
      newContainerClasses += " tns-" + options.axis;
      container.className += newContainerClasses;
      if (carousel) {
        middleWrapper = doc.createElement("div");
        middleWrapper.id = slideId + "-mw";
        middleWrapper.className = "tns-ovh";
        outerWrapper.appendChild(middleWrapper);
        middleWrapper.appendChild(innerWrapper);
      } else {
        outerWrapper.appendChild(innerWrapper);
      }
      if (autoHeight) {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.className += " tns-ah";
      }
      containerParent.insertBefore(outerWrapper, container);
      innerWrapper.appendChild(container);
      forEach(slideItems, function(item, i) {
        addClass(item, "tns-item");
        if (!item.id) {
          item.id = slideId + "-item" + i;
        }
        if (!carousel && animateNormal) {
          addClass(item, animateNormal);
        }
        setAttrs(item, {
          "aria-hidden": "true",
          "tabindex": "-1"
        });
      });
      if (cloneCount) {
        var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
        for (var j = cloneCount; j--; ) {
          var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
          addClass(cloneFirst, slideClonedClass);
          removeAttrs(cloneFirst, "id");
          fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
          if (carousel) {
            var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
            addClass(cloneLast, slideClonedClass);
            removeAttrs(cloneLast, "id");
            fragmentBefore.appendChild(cloneLast);
          }
        }
        container.insertBefore(fragmentBefore, container.firstChild);
        container.appendChild(fragmentAfter);
        slideItems = container.children;
      }
    }
    function initSliderTransform() {
      if (hasOption("autoHeight") || autoWidth || !horizontal) {
        var imgs = container.querySelectorAll("img");
        forEach(imgs, function(img) {
          var src = img.src;
          if (!lazyload) {
            if (src && src.indexOf("data:image") < 0) {
              img.src = "";
              addEvents(img, imgEvents);
              addClass(img, "loading");
              img.src = src;
            } else {
              imgLoaded(img);
            }
          }
        });
        raf(function() {
          imgsLoadedCheck(arrayFromNodeList(imgs), function() {
            imgsComplete = true;
          });
        });
        if (hasOption("autoHeight")) {
          imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
        }
        lazyload ? initSliderTransformStyleCheck() : raf(function() {
          imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck);
        });
      } else {
        if (carousel) {
          doContainerTransformSilent();
        }
        initTools();
        initEvents();
      }
    }
    function initSliderTransformStyleCheck() {
      if (autoWidth && slideCount > 1) {
        var num = loop ? index : slideCount - 1;
        (function stylesApplicationCheck() {
          var left = slideItems[num].getBoundingClientRect().left;
          var right = slideItems[num - 1].getBoundingClientRect().right;
          Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
            stylesApplicationCheck();
          }, 16);
        })();
      } else {
        initSliderTransformCore();
      }
    }
    function initSliderTransformCore() {
      if (!horizontal || autoWidth) {
        setSlidePositions();
        if (autoWidth) {
          rightBoundary = getRightBoundary();
          if (freezable) {
            freeze = getFreeze();
          }
          indexMax = getIndexMax();
          resetVariblesWhenDisable(disable || freeze);
        } else {
          updateContentWrapperHeight();
        }
      }
      if (carousel) {
        doContainerTransformSilent();
      }
      initTools();
      initEvents();
    }
    function initSheet() {
      if (!carousel) {
        for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
          var item = slideItems[i];
          item.style.left = (i - index) * 100 / items + "%";
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      }
      if (horizontal) {
        if (PERCENTAGELAYOUT || autoWidth) {
          addCSSRule(sheet, "#" + slideId + " > .tns-item", "font-size:" + win3.getComputedStyle(slideItems[0]).fontSize + ";", getCssRulesLength(sheet));
          addCSSRule(sheet, "#" + slideId, "font-size:0;", getCssRulesLength(sheet));
        } else if (carousel) {
          forEach(slideItems, function(slide, i2) {
            slide.style.marginLeft = getSlideMarginLeft(i2);
          });
        }
      }
      if (CSSMQ) {
        if (TRANSITIONDURATION) {
          var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : "";
          addCSSRule(sheet, "#" + slideId + "-mw", str, getCssRulesLength(sheet));
        }
        str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
        addCSSRule(sheet, "#" + slideId + "-iw", str, getCssRulesLength(sheet));
        if (carousel) {
          str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "";
          if (TRANSITIONDURATION) {
            str += getTransitionDurationStyle(speed);
          }
          addCSSRule(sheet, "#" + slideId, str, getCssRulesLength(sheet));
        }
        str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "";
        if (options.gutter) {
          str += getSlideGutterStyle(options.gutter);
        }
        if (!carousel) {
          if (TRANSITIONDURATION) {
            str += getTransitionDurationStyle(speed);
          }
          if (ANIMATIONDURATION) {
            str += getAnimationDurationStyle(speed);
          }
        }
        if (str) {
          addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
        }
      } else {
        update_carousel_transition_duration();
        innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
        if (carousel && horizontal && !autoWidth) {
          container.style.width = getContainerWidth(fixedWidth, gutter, items);
        }
        var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
        if (gutter) {
          str += getSlideGutterStyle(gutter);
        }
        if (str) {
          addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
        }
      }
      if (responsive && CSSMQ) {
        for (var bp in responsive) {
          bp = parseInt(bp);
          var opts = responsive[bp], str = "", middleWrapperStr = "", innerWrapperStr = "", containerStr = "", slideStr = "", itemsBP = !autoWidth ? getOption("items", bp) : null, fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
          if (TRANSITIONDURATION && middleWrapper && getOption("autoHeight", bp) && "speed" in opts) {
            middleWrapperStr = "#" + slideId + "-mw{" + getTransitionDurationStyle(speedBP) + "}";
          }
          if ("edgePadding" in opts || "gutter" in opts) {
            innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}";
          }
          if (carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts)) {
            containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";";
          }
          if (TRANSITIONDURATION && "speed" in opts) {
            containerStr += getTransitionDurationStyle(speedBP);
          }
          if (containerStr) {
            containerStr = "#" + slideId + "{" + containerStr + "}";
          }
          if ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) {
            slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
          }
          if ("gutter" in opts) {
            slideStr += getSlideGutterStyle(gutterBP);
          }
          if (!carousel && "speed" in opts) {
            if (TRANSITIONDURATION) {
              slideStr += getTransitionDurationStyle(speedBP);
            }
            if (ANIMATIONDURATION) {
              slideStr += getAnimationDurationStyle(speedBP);
            }
          }
          if (slideStr) {
            slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}";
          }
          str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
          if (str) {
            sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
          }
        }
      }
    }
    function initTools() {
      updateSlideStatus();
      outerWrapper.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + "</span>  of " + slideCount + "</div>");
      liveregionCurrent = outerWrapper.querySelector(".tns-liveregion .current");
      if (hasAutoplay) {
        var txt = autoplay ? "stop" : "start";
        if (autoplayButton) {
          setAttrs(autoplayButton, { "data-action": txt });
        } else if (options.autoplayButtonOutput) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>");
          autoplayButton = outerWrapper.querySelector("[data-action]");
        }
        if (autoplayButton) {
          addEvents(autoplayButton, { "click": toggleAutoplay });
        }
        if (autoplay) {
          startAutoplay();
          if (autoplayHoverPause) {
            addEvents(container, hoverEvents);
          }
          if (autoplayResetOnVisibility) {
            addEvents(container, visibilityEvent);
          }
        }
      }
      if (hasNav) {
        var initIndex = !carousel ? 0 : cloneCount;
        if (navContainer) {
          setAttrs(navContainer, { "aria-label": "Carousel Pagination" });
          navItems = navContainer.children;
          forEach(navItems, function(item, i2) {
            setAttrs(item, {
              "data-nav": i2,
              "tabindex": "-1",
              "aria-label": navStr + (i2 + 1),
              "aria-controls": slideId
            });
          });
        } else {
          var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"';
          for (var i = 0; i < slideCount; i++) {
            navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
          }
          navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>";
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
          navContainer = outerWrapper.querySelector(".tns-nav");
          navItems = navContainer.children;
        }
        updateNavVisibility();
        if (TRANSITIONDURATION) {
          var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1e3 + "s";
          if (prefix) {
            str = "-" + prefix + "-" + str;
          }
          addCSSRule(sheet, "[aria-controls^=" + slideId + "-item]", str, getCssRulesLength(sheet));
        }
        setAttrs(navItems[navCurrentIndex], { "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent });
        removeAttrs(navItems[navCurrentIndex], "tabindex");
        addClass(navItems[navCurrentIndex], navActiveClass);
        addEvents(navContainer, navEvents);
      }
      if (hasControls) {
        if (!controlsContainer && (!prevButton || !nextButton)) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + "</button></div>");
          controlsContainer = outerWrapper.querySelector(".tns-controls");
        }
        if (!prevButton || !nextButton) {
          prevButton = controlsContainer.children[0];
          nextButton = controlsContainer.children[1];
        }
        if (options.controlsContainer) {
          setAttrs(controlsContainer, {
            "aria-label": "Carousel Navigation",
            "tabindex": "0"
          });
        }
        if (options.controlsContainer || options.prevButton && options.nextButton) {
          setAttrs([prevButton, nextButton], {
            "aria-controls": slideId,
            "tabindex": "-1"
          });
        }
        if (options.controlsContainer || options.prevButton && options.nextButton) {
          setAttrs(prevButton, { "data-controls": "prev" });
          setAttrs(nextButton, { "data-controls": "next" });
        }
        prevIsButton = isButton(prevButton);
        nextIsButton = isButton(nextButton);
        updateControlsStatus();
        if (controlsContainer) {
          addEvents(controlsContainer, controlsEvents);
        } else {
          addEvents(prevButton, controlsEvents);
          addEvents(nextButton, controlsEvents);
        }
      }
      disableUI();
    }
    function initEvents() {
      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        addEvents(container, eve);
      }
      if (touch) {
        addEvents(container, touchEvents, options.preventScrollOnTouch);
      }
      if (mouseDrag) {
        addEvents(container, dragEvents);
      }
      if (arrowKeys) {
        addEvents(doc, docmentKeydownEvent);
      }
      if (nested === "inner") {
        events.on("outerResized", function() {
          resizeTasks();
          events.emit("innerLoaded", info());
        });
      } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
        addEvents(win3, { "resize": onResize });
      }
      if (autoHeight) {
        if (nested === "outer") {
          events.on("innerLoaded", doAutoHeight);
        } else if (!disable) {
          doAutoHeight();
        }
      }
      doLazyLoad();
      if (disable) {
        disableSlider();
      } else if (freeze) {
        freezeSlider();
      }
      events.on("indexChanged", additionalUpdates);
      if (nested === "inner") {
        events.emit("innerLoaded", info());
      }
      if (typeof onInit === "function") {
        onInit(info());
      }
      isOn = true;
    }
    function destroy() {
      sheet.disabled = true;
      if (sheet.ownerNode) {
        sheet.ownerNode.remove();
      }
      removeEvents(win3, { "resize": onResize });
      if (arrowKeys) {
        removeEvents(doc, docmentKeydownEvent);
      }
      if (controlsContainer) {
        removeEvents(controlsContainer, controlsEvents);
      }
      if (navContainer) {
        removeEvents(navContainer, navEvents);
      }
      removeEvents(container, hoverEvents);
      removeEvents(container, visibilityEvent);
      if (autoplayButton) {
        removeEvents(autoplayButton, { "click": toggleAutoplay });
      }
      if (autoplay) {
        clearInterval(autoplayTimer);
      }
      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        removeEvents(container, eve);
      }
      if (touch) {
        removeEvents(container, touchEvents);
      }
      if (mouseDrag) {
        removeEvents(container, dragEvents);
      }
      var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];
      tnsList.forEach(function(item, i) {
        var el = item === "container" ? outerWrapper : options[item];
        if (typeof el === "object" && el) {
          var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
          el.outerHTML = htmlList[i];
          options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
        }
      });
      tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
      for (var a in this) {
        if (a !== "rebuild") {
          this[a] = null;
        }
      }
      isOn = false;
    }
    function onResize(e) {
      raf(function() {
        resizeTasks(getEvent(e));
      });
    }
    function resizeTasks(e) {
      if (!isOn) {
        return;
      }
      if (nested === "outer") {
        events.emit("outerResized", info(e));
      }
      windowWidth = getWindowWidth();
      var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
      if (responsive) {
        setBreakpointZone();
        bpChanged = breakpointZoneTem !== breakpointZone;
        if (bpChanged) {
          events.emit("newBreakpointStart", info(e));
        }
      }
      var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
      if (bpChanged) {
        var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
        if (!CSSMQ) {
          var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
      }
      arrowKeys = getOption("arrowKeys");
      controls = getOption("controls");
      nav = getOption("nav");
      touch = getOption("touch");
      center = getOption("center");
      mouseDrag = getOption("mouseDrag");
      autoplay = getOption("autoplay");
      autoplayHoverPause = getOption("autoplayHoverPause");
      autoplayResetOnVisibility = getOption("autoplayResetOnVisibility");
      if (bpChanged) {
        disable = getOption("disable");
        fixedWidth = getOption("fixedWidth");
        speed = getOption("speed");
        autoHeight = getOption("autoHeight");
        controlsText = getOption("controlsText");
        autoplayText = getOption("autoplayText");
        autoplayTimeout = getOption("autoplayTimeout");
        if (!CSSMQ) {
          edgePadding = getOption("edgePadding");
          gutter = getOption("gutter");
        }
      }
      resetVariblesWhenDisable(disable);
      viewport = getViewportWidth();
      if ((!horizontal || autoWidth) && !disable) {
        setSlidePositions();
        if (!horizontal) {
          updateContentWrapperHeight();
          needContainerTransform = true;
        }
      }
      if (fixedWidth || autoWidth) {
        rightBoundary = getRightBoundary();
        indexMax = getIndexMax();
      }
      if (bpChanged || fixedWidth) {
        items = getOption("items");
        slideBy = getOption("slideBy");
        itemsChanged = items !== itemsTem;
        if (itemsChanged) {
          if (!fixedWidth && !autoWidth) {
            indexMax = getIndexMax();
          }
          updateIndex();
        }
      }
      if (bpChanged) {
        if (disable !== disableTem) {
          if (disable) {
            disableSlider();
          } else {
            enableSlider();
          }
        }
      }
      if (freezable && (bpChanged || fixedWidth || autoWidth)) {
        freeze = getFreeze();
        if (freeze !== freezeTem) {
          if (freeze) {
            doContainerTransform(getContainerTransformValue(getStartIndex(0)));
            freezeSlider();
          } else {
            unfreezeSlider();
            needContainerTransform = true;
          }
        }
      }
      resetVariblesWhenDisable(disable || freeze);
      if (!autoplay) {
        autoplayHoverPause = autoplayResetOnVisibility = false;
      }
      if (arrowKeys !== arrowKeysTem) {
        arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent);
      }
      if (controls !== controlsTem) {
        if (controls) {
          if (controlsContainer) {
            showElement(controlsContainer);
          } else {
            if (prevButton) {
              showElement(prevButton);
            }
            if (nextButton) {
              showElement(nextButton);
            }
          }
        } else {
          if (controlsContainer) {
            hideElement(controlsContainer);
          } else {
            if (prevButton) {
              hideElement(prevButton);
            }
            if (nextButton) {
              hideElement(nextButton);
            }
          }
        }
      }
      if (nav !== navTem) {
        if (nav) {
          showElement(navContainer);
          updateNavVisibility();
        } else {
          hideElement(navContainer);
        }
      }
      if (touch !== touchTem) {
        touch ? addEvents(container, touchEvents, options.preventScrollOnTouch) : removeEvents(container, touchEvents);
      }
      if (mouseDrag !== mouseDragTem) {
        mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents);
      }
      if (autoplay !== autoplayTem) {
        if (autoplay) {
          if (autoplayButton) {
            showElement(autoplayButton);
          }
          if (!animating && !autoplayUserPaused) {
            startAutoplay();
          }
        } else {
          if (autoplayButton) {
            hideElement(autoplayButton);
          }
          if (animating) {
            stopAutoplay();
          }
        }
      }
      if (autoplayHoverPause !== autoplayHoverPauseTem) {
        autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents);
      }
      if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
        autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent);
      }
      if (bpChanged) {
        if (fixedWidth !== fixedWidthTem || center !== centerTem) {
          needContainerTransform = true;
        }
        if (autoHeight !== autoHeightTem) {
          if (!autoHeight) {
            innerWrapper.style.height = "";
          }
        }
        if (controls && controlsText !== controlsTextTem) {
          prevButton.innerHTML = controlsText[0];
          nextButton.innerHTML = controlsText[1];
        }
        if (autoplayButton && autoplayText !== autoplayTextTem) {
          var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
          if (html.substring(len) === autoplayTextTem[i]) {
            autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
          }
        }
      } else {
        if (center && (fixedWidth || autoWidth)) {
          needContainerTransform = true;
        }
      }
      if (itemsChanged || fixedWidth && !autoWidth) {
        pages = getPages();
        updateNavVisibility();
      }
      indChanged = index !== indexTem;
      if (indChanged) {
        events.emit("indexChanged", info());
        needContainerTransform = true;
      } else if (itemsChanged) {
        if (!indChanged) {
          additionalUpdates();
        }
      } else if (fixedWidth || autoWidth) {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
      }
      if (itemsChanged && !carousel) {
        updateGallerySlidePositions();
      }
      if (!disable && !freeze) {
        if (bpChanged && !CSSMQ) {
          if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
          }
          if (horizontal) {
            if (carousel) {
              container.style.width = getContainerWidth(fixedWidth, gutter, items);
            }
            var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
            removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
            addCSSRule(sheet, "#" + slideId + " > .tns-item", str, getCssRulesLength(sheet));
          }
        }
        if (autoHeight) {
          doAutoHeight();
        }
        if (needContainerTransform) {
          doContainerTransformSilent();
          indexCached = index;
        }
      }
      if (bpChanged) {
        events.emit("newBreakpointEnd", info(e));
      }
    }
    function getFreeze() {
      if (!fixedWidth && !autoWidth) {
        var a = center ? items - (items - 1) / 2 : items;
        return slideCount <= a;
      }
      var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
      if (center) {
        vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
      }
      return width <= vp;
    }
    function setBreakpointZone() {
      breakpointZone = 0;
      for (var bp in responsive) {
        bp = parseInt(bp);
        if (windowWidth >= bp) {
          breakpointZone = bp;
        }
      }
    }
    var updateIndex = function() {
      return loop ? carousel ? function() {
        var leftEdge = indexMin, rightEdge = indexMax;
        leftEdge += slideBy;
        rightEdge -= slideBy;
        if (edgePadding) {
          leftEdge += 1;
          rightEdge -= 1;
        } else if (fixedWidth) {
          if ((viewport + gutter) % (fixedWidth + gutter)) {
            rightEdge -= 1;
          }
        }
        if (cloneCount) {
          if (index > rightEdge) {
            index -= slideCount;
          } else if (index < leftEdge) {
            index += slideCount;
          }
        }
      } : function() {
        if (index > indexMax) {
          while (index >= indexMin + slideCount) {
            index -= slideCount;
          }
        } else if (index < indexMin) {
          while (index <= indexMax - slideCount) {
            index += slideCount;
          }
        }
      } : function() {
        index = Math.max(indexMin, Math.min(indexMax, index));
      };
    }();
    function disableUI() {
      if (!autoplay && autoplayButton) {
        hideElement(autoplayButton);
      }
      if (!nav && navContainer) {
        hideElement(navContainer);
      }
      if (!controls) {
        if (controlsContainer) {
          hideElement(controlsContainer);
        } else {
          if (prevButton) {
            hideElement(prevButton);
          }
          if (nextButton) {
            hideElement(nextButton);
          }
        }
      }
    }
    function enableUI() {
      if (autoplay && autoplayButton) {
        showElement(autoplayButton);
      }
      if (nav && navContainer) {
        showElement(navContainer);
      }
      if (controls) {
        if (controlsContainer) {
          showElement(controlsContainer);
        } else {
          if (prevButton) {
            showElement(prevButton);
          }
          if (nextButton) {
            showElement(nextButton);
          }
        }
      }
    }
    function freezeSlider() {
      if (frozen) {
        return;
      }
      if (edgePadding) {
        innerWrapper.style.margin = "0px";
      }
      if (cloneCount) {
        var str = "tns-transparent";
        for (var i = cloneCount; i--; ) {
          if (carousel) {
            addClass(slideItems[i], str);
          }
          addClass(slideItems[slideCountNew - i - 1], str);
        }
      }
      disableUI();
      frozen = true;
    }
    function unfreezeSlider() {
      if (!frozen) {
        return;
      }
      if (edgePadding && CSSMQ) {
        innerWrapper.style.margin = "";
      }
      if (cloneCount) {
        var str = "tns-transparent";
        for (var i = cloneCount; i--; ) {
          if (carousel) {
            removeClass(slideItems[i], str);
          }
          removeClass(slideItems[slideCountNew - i - 1], str);
        }
      }
      enableUI();
      frozen = false;
    }
    function disableSlider() {
      if (disabled) {
        return;
      }
      sheet.disabled = true;
      container.className = container.className.replace(newContainerClasses.substring(1), "");
      removeAttrs(container, ["style"]);
      if (loop) {
        for (var j = cloneCount; j--; ) {
          if (carousel) {
            hideElement(slideItems[j]);
          }
          hideElement(slideItems[slideCountNew - j - 1]);
        }
      }
      if (!horizontal || !carousel) {
        removeAttrs(innerWrapper, ["style"]);
      }
      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i];
          removeAttrs(item, ["style"]);
          removeClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      }
      disableUI();
      disabled = true;
    }
    function enableSlider() {
      if (!disabled) {
        return;
      }
      sheet.disabled = false;
      container.className += newContainerClasses;
      doContainerTransformSilent();
      if (loop) {
        for (var j = cloneCount; j--; ) {
          if (carousel) {
            showElement(slideItems[j]);
          }
          showElement(slideItems[slideCountNew - j - 1]);
        }
      }
      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
          item.style.left = (i - index) * 100 / items + "%";
          addClass(item, classN);
        }
      }
      enableUI();
      disabled = false;
    }
    function updateLiveRegion() {
      var str = getLiveRegionStr();
      if (liveregionCurrent.innerHTML !== str) {
        liveregionCurrent.innerHTML = str;
      }
    }
    function getLiveRegionStr() {
      var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
      return start === end ? start + "" : start + " to " + end;
    }
    function getVisibleSlideRange(val2) {
      if (val2 == null) {
        val2 = getContainerTransformValue();
      }
      var start = index, end, rangestart, rangeend;
      if (center || edgePadding) {
        if (autoWidth || fixedWidth) {
          rangestart = -(parseFloat(val2) + edgePadding);
          rangeend = rangestart + viewport + edgePadding * 2;
        }
      } else {
        if (autoWidth) {
          rangestart = slidePositions[index];
          rangeend = rangestart + viewport;
        }
      }
      if (autoWidth) {
        slidePositions.forEach(function(point, i) {
          if (i < slideCountNew) {
            if ((center || edgePadding) && point <= rangestart + 0.5) {
              start = i;
            }
            if (rangeend - point >= 0.5) {
              end = i;
            }
          }
        });
      } else {
        if (fixedWidth) {
          var cell = fixedWidth + gutter;
          if (center || edgePadding) {
            start = Math.floor(rangestart / cell);
            end = Math.ceil(rangeend / cell - 1);
          } else {
            end = start + Math.ceil(viewport / cell) - 1;
          }
        } else {
          if (center || edgePadding) {
            var a = items - 1;
            if (center) {
              start -= a / 2;
              end = index + a / 2;
            } else {
              end = index + a;
            }
            if (edgePadding) {
              var b = edgePadding * items / viewport;
              start -= b;
              end += b;
            }
            start = Math.floor(start);
            end = Math.ceil(end);
          } else {
            end = start + items - 1;
          }
        }
        start = Math.max(start, 0);
        end = Math.min(end, slideCountNew - 1);
      }
      return [start, end];
    }
    function doLazyLoad() {
      if (lazyload && !disable) {
        var arg = getVisibleSlideRange();
        arg.push(lazyloadSelector);
        getImageArray.apply(null, arg).forEach(function(img) {
          if (!hasClass(img, imgCompleteClass)) {
            var eve = {};
            eve[TRANSITIONEND] = function(e) {
              e.stopPropagation();
            };
            addEvents(img, eve);
            addEvents(img, imgEvents);
            img.src = getAttr(img, "data-src");
            var srcset = getAttr(img, "data-srcset");
            if (srcset) {
              img.srcset = srcset;
            }
            addClass(img, "loading");
          }
        });
      }
    }
    function onImgLoaded(e) {
      imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
      imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
      addClass(img, "loaded");
      imgCompleted(img);
    }
    function imgFailed(img) {
      addClass(img, "failed");
      imgCompleted(img);
    }
    function imgCompleted(img) {
      addClass(img, imgCompleteClass);
      removeClass(img, "loading");
      removeEvents(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
      var imgs = [];
      if (!imgSelector) {
        imgSelector = "img";
      }
      while (start <= end) {
        forEach(slideItems[start].querySelectorAll(imgSelector), function(img) {
          imgs.push(img);
        });
        start++;
      }
      return imgs;
    }
    function doAutoHeight() {
      var imgs = getImageArray.apply(null, getVisibleSlideRange());
      raf(function() {
        imgsLoadedCheck(imgs, updateInnerWrapperHeight);
      });
    }
    function imgsLoadedCheck(imgs, cb) {
      if (imgsComplete) {
        return cb();
      }
      imgs.forEach(function(img, index2) {
        if (!lazyload && img.complete) {
          imgCompleted(img);
        }
        if (hasClass(img, imgCompleteClass)) {
          imgs.splice(index2, 1);
        }
      });
      if (!imgs.length) {
        return cb();
      }
      raf(function() {
        imgsLoadedCheck(imgs, cb);
      });
    }
    function additionalUpdates() {
      doLazyLoad();
      updateSlideStatus();
      updateLiveRegion();
      updateControlsStatus();
      updateNavStatus();
    }
    function update_carousel_transition_duration() {
      if (carousel && autoHeight) {
        middleWrapper.style[TRANSITIONDURATION] = speed / 1e3 + "s";
      }
    }
    function getMaxSlideHeight(slideStart, slideRange) {
      var heights = [];
      for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
        heights.push(slideItems[i].offsetHeight);
      }
      return Math.max.apply(null, heights);
    }
    function updateInnerWrapperHeight() {
      var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
      if (wp.style.height !== maxHeight) {
        wp.style.height = maxHeight + "px";
      }
    }
    function setSlidePositions() {
      slidePositions = [0];
      var attr = horizontal ? "left" : "top", attr2 = horizontal ? "right" : "bottom", base = slideItems[0].getBoundingClientRect()[attr];
      forEach(slideItems, function(item, i) {
        if (i) {
          slidePositions.push(item.getBoundingClientRect()[attr] - base);
        }
        if (i === slideCountNew - 1) {
          slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        }
      });
    }
    function updateSlideStatus() {
      var range = getVisibleSlideRange(), start = range[0], end = range[1];
      forEach(slideItems, function(item, i) {
        if (i >= start && i <= end) {
          if (hasAttr(item, "aria-hidden")) {
            removeAttrs(item, ["aria-hidden", "tabindex"]);
            addClass(item, slideActiveClass);
          }
        } else {
          if (!hasAttr(item, "aria-hidden")) {
            setAttrs(item, {
              "aria-hidden": "true",
              "tabindex": "-1"
            });
            removeClass(item, slideActiveClass);
          }
        }
      });
    }
    function updateGallerySlidePositions() {
      var l = index + Math.min(slideCount, items);
      for (var i = slideCountNew; i--; ) {
        var item = slideItems[i];
        if (i >= index && i < l) {
          addClass(item, "tns-moving");
          item.style.left = (i - index) * 100 / items + "%";
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        } else if (item.style.left) {
          item.style.left = "";
          addClass(item, animateNormal);
          removeClass(item, animateIn);
        }
        removeClass(item, animateOut);
      }
      setTimeout(function() {
        forEach(slideItems, function(el) {
          removeClass(el, "tns-moving");
        });
      }, 300);
    }
    function updateNavStatus() {
      if (nav) {
        navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
        navClicked = -1;
        if (navCurrentIndex !== navCurrentIndexCached) {
          var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
          setAttrs(navPrev, {
            "tabindex": "-1",
            "aria-label": navStr + (navCurrentIndexCached + 1)
          });
          removeClass(navPrev, navActiveClass);
          setAttrs(navCurrent, { "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent });
          removeAttrs(navCurrent, "tabindex");
          addClass(navCurrent, navActiveClass);
          navCurrentIndexCached = navCurrentIndex;
        }
      }
    }
    function getLowerCaseNodeName(el) {
      return el.nodeName.toLowerCase();
    }
    function isButton(el) {
      return getLowerCaseNodeName(el) === "button";
    }
    function isAriaDisabled(el) {
      return el.getAttribute("aria-disabled") === "true";
    }
    function disEnableElement(isButton2, el, val2) {
      if (isButton2) {
        el.disabled = val2;
      } else {
        el.setAttribute("aria-disabled", val2.toString());
      }
    }
    function updateControlsStatus() {
      if (!controls || rewind || loop) {
        return;
      }
      var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
      if (disablePrev && !prevDisabled) {
        disEnableElement(prevIsButton, prevButton, true);
      }
      if (!disablePrev && prevDisabled) {
        disEnableElement(prevIsButton, prevButton, false);
      }
      if (disableNext && !nextDisabled) {
        disEnableElement(nextIsButton, nextButton, true);
      }
      if (!disableNext && nextDisabled) {
        disEnableElement(nextIsButton, nextButton, false);
      }
    }
    function resetDuration(el, str) {
      if (TRANSITIONDURATION) {
        el.style[TRANSITIONDURATION] = str;
      }
    }
    function getSliderWidth() {
      return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
      if (num == null) {
        num = index;
      }
      var gap = edgePadding ? gutter : 0;
      return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
      var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
      if (center && !loop) {
        result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
      }
      if (result > 0) {
        result = 0;
      }
      return result;
    }
    function getContainerTransformValue(num) {
      if (num == null) {
        num = index;
      }
      var val2;
      if (horizontal && !autoWidth) {
        if (fixedWidth) {
          val2 = -(fixedWidth + gutter) * num;
          if (center) {
            val2 += getCenterGap();
          }
        } else {
          var denominator = TRANSFORM ? slideCountNew : items;
          if (center) {
            num -= getCenterGap();
          }
          val2 = -num * 100 / denominator;
        }
      } else {
        val2 = -slidePositions[num];
        if (center && autoWidth) {
          val2 += getCenterGap();
        }
      }
      if (hasRightDeadZone) {
        val2 = Math.max(val2, rightBoundary);
      }
      val2 += horizontal && !autoWidth && !fixedWidth ? "%" : "px";
      return val2;
    }
    function doContainerTransformSilent(val2) {
      resetDuration(container, "0s");
      doContainerTransform(val2);
    }
    function doContainerTransform(val2) {
      if (val2 == null) {
        val2 = getContainerTransformValue();
      }
      container.style[transformAttr] = transformPrefix + val2 + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
      var l = number + items;
      if (!loop) {
        l = Math.min(l, slideCountNew);
      }
      for (var i = number; i < l; i++) {
        var item = slideItems[i];
        if (!isOut) {
          item.style.left = (i - index) * 100 / items + "%";
        }
        if (animateDelay && TRANSITIONDELAY) {
          item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1e3 + "s";
        }
        removeClass(item, classOut);
        addClass(item, classIn);
        if (isOut) {
          slideItemsOut.push(item);
        }
      }
    }
    var transformCore = function() {
      return carousel ? function() {
        resetDuration(container, "");
        if (TRANSITIONDURATION || !speed) {
          doContainerTransform();
          if (!speed || !isVisible(container)) {
            onTransitionEnd();
          }
        } else {
          jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
        }
        if (!horizontal) {
          updateContentWrapperHeight();
        }
      } : function() {
        slideItemsOut = [];
        var eve = {};
        eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
        removeEvents(slideItems[indexCached], eve);
        addEvents(slideItems[index], eve);
        animateSlide(indexCached, animateIn, animateOut, true);
        animateSlide(index, animateNormal, animateIn);
        if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) {
          onTransitionEnd();
        }
      };
    }();
    function render(e, sliderMoved) {
      if (updateIndexBeforeTransform) {
        updateIndex();
      }
      if (index !== indexCached || sliderMoved) {
        events.emit("indexChanged", info());
        events.emit("transitionStart", info());
        if (autoHeight) {
          doAutoHeight();
        }
        if (animating && e && ["click", "keydown"].indexOf(e.type) >= 0) {
          stopAutoplay();
        }
        running = true;
        transformCore();
      }
    }
    function strTrans(str) {
      return str.toLowerCase().replace(/-/g, "");
    }
    function onTransitionEnd(event) {
      if (carousel || running) {
        events.emit("transitionEnd", info(event));
        if (!carousel && slideItemsOut.length > 0) {
          for (var i = 0; i < slideItemsOut.length; i++) {
            var item = slideItemsOut[i];
            item.style.left = "";
            if (ANIMATIONDELAY && TRANSITIONDELAY) {
              item.style[ANIMATIONDELAY] = "";
              item.style[TRANSITIONDELAY] = "";
            }
            removeClass(item, animateOut);
            addClass(item, animateNormal);
          }
        }
        if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
          if (!updateIndexBeforeTransform) {
            var indexTem = index;
            updateIndex();
            if (index !== indexTem) {
              events.emit("indexChanged", info());
              doContainerTransformSilent();
            }
          }
          if (nested === "inner") {
            events.emit("innerLoaded", info());
          }
          running = false;
          indexCached = index;
        }
      }
    }
    function goTo(targetIndex, e) {
      if (freeze) {
        return;
      }
      if (targetIndex === "prev") {
        onControlsClick(e, -1);
      } else if (targetIndex === "next") {
        onControlsClick(e, 1);
      } else {
        if (running) {
          if (preventActionWhenRunning) {
            return;
          } else {
            onTransitionEnd();
          }
        }
        var absIndex = getAbsIndex(), indexGap = 0;
        if (targetIndex === "first") {
          indexGap = -absIndex;
        } else if (targetIndex === "last") {
          indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
        } else {
          if (typeof targetIndex !== "number") {
            targetIndex = parseInt(targetIndex);
          }
          if (!isNaN(targetIndex)) {
            if (!e) {
              targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
            }
            indexGap = targetIndex - absIndex;
          }
        }
        if (!carousel && indexGap && Math.abs(indexGap) < items) {
          var factor = indexGap > 0 ? 1 : -1;
          indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
        }
        index += indexGap;
        if (carousel && loop) {
          if (index < indexMin) {
            index += slideCount;
          }
          if (index > indexMax) {
            index -= slideCount;
          }
        }
        if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
          render(e);
        }
      }
    }
    function onControlsClick(e, dir) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }
      var passEventObject;
      if (!dir) {
        e = getEvent(e);
        var target = getTarget(e);
        while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) {
          target = target.parentNode;
        }
        var targetIn = [prevButton, nextButton].indexOf(target);
        if (targetIn >= 0) {
          passEventObject = true;
          dir = targetIn === 0 ? -1 : 1;
        }
      }
      if (rewind) {
        if (index === indexMin && dir === -1) {
          goTo("last", e);
          return;
        } else if (index === indexMax && dir === 1) {
          goTo("first", e);
          return;
        }
      }
      if (dir) {
        index += slideBy * dir;
        if (autoWidth) {
          index = Math.floor(index);
        }
        render(passEventObject || e && e.type === "keydown" ? e : null);
      }
    }
    function onNavClick(e) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }
      e = getEvent(e);
      var target = getTarget(e), navIndex;
      while (target !== navContainer && !hasAttr(target, "data-nav")) {
        target = target.parentNode;
      }
      if (hasAttr(target, "data-nav")) {
        var navIndex = navClicked = Number(getAttr(target, "data-nav")), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
        goTo(targetIndex, e);
        if (navCurrentIndex === navIndex) {
          if (animating) {
            stopAutoplay();
          }
          navClicked = -1;
        }
      }
    }
    function setAutoplayTimer() {
      autoplayTimer = setInterval(function() {
        onControlsClick(null, autoplayDirection);
      }, autoplayTimeout);
      animating = true;
    }
    function stopAutoplayTimer() {
      clearInterval(autoplayTimer);
      animating = false;
    }
    function updateAutoplayButton(action, txt) {
      setAttrs(autoplayButton, { "data-action": action });
      autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
      setAutoplayTimer();
      if (autoplayButton) {
        updateAutoplayButton("stop", autoplayText[1]);
      }
    }
    function stopAutoplay() {
      stopAutoplayTimer();
      if (autoplayButton) {
        updateAutoplayButton("start", autoplayText[0]);
      }
    }
    function play() {
      if (autoplay && !animating) {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }
    function pause() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      }
    }
    function toggleAutoplay() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      } else {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }
    function onVisibilityChange() {
      if (doc.hidden) {
        if (animating) {
          stopAutoplayTimer();
          autoplayVisibilityPaused = true;
        }
      } else if (autoplayVisibilityPaused) {
        setAutoplayTimer();
        autoplayVisibilityPaused = false;
      }
    }
    function mouseoverPause() {
      if (animating) {
        stopAutoplayTimer();
        autoplayHoverPaused = true;
      }
    }
    function mouseoutRestart() {
      if (autoplayHoverPaused) {
        setAutoplayTimer();
        autoplayHoverPaused = false;
      }
    }
    function onDocumentKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);
      if (keyIndex >= 0) {
        onControlsClick(e, keyIndex === 0 ? -1 : 1);
      }
    }
    function onControlsKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);
      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (!prevButton.disabled) {
            onControlsClick(e, -1);
          }
        } else if (!nextButton.disabled) {
          onControlsClick(e, 1);
        }
      }
    }
    function setFocus(el) {
      el.focus();
    }
    function onNavKeydown(e) {
      e = getEvent(e);
      var curElement = doc.activeElement;
      if (!hasAttr(curElement, "data-nav")) {
        return;
      }
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode), navIndex = Number(getAttr(curElement, "data-nav"));
      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (navIndex > 0) {
            setFocus(navItems[navIndex - 1]);
          }
        } else if (keyIndex === 1) {
          if (navIndex < pages - 1) {
            setFocus(navItems[navIndex + 1]);
          }
        } else {
          navClicked = navIndex;
          goTo(navIndex, e);
        }
      }
    }
    function getEvent(e) {
      e = e || win3.event;
      return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
      return e.target || win3.event.srcElement;
    }
    function isTouchEvent(e) {
      return e.type.indexOf("touch") >= 0;
    }
    function preventDefaultBehavior(e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
      return getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }
      if (autoplay && animating) {
        stopAutoplayTimer();
      }
      panStart = true;
      if (rafIndex) {
        caf(rafIndex);
        rafIndex = null;
      }
      var $ = getEvent(e);
      events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e));
      if (!isTouchEvent(e) && ["img", "a"].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
        preventDefaultBehavior(e);
      }
      lastPosition.x = initPosition.x = $.clientX;
      lastPosition.y = initPosition.y = $.clientY;
      if (carousel) {
        translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ""));
        resetDuration(container, "0s");
      }
    }
    function onPanMove(e) {
      if (panStart) {
        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;
        if (carousel) {
          if (!rafIndex) {
            rafIndex = raf(function() {
              panUpdate(e);
            });
          }
        } else {
          if (moveDirectionExpected === "?") {
            moveDirectionExpected = getMoveDirectionExpected();
          }
          if (moveDirectionExpected) {
            preventScroll = true;
          }
        }
        if ((typeof e.cancelable !== "boolean" || e.cancelable) && preventScroll) {
          e.preventDefault();
        }
      }
    }
    function panUpdate(e) {
      if (!moveDirectionExpected) {
        panStart = false;
        return;
      }
      caf(rafIndex);
      if (panStart) {
        rafIndex = raf(function() {
          panUpdate(e);
        });
      }
      if (moveDirectionExpected === "?") {
        moveDirectionExpected = getMoveDirectionExpected();
      }
      if (moveDirectionExpected) {
        if (!preventScroll && isTouchEvent(e)) {
          preventScroll = true;
        }
        try {
          if (e.type) {
            events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
          }
        } catch (err) {
        }
        var x = translateInit, dist = getDist(lastPosition, initPosition);
        if (!horizontal || fixedWidth || autoWidth) {
          x += dist;
          x += "px";
        } else {
          var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
          x += percentageX;
          x += "%";
        }
        container.style[transformAttr] = transformPrefix + x + transformPostfix;
      }
    }
    function onPanEnd(e) {
      if (panStart) {
        if (rafIndex) {
          caf(rafIndex);
          rafIndex = null;
        }
        if (carousel) {
          resetDuration(container, "");
        }
        panStart = false;
        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;
        var dist = getDist(lastPosition, initPosition);
        if (Math.abs(dist)) {
          if (!isTouchEvent(e)) {
            var target = getTarget(e);
            addEvents(target, { "click": function preventClick(e2) {
              preventDefaultBehavior(e2);
              removeEvents(target, { "click": preventClick });
            } });
          }
          if (carousel) {
            rafIndex = raf(function() {
              if (horizontal && !autoWidth) {
                var indexMoved = -dist * items / (viewport + gutter);
                indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                index += indexMoved;
              } else {
                var moved = -(translateInit + dist);
                if (moved <= 0) {
                  index = indexMin;
                } else if (moved >= slidePositions[slideCountNew - 1]) {
                  index = indexMax;
                } else {
                  var i = 0;
                  while (i < slideCountNew && moved >= slidePositions[i]) {
                    index = i;
                    if (moved > slidePositions[i] && dist < 0) {
                      index += 1;
                    }
                    i++;
                  }
                }
              }
              render(e, dist);
              events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
            });
          } else {
            if (moveDirectionExpected) {
              onControlsClick(e, dist > 0 ? -1 : 1);
            }
          }
        }
      }
      if (options.preventScrollOnTouch === "auto") {
        preventScroll = false;
      }
      if (swipeAngle) {
        moveDirectionExpected = "?";
      }
      if (autoplay && !animating) {
        setAutoplayTimer();
      }
    }
    function updateContentWrapperHeight() {
      var wp = middleWrapper ? middleWrapper : innerWrapper;
      wp.style.height = slidePositions[index + items] - slidePositions[index] + "px";
    }
    function getPages() {
      var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
      return Math.min(Math.ceil(rough), slideCount);
    }
    function updateNavVisibility() {
      if (!nav || navAsThumbnails) {
        return;
      }
      if (pages !== pagesCached) {
        var min = pagesCached, max = pages, fn = showElement;
        if (pagesCached > pages) {
          min = pages;
          max = pagesCached;
          fn = hideElement;
        }
        while (min < max) {
          fn(navItems[min]);
          min++;
        }
        pagesCached = pages;
      }
    }
    function info(e) {
      return {
        container,
        slideItems,
        navContainer,
        navItems,
        controlsContainer,
        hasControls,
        prevButton,
        nextButton,
        items,
        slideBy,
        cloneCount,
        slideCount,
        slideCountNew,
        index,
        indexCached,
        displayIndex: getCurrentSlide(),
        navCurrentIndex,
        navCurrentIndexCached,
        pages,
        pagesCached,
        sheet,
        isOn,
        event: e || {}
      };
    }
    return {
      version: "2.9.4",
      getInfo: info,
      events,
      goTo,
      play,
      pause,
      isOn,
      updateSliderHeight: updateInnerWrapperHeight,
      refresh: initSliderTransform,
      destroy,
      rebuild: function() {
        return tns(extend(options, optionsElements));
      }
    };
  };

  // assets/js/src/slider/slider.js
  var Slider = class {
    constructor() {
    }
    static setup() {
      const sliders_full = store_default.theContainer.getElementsByClassName("js-slider-full");
      if (sliders_full.length > 0) {
        for (let i = sliders_full.length - 1; i >= 0; i--) {
          const element = sliders_full[i];
          const parent = element.parentElement;
          const controls = parent.getElementsByClassName("js-controls")[0];
          const navigation = parent.getElementsByClassName("js-nav")[0];
          const slider = tns({
            container: element,
            items: 1,
            slideBy: "page",
            autoplay: false,
            mouseDrag: true,
            autoplayButtonOutput: false,
            controlsContainer: controls,
            navContainer: navigation,
            mode: "gallery"
          });
        }
      }
      const sliders_plan = store_default.theContainer.getElementsByClassName("js-slider-map");
      if (sliders_plan.length > 0) {
        for (let i = sliders_plan.length - 1; i >= 0; i--) {
          const element = sliders_plan[i];
          const parent = element.parentElement;
          const controls = parent.getElementsByClassName("js-controls")[0];
          const navigation = parent.getElementsByClassName("js-nav")[0];
          const slider = tns({
            container: element,
            items: 1,
            slideBy: "page",
            autoplay: false,
            mouseDrag: true,
            autoplayButtonOutput: false,
            controlsContainer: controls,
            nav: false,
            gutter: 10,
            responsive: {
              700: {
                items: 2
              },
              991: {
                items: 3,
                gutter: 30
              },
              1199: {
                items: 4
              },
              1450: {
                items: 5
              }
            }
          });
        }
      }
      const sliders_subNav = store_default.theContainer.getElementsByClassName("js-slider-subNav");
      if (sliders_subNav.length > 0) {
        for (let i = sliders_subNav.length - 1; i >= 0; i--) {
          const element = sliders_subNav[i];
          const parent = element.parentElement;
          const controls = parent.getElementsByClassName("js-controls")[0];
          const slider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: false,
            mouseDrag: true,
            autoplayButtonOutput: false,
            controlsContainer: controls,
            nav: false,
            loop: false,
            responsive: {
              520: {
                items: 2
              },
              700: {
                items: 3
              },
              991: {
                items: 4
              },
              1199: {
                items: 5
              }
            }
          });
        }
      }
      const sliders_career = store_default.theContainer.getElementsByClassName("js-slider-career");
      if (sliders_career.length > 0) {
        let initSlideCounter = function(childrenCount) {
          counter.innerHTML = `<strong>1</strong> / ${childrenCount}`;
        };
        const counter = store_default.theContainer.querySelector(".js-counter");
        const custom_event = function(info, indexChanged) {
          const data = info;
          const current_slide = info.displayIndex;
          const total_slide = info.slideCount;
          counter.innerHTML = `<strong>${current_slide}</strong> / ${total_slide}`;
        };
        for (let i = sliders_career.length - 1; i >= 0; i--) {
          const element = sliders_career[i];
          const childrenCount = element.getElementsByTagName("li") ? element.getElementsByTagName("li").length : 0;
          const parent = element.parentElement;
          const controls = parent.getElementsByClassName("js-controls")[0];
          const navigation = parent.getElementsByClassName("js-nav")[0];
          const slider = tns({
            container: element,
            items: 1,
            slideBy: "page",
            autoplay: true,
            mouseDrag: true,
            autoplayButtonOutput: false,
            controlsContainer: controls,
            nav: false,
            autoHeight: true,
            onInit: initSlideCounter(childrenCount)
          });
          slider.events.on("indexChanged", custom_event);
        }
      }
    }
  };

  // assets/js/src/sticky/sticky.js
  var import_sticky_js = __toModule(require_sticky_js());

  // assets/js/src/filters/filters.js
  var import_barba3 = __toModule(require_barba());
  var Filters = class {
    constructor(params) {
      this.form = params.form;
      this.fields = null;
    }
    static setup() {
      const forms = store_default.theContainer.getElementsByClassName("js-filters");
      if (forms.length > 0) {
        for (let i = forms.length - 1; i >= 0; i--) {
          const form = forms[i];
          const params = {
            form
          };
          const obj = new Filters(params);
          form.addEventListener("submit", obj.validateForm);
          obj.selectEventListener();
        }
      }
    }
    selectEventListener() {
      const hasSelect = this.form.querySelector("select");
      if (hasSelect) {
        hasSelect.addEventListener("change", (event) => {
          const defaultValue = hasSelect.querySelector("option").value;
          const currentValue = hasSelect.value;
          if (defaultValue != currentValue) {
            const button = this.form.querySelector("button");
            button.click();
          }
        });
      }
    }
    validateForm(e) {
      e.preventDefault();
      const fields = this.elements;
      const wrappers = this.getElementsByClassName("m-Filters__item");
      for (let i = 0; i < wrappers.length; i++) {
        const wrap = wrappers[i];
        wrap.classList.remove("has-error");
      }
      const type = fields["type"];
      const typeDefault = type ? this.dataset.selectName : null;
      const typeValue = type && typeDefault ? fields["type"].value : null;
      const typeRequired = type ? type.required : false;
      const checkbox = fields[this.dataset.checkboxName];
      const checkboxName = checkbox ? checkbox.name : null;
      const checkboxState = checkboxName ? fields[this.dataset.checkboxName].checked : null;
      const search = fields[this.dataset.searchName];
      let searchValue = null;
      let searchAction = null;
      if (search) {
        searchValue = search.value;
        searchAction = this.dataset.searchAction;
      }
      let searchParams = "?";
      if (searchValue != "" && searchValue != null) {
        searchParams = `${searchAction}${searchValue}`;
      }
      const action = this.action;
      if (type && typeValue === typeDefault && typeRequired) {
        type.parentElement.parentElement.classList.add("has-error");
        return;
      }
      if (checkbox && checkboxState && (type && typeValue !== typeDefault)) {
        if (searchParams != "?")
          searchParams += "&";
        import_barba3.default.Pjax.goTo(`${searchParams}type=${typeValue}&${checkboxName}=${checkboxState ? "1" : "0"}#results`);
        return;
      }
      if (checkbox && checkboxState) {
        if (searchParams != "?")
          searchParams += "&";
        import_barba3.default.Pjax.goTo(`${searchParams}${checkboxName}=${checkboxState ? "1" : "0"}#results`);
        return;
      }
      if (type && typeValue !== typeDefault) {
        if (searchParams != "?")
          searchParams += "&";
        import_barba3.default.Pjax.goTo(`${searchParams}type=${typeValue}#results`);
        return;
      }
      import_barba3.default.Pjax.goTo(`${searchParams}#results`);
      return;
    }
  };

  // assets/js/src/helpers/helpers.js
  var import_object_fit_images = __toModule(require_ofi_common_js());

  // assets/js/src/watchscroll/watchscroll.js
  var WatchScroll = class {
    constructor(params) {
      this.camera = params.camera;
      this.scene = params.scene;
      this.scrollValues = params.scrollValues;
      this.source = params.source;
      this.elements = params.elements;
      this.settings = params.settings;
    }
    static createWorld(_settings) {
      const settings = __spreadValues({
        selectClass: "js-watch-scroll-item",
        visibleClass: "is-visible"
      }, _settings);
      const camera = WatchScroll.createCamera();
      const scene = WatchScroll.createScene();
      const scrollValues = WatchScroll.createScrollValues();
      const selectClass = settings.selectClass;
      const source = WatchScroll.getSource(selectClass);
      const elements = WatchScroll.createElements(source);
      const params = {
        camera,
        scene,
        scrollValues,
        source,
        elements,
        settings
      };
      return new WatchScroll(params);
    }
    static createCamera() {
      const camera_view = {
        x: 0,
        y: 0,
        w: window.innerWidth,
        h: window.innerHeight
      };
      const params = __spreadValues({}, camera_view);
      return params;
    }
    updateCameraPosition() {
      const camera_view = {
        x: window.pageXOffset,
        y: window.pageYOffset,
        w: window.innerWidth,
        h: window.innerHeight
      };
      this.camera = __spreadValues({}, camera_view);
    }
    getCameraCoordinates() {
      const x0 = this.camera.x - this.scrollValues.x;
      const y0 = this.camera.y - this.scrollValues.y;
      const x1 = x0 + this.camera.w;
      const y1 = y0 + this.camera.h;
      return { x0, y0, x1, y1 };
    }
    static createScene() {
      const scene_shape = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      const params = __spreadValues({}, scene_shape);
      return params;
    }
    static createScrollValues() {
      const scroll_values = {
        x: window.pageXOffset,
        y: window.pageYOffset
      };
      const params = __spreadValues({}, scroll_values);
      return params;
    }
    updateScrollValues() {
      const scroll_values = {
        x: window.pageXOffset,
        y: window.pageYOffset
      };
      this.scrollValues = __spreadValues({}, scroll_values);
    }
    static getSource(cssClass) {
      return document.getElementsByClassName(cssClass);
    }
    static createElements(_source) {
      const elements = _source;
      let out = [];
      for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        const bounding = element.getBoundingClientRect();
        const settings = WatchScroll.createElementSettings(element);
        const params = {
          element,
          x: bounding.x,
          y: bounding.y,
          w: bounding.width,
          h: bounding.height,
          state: {
            visible: false
          },
          settings: __spreadValues({}, settings)
        };
        out.push(params);
      }
      return out;
    }
    static createElementSettings(_element) {
      const element = _element;
      const attrs = element.dataset;
      const animation_mode = attrs.animationMode ? attrs.animationMode : "once";
      const show_top = attrs.showTop ? parseInt(attrs.showTop) : 0;
      const show_bottom = attrs.showBottom ? parseInt(attrs.showBottom) : 0;
      const show_left = attrs.showLeft ? parseInt(attrs.showTop) : 0;
      const show_right = attrs.showRight ? parseInt(attrs.showRight) : 0;
      return {
        animation_mode,
        show_top,
        show_bottom,
        show_left,
        show_right
      };
    }
    updateElementsPosition() {
      const elements = this.elements;
      for (let i = elements.length - 1; i >= 0; i--) {
        const element = this.elements[i];
        const bounding = element.element.getBoundingClientRect();
        const x = bounding.x;
        const y = bounding.y;
        const w = bounding.width;
        const h = bounding.height;
        this.elements[i].x = x;
        this.elements[i].y = y;
        this.elements[i].w = w;
        this.elements[i].h = h;
      }
    }
    updateElementsVisibility() {
      const elements = this.elements;
      const visibleClass = this.settings.visibleClass;
      for (let i = elements.length - 1; i >= 0; i--) {
        const camera_coords = __spreadValues({}, this.getCameraCoordinates());
        const element = elements[i];
        const isInView = this.getElementVisibility(element, camera_coords);
        if (isInView) {
          element.element.classList.add(visibleClass);
          element.state.visible = true;
        } else {
          element.element.classList.remove(visibleClass);
          element.state.visible = false;
        }
        if (isInView) {
          const mode = element.settings.animation_mode;
          if (mode === "once" || mode === "one" || mode === "1" || mode === 1) {
            this.elements.splice(i, 1);
          }
        }
      }
    }
    getElementCoordinates(_element) {
      const element = _element;
      const x0 = element.x;
      const y0 = element.y;
      const x1 = x0 + element.w;
      const y1 = y0 + element.h;
      return { x0, y0, x1, y1 };
    }
    getElementVisibility(_element, _camera_coords) {
      const element = _element;
      const element_coords = this.getElementCoordinates(element);
      const camera_coords = _camera_coords;
      const x = this.getElementVisibilityX(element, element_coords, camera_coords);
      const y = this.getElementVisibilityY(element, element_coords, camera_coords);
      return x && y;
    }
    getElementVisibilityX(_element, _element_coords, _camera_coords) {
      const element = _element;
      const element_coords = _element_coords;
      const camera_coords = _camera_coords;
      const x_top = element.settings.show_top;
      const x_bottom = element.settings.show_bottom;
      if (x_top === 0) {
        return camera_coords.x0 < element_coords.x1 && camera_coords.x1 > element_coords.x0;
      }
      return camera_coords.x0 < element_coords.x1 && camera_coords.x1 > element_coords.x0;
    }
    getElementVisibilityY(_element, _element_coords, _camera_coords) {
      const element = _element;
      const element_coords = _element_coords;
      const camera_coords = _camera_coords;
      const y_top = element.settings.show_top;
      const y_bottom = element.settings.show_bottom;
      if (y_top === 0 && y_bottom === 0) {
        return camera_coords.y0 < element_coords.y1 && camera_coords.y1 > element_coords.y0;
      }
      const view_top = this.getElementVisibilityY_top_bottom(element, element_coords, camera_coords, y_top);
      return view_top && camera_coords.y1 > element_coords.y0;
    }
    getElementVisibilityY_top_bottom(_element, _element_coords, _camera_coords, _y_top) {
      const element = _element;
      const element_coords = _element_coords;
      const camera_coords = _camera_coords;
      const ey0 = element_coords.y0;
      const ey1 = element_coords.y1;
      const eh = element_coords.y1 - element_coords.y0;
      const cy0 = _camera_coords.y0;
      const cy1 = _camera_coords.y1;
      const ch = _camera_coords.y1 + _camera_coords.y0;
      let pixel_visible_from_top = -1 * (ey1 - cy1 - eh);
      if (pixel_visible_from_top >= eh)
        pixel_visible_from_top = true;
      let pixel_visible_from_bottom = -1 * (cy1 - ey0 - ch - eh);
      if (pixel_visible_from_bottom >= eh)
        pixel_visible_from_bottom = true;
      let total_pixel_visible = 0;
      const top_type = typeof pixel_visible_from_top;
      const bottom_type = typeof pixel_visible_from_bottom;
      if (top_type === "boolean" && bottom_type === "boolean" && pixel_visible_from_top === true && pixel_visible_from_bottom === true) {
        total_pixel_visible = eh;
      }
      if (pixel_visible_from_top > 0 && (bottom_type === "boolean" && pixel_visible_from_bottom === true)) {
        total_pixel_visible = pixel_visible_from_top;
      }
      if (pixel_visible_from_bottom > 0 && (top_type === "boolean" && pixel_visible_from_top === true)) {
        total_pixel_visible = pixel_visible_from_bottom;
      }
      if (total_pixel_visible === true) {
        return true;
      }
      const ratio = _y_top;
      return total_pixel_visible * 100 / ch > ratio;
    }
    static watch(_obj) {
      if (_obj) {
        const obj = _obj;
        const elements = obj.elements;
        obj.updateScrollValues();
        obj.updateCameraPosition();
        if (elements.length > 0) {
          obj.updateElementsPosition();
          obj.updateElementsVisibility();
        }
      }
    }
  };

  // assets/js/src/scrollbar/scrollbar.js
  var ScrollbarHelper = class {
    static getCurrentScrollTop() {
      return store_default.scrolled_y;
    }
    static scrollToTop() {
      window.scrollTo(0, 0);
    }
    static currentlyVisible(el) {
      var bounding = el.getBoundingClientRect();
      return bounding.top >= 0 && bounding.top < store_default.screenHeight / 4 * 3;
    }
    static updateScrollDirection() {
      const d = store_default.ScrollDirection;
      const y = store_default.scrolled_y;
      const p = store_default.prev_scrolled_y;
      if (y > p) {
        store_default.ScrollDirection = 1;
        store_default.theBody.classList.add("is-scrolling-down");
        store_default.theBody.classList.remove("is-scrolling-up");
      } else {
        store_default.ScrollDirection = 0;
        store_default.theBody.classList.remove("is-scrolling-down");
        store_default.theBody.classList.add("is-scrolling-up");
      }
    }
  };

  // assets/js/src/inputs/inputs.js
  function initInputs() {
    var inputs = store_default.theContainer.querySelectorAll(".js-label input, .js-label textarea");
    inputs.forEach((input) => {
      input.addEventListener("focusin", function(event) {
        event.target.parentElement.classList.add("is-up");
      });
      input.addEventListener("focusout", function(event) {
        checkInput(event.target);
      });
      checkInput(input);
    });
    addGlobalEventListener();
  }
  function checkInput(input) {
    if (input) {
      if (input.tagName.toLowerCase() == "input" || input.tagName.toLowerCase() == "textarea") {
        if (input.value.length == 0) {
          input.parentElement.classList.remove("is-up");
        } else {
          input.parentElement.classList.add("is-up");
        }
      }
    }
  }
  function getCheckboxesValue() {
    const checkBoxes = store_default.theContainer.querySelectorAll(".js-checkBox");
    checkBoxes.forEach((checkBox) => {
      checkBox.addEventListener("change", () => {
        buildInputs();
      });
    });
  }
  function buildInputs() {
    const checkBoxes = store_default.theContainer.querySelectorAll(".js-checkBox:checked");
    const inputHidden = store_default.theContainer.querySelector(".js-inputHidden");
    let values = [];
    checkBoxes.forEach((checkBox) => {
      values.push(checkBox.value);
    });
    inputHidden.value = values.join(", ");
  }
  function initCheckAutofill() {
    addGlobalEventListener("blur", function(target) {
      window.setTimeout(function() {
        checkInput(target);
      }, 20);
    });
  }
  function addGlobalEventListener(eventName, listener) {
    if (!document.body.addEventListener) {
      document.body.attachEvent(eventName, onEvent);
    } else {
      document.body.addEventListener(eventName, onEvent, true);
    }
    function onEvent(event) {
      var target = event.target;
      listener(target);
    }
  }

  // assets/js/src/scripts/scripts.js
  var Scripts = class {
    static joss(message) {
      console.log(message);
    }
    static reenableButtons($form) {
      $form = $form || document;
      var $buttons = $form.querySelectorAll("input[type=submit], button[type=submit]");
      $buttons.forEach(function($button) {
        $button.classList.remove("disabled");
        $button.disabled = false;
        var text = "";
        if ($button.getAttribute("data-msg_loading")) {
          text = $button.textContent;
          $button.textContent = $button.getAttribute("data-msg_loading");
          $button.setAttribute("data-msg_loading", text);
        } else if ($button.getAttribute("data-msg_default")) {
          text = $button.innerHTML;
          $button.innerHTML = $button.getAttribute("data-msg_default");
          $button.setAttribute("data-msg_default", text);
        }
      });
    }
    static resetFormErrors($form) {
      var elements = false;
      elements = $form.querySelectorAll(".Alert.has-error");
      if (elements) {
        elements.forEach(function($ele) {
          $ele.innerHTML = "";
        });
      }
      elements = $form.querySelectorAll(".Alert");
      if (elements) {
        elements.forEach(function($ele) {
          $ele.style.display = "none";
        });
      }
      elements = $form.querySelectorAll(".js-error");
      if (elements) {
        elements.forEach(function($ele) {
          $ele.parentNode.removeChild($ele);
        });
      }
      elements = $form.querySelectorAll(".FormElement.has-error");
      if (elements) {
        elements.forEach(function($ele) {
          $ele.classList.remove("has-error");
        });
      }
    }
    static displaySuccess($form) {
      var _a;
      if (typeof $form == "string") {
        $form = document.querySelector($form);
      }
      Scripts.resetFormErrors($form);
      var $alert = $form.nextSibling;
      if (!$alert || !$alert.classList || !$alert.classList.contains("Alert") || !$alert.classList.contains("has-success")) {
        $alert = $form.parentNode.querySelector(".Alert.has-success");
      }
      if ($alert) {
        $form.style.display = "none";
        $alert.style.display = "block";
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "event": (_a = $form.dataset.formtype) != null ? _a : ""
      });
      var target = $alert.getBoundingClientRect().top;
      if (store_default.scrollbar) {
        store_default.scrollbar.getScrollElement().scrollBy({
          top: target,
          left: 0,
          behavior: "smooth"
        });
      } else {
        window.scrollBy({
          top: target,
          left: 0,
          behavior: "smooth"
        });
      }
    }
    static displayErrors($form, messages, skipReset) {
      if (typeof $form == "string") {
        $form = document.querySelector($form);
      }
      $form = $form || document;
      skipReset = skipReset || false;
      if (!skipReset) {
        Scripts.resetFormErrors($form);
      }
      var focusIt = true;
      for (var name in messages) {
        if (name == "global") {
          var $alert = $form.querySelector(".Alert.has-error");
          if ($alert) {
            $alert.style.display = "block";
            $alert.innerHTML += messages[name];
          }
          var target = $alert.getBoundingClientRect().top;
          if (store_default.scrollbar) {
            store_default.scrollbar.getScrollElement().scrollBy({
              top: target,
              left: 0,
              behavior: "smooth"
            });
          } else {
            window.scrollBy({
              top: target,
              left: 0,
              behavior: "smooth"
            });
          }
        } else {
          var $ele = $form.querySelector("*[name=" + name + "]");
          if ($ele) {
            if (focusIt && $ele.offsetParent !== null) {
              $ele.focus();
              focusIt = false;
            }
            var $formElement = $ele.closest(".FormElement");
            if ($formElement) {
              $formElement.classList.add("has-error");
              var $errorMessage = document.createElement("div");
              $errorMessage.innerHTML = '<label for="' + $ele.getAttribute("id") + '" class="js-error">' + messages[name] + "</label>";
              $formElement.parentNode.insertBefore($errorMessage.firstChild, $formElement.nextSibling);
            }
          }
        }
      }
    }
    static sendFormAjax($form, callback, callbackArgs) {
      var data = new FormData($form);
      var req = new XMLHttpRequest();
      var action = $form.getAttribute("action");
      if (action.indexOf("?") < 0) {
        action += "?";
      }
      action += "&ajax";
      req.open("POST", action, true);
      req.responseType = "json";
      req.onreadystatechange = function() {
        var response = req.response;
        if (response && typeof response == "string") {
          try {
            response = JSON.parse(response);
          } catch (e) {
          }
        }
        if (req.readyState == 4 && req.status == 200) {
          if (callback) {
            if (window[callback]) {
              callback = window[callback];
            }
            var args = [response];
            args = args.concat(callbackArgs);
            callback.apply(null, args);
          } else {
            if (response.result) {
              if (response.replaceHtml) {
                $form.innerHTML = response.replaceHtml;
              }
            }
          }
        }
      };
      req.send(data);
    }
    static initFormButtons() {
      var $forms = document.querySelectorAll("form");
      $forms.forEach(function($form) {
        $form.addEventListener("submit", function(e) {
          var $buttons = this.querySelectorAll("input[type=submit], button[type=submit]");
          $buttons.forEach(function($button) {
            if (!$button.classList.contains("js-no-disabled")) {
              $button.classList.add("disabled");
              $button.disabled = true;
              var text = "";
              if ($button.getAttribute("data-msg_loading")) {
                text = $button.textContent;
                $button.textContent = $button.getAttribute("data-msg_loading");
                $button.setAttribute("data-msg_loading", text);
              } else if ($button.getAttribute("data-msg_default")) {
                text = $button.innerHTML;
                $button.innerHTML = $button.getAttribute("data-msg_default");
                $button.setAttribute("data-msg_default", text);
              }
            }
          });
        });
      });
    }
    static initJsValidate() {
      var $forms = document.querySelectorAll("form.js-validate");
      $forms.forEach(function($form) {
        $form.addEventListener("submit", function(e) {
          var errors = {};
          this.querySelectorAll("input, select, textarea").forEach(function($ele) {
            if ($ele.required && !$ele.value) {
              errors[$ele.name] = $ele.getAttribute("data-required-text");
            }
          });
          this.querySelectorAll(".must-check-one").forEach(function($ele) {
            var checked = false;
            $ele.querySelectorAll("input[type=checkbox], input[type=radio]").forEach(function($chk) {
              if ($chk.checked) {
                checked = true;
              }
            });
            if (!checked) {
              if ("global" in errors) {
                errors["global"] += "<br/>" + $ele.getAttribute("data-required-text");
              } else {
                errors["global"] = $ele.getAttribute("data-required-text");
              }
            }
          });
          if (Object.keys(errors).length) {
            Scripts.displayErrors(this, errors);
            Scripts.reenableButtons(this);
            e.stopPropagation();
            e.preventDefault();
            return false;
          }
        });
      });
    }
    static initJsForms() {
      var $forms = document.querySelectorAll("form.js-form");
      var DEBUG_FORM = false;
      if (DEBUG_FORM) {
        Scripts.joss("---------------------");
        Scripts.joss("initiating js forms");
        Scripts.joss("---------------------");
      }
      var i = 1;
      $forms.forEach(function($form) {
        $form.addEventListener("submit", function(e) {
          Scripts.joss("---------------------");
          Scripts.joss("submitting js forms");
          Scripts.joss("---------------------");
          e.preventDefault();
          Scripts.sendFormAjax(this, function(response) {
            Scripts.joss("---------------------");
            Scripts.joss("js forms response came back");
            Scripts.joss("---------------------");
            if (response) {
              if (!response.error) {
                if (response.url) {
                  location.href = response.url;
                } else if (response.message == "reload") {
                  location.href = location.href;
                } else {
                  Scripts.displaySuccess($form);
                }
              } else {
                Scripts.reenableButtons($form);
                Scripts.resetFormErrors($form);
                if (response.message) {
                  Scripts.displayErrors($form, { "global": response.message }, true);
                }
                if (response.messages) {
                  Scripts.displayErrors($form, response.messages, true);
                }
              }
            }
          });
        });
      });
    }
    static initFileInputs() {
      var fileInputs = document.querySelectorAll('input[type="file"]');
      if (fileInputs.length) {
        fileInputs.forEach(function(fileInput) {
          fileInput.addEventListener("change", function(e) {
            var filenames = [];
            var target = e.target;
            for (var i = 0; i < target.files.length; i++)
              filenames.push(target.files[i].name);
            var parent = target.parentNode;
            var label = parent.querySelector("label");
            label.innerText = filenames.join(",");
          });
        });
      }
    }
    static initEverything() {
      initPartial();
    }
    static initPartial() {
      Scripts.initFormButtons();
      Scripts.initFileInputs();
      Scripts.initJsValidate();
      Scripts.initJsForms();
    }
  };

  // assets/js/src/accordions/accordions.js
  var Accordion = class {
    constructor(_accordion, _children, _collapsible) {
      this.accordion = _accordion;
      this.children = _children;
      this.collapsible = _collapsible;
    }
    static init() {
      store_default.Accordions = [];
      const accordions = document.getElementsByClassName("js-accordions");
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const accordionID = urlParams.get("accordions");
      for (let i = 0; i < accordions.length; i++) {
        let a = accordions[i];
        let children = [];
        a.dataset.parent = i;
        let collapsible = false;
        if (a.classList.contains("is-collapsible"))
          collapsible = true;
        let block = a.getElementsByClassName("js-accordionsRow");
        for (let j = 0; j < block.length; j++) {
          children[j] = [];
          let c = children[j];
          let b = block[j];
          b.dataset.parent = i;
          b.dataset.child = j;
          let content = b.getElementsByClassName("js-accordionsContent")[0];
          let contentHeight = content.firstElementChild.scrollHeight;
          b.getElementsByClassName("js-accordionsContent")[0].style.height = 0;
          c["block"] = b;
          c["active"] = false;
          c["contentHeight"] = contentHeight;
          c["slug"] = null;
          if (b.dataset.slug)
            c["slug"] = b.dataset.slug;
          let target = b.getElementsByClassName("js-accordionsTrigger")[0];
          target.addEventListener("click", Accordion.clicked.bind(b));
          if (c["block"].dataset.id === accordionID) {
            setTimeout(() => {
              this.toggle(i, j);
            }, 1);
          }
        }
        let obj = new Accordion(a, children, collapsible);
        store_default.Accordions.push(obj);
      }
    }
    static update() {
      const accordions = store_default.Accordions;
      for (let i = 0; i < accordions.length; i++) {
        let children = accordions[i].children;
        for (let j = 0; j < children.length; j++) {
          let el = children[j].block;
          let content = el.getElementsByClassName("js-accordionsContent")[0];
          let contentHeight = content.firstElementChild.scrollHeight;
          children[j]["contentHeight"] = contentHeight;
          if (children[j].active == true) {
            content.style.height = contentHeight + "px";
          }
        }
      }
    }
    static toggle(p, c) {
      let p_index = p;
      let c_index = c;
      let a = store_default.Accordions[p_index];
      let child = a.children[c_index];
      let collapsible = a.collapsible;
      let active = child.active;
      Accordion.collapsible(p_index);
      if (active) {
        Accordion.hide(p, c);
      } else {
        Accordion.show(p, c);
      }
      Accordion.focus(p_index);
    }
    static show(p, c) {
      let p_index = p;
      let c_index = c;
      let a = store_default.Accordions[p_index];
      let child = a.children[c_index];
      let block = child.block;
      let content = block.getElementsByClassName("js-accordionsContent")[0];
      let content_h = child.contentHeight;
      content.style.height = content_h + "px";
      block.classList.add("is-active");
      child.active = true;
    }
    static hide(p, c) {
      let p_index = p;
      let c_index = c;
      let a = store_default.Accordions[p_index];
      let child = a.children[c_index];
      let block = child.block;
      let content = block.getElementsByClassName("js-accordionsContent")[0];
      content.style.height = 0;
      block.classList.remove("is-active");
      child.active = false;
    }
    static clicked() {
      let p = this.dataset.parent;
      let c = this.dataset.child;
      Accordion.toggle(p, c);
    }
    static collapsible(p_index) {
      const accordions = store_default.Accordions;
      const current_accordion = accordions[p_index];
      const current_accordion_children = current_accordion.children;
      for (var i = current_accordion_children.length - 1; i >= 0; i--) {
        Accordion.hide(p_index, i);
      }
    }
    static focus(p_index) {
      const accordions = store_default.Accordions;
      const current_accordion = accordions[p_index];
      const current_accordion_children = current_accordion.children;
      let active_accordion_block = null;
      loop:
        for (let i = 0; i < current_accordion_children.length; i++) {
          let child = current_accordion_children[i];
          let isActive = child.active;
          if (isActive) {
            active_accordion_block = child.block;
            break loop;
          }
        }
      if (active_accordion_block) {
        setTimeout(function() {
          active_accordion_block.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 450);
      }
    }
  };

  // assets/js/src/recaptcha/recaptcha.js
  var Recaptcha = class {
    static init() {
      store_default.Recaptcha.elements = [];
      store_default.Recaptcha.elements = store_default.theBody.querySelectorAll(".g-recaptcha");
      const elements = store_default.Recaptcha.elements;
      if (elements.length > 0) {
        const key = elements[0].dataset.sitekey;
        store_default.Recaptcha.key = key;
        elements.forEach((element) => {
          element.innerHTML = "";
        });
        if (store_default.RecaptchaIsLoaded == false) {
          Recaptcha.load().then((value) => {
            store_default.RecaptchaIsLoaded = true;
            elements.forEach((element) => {
              setTimeout(function() {
                Recaptcha.render(element, key);
              }, 2500);
            });
          });
        } else {
          elements.forEach((element) => {
            setTimeout(function() {
              Recaptcha.render(element, key);
            }, 2500);
          });
        }
      }
    }
    static load() {
      return __async(this, null, function* () {
        let cs = document.createElement("script");
        store_default.Recaptcha.RecaptchaAPI = new Promise((resolve, reject) => {
          store_default.theBody.appendChild(cs);
          cs.onload = resolve;
          cs.onerror = reject;
          cs.async = true;
          cs.defer = true;
          cs.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
        });
        store_default.Recaptcha.RecaptchaAPI.then((resolve) => {
          window.onloadCallback = function(resolve2) {
            Recaptcha.render();
          };
        });
      });
    }
    static render(element, key) {
      if (element) {
        const isActive = element.dataset.active;
        if (!isActive) {
          window.grecaptcha.render(element, {
            "sitekey": key
          });
          element.dataset.active = true;
        }
        store_default.RecaptchaIsRendered = true;
      }
    }
  };

  // assets/js/src/helpers/helpers.js
  var StoreUpdate = function() {
    store_default.theBody = document.getElementsByTagName("body")[0];
    store_default.theContainer = null;
    store_default.theContainer = document.getElementsByClassName("barba-container")[0];
    store_default.screenWidth = window.innerWidth;
    store_default.screenHeight = window.innerHeight;
  };
  var getCurrentLang = function() {
    const element = store_default.theContainer;
    if (element != null) {
      const lang = element.dataset.lang;
      return lang;
    }
    return false;
  };
  var updateIframeRatio = function() {
    const EditableContents = store_default.theContainer.querySelectorAll(".Editable");
    const maxWidth = 1208;
    EditableContents.forEach((content) => {
      const iframes = content.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        const width = iframe.scrollWidth;
        if (width >= maxWidth) {
          const finalHeight = maxWidth * 9 / 16;
          iframe.style.height = `${finalHeight}px`;
        }
        if (width < maxWidth) {
          const finalHeight = width * 9 / 16;
          iframe.style.height = `${finalHeight}px`;
        }
      });
    });
  };
  var ajaxInitPartial = function() {
    initCheckAutofill();
    Navigation.checkRedirect();
    Navigation.init();
    Slider.setup();
    Select.setup();
    Lightbox.setup();
    Recaptcha.init();
    Filters.setup();
    initInputs();
    getCheckboxesValue();
    store_default.Timeline = WatchScroll.createWorld();
    Accordion.init();
    Scripts.initPartial();
    updateIframeRatio();
    const hash = window.location.hash.replace("#", "");
    const hashTarget = store_default.theContainer.getElementsByClassName(hash);
    if (hashTarget.length > 0) {
      hashTarget[0].scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  window.addEventListener("scroll", function(e) {
    store_default.prev_scrolled_y = store_default.scrolled_y;
    store_default.scrolled_y = window.pageYOffset;
    ScrollbarHelper.updateScrollDirection();
    if (!store_default.ticking) {
      window.requestAnimationFrame(() => {
        const y = store_default.scrolled_y;
        store_default.Navigation.watch(y);
        WatchScroll.watch(store_default.Timeline);
        (0, import_object_fit_images.default)(".js-object-fit");
        store_default.ticking = false;
      });
      store_default.ticking = true;
    }
  });
  window.addEventListener("resize", function() {
    store_default.screenWidth = window.innerWidth;
    store_default.screenHeight = window.innerHeight;
    updateIframeRatio();
  }, true);

  // assets/js/src/ajax/ajax.js
  var AjaxTransition = class {
    static getTransition() {
      import_barba4.default.Pjax.getTransition = function() {
        if (!store_default.theBody.classList.contains("ajax-transition-begin")) {
          store_default.theBody.classList.add("ajax-transition-begin");
        }
        if (TSmilieu.valid()) {
          return TSmilieu;
        }
        if (TSpagedefault.valid()) {
          return TSpagedefault;
        }
        return TSpagedefault;
      };
    }
    static linkClicked() {
      import_barba4.default.Dispatcher.on("linkClicked", function() {
        console.log("%c---------------------", "color: #D84C4C;");
        console.log("%cCLICKED", "color: #D84C4C;");
        store_default.Navigation.navigationToggle("close");
      });
    }
    static newPageReady() {
      import_barba4.default.Dispatcher.on("newPageReady", function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
        console.log("%c---------------------", "color: #D84C4C;");
        console.log("%cREADY", "color: #D84C4C;");
        window.scrollTo(0, 0);
      });
    }
    static transitionCompleted() {
      import_barba4.default.Dispatcher.on("transitionCompleted", function() {
        console.log("%c---------------------", "color: #D84C4C;");
        console.log("%cCOMPLETED", "color: #D84C4C;");
        StoreUpdate();
        ajaxInitPartial();
        store_default.Navigation.setActiveLink();
        if (store_default.theBody.classList.contains("ajax-transition-begin")) {
          store_default.theBody.classList.add("ajax-transition-done");
          store_default.theBody.classList.remove("ajax-transition-begin");
        }
      });
    }
  };

  // assets/js/src/ajax/namespace.js
  var import_barba5 = __toModule(require_barba());
  var NSpagedefault = import_barba5.default.BaseView.extend({
    namespace: "pagedefault",
    onEnter: function() {
    },
    onEnterCompleted: function() {
      setTimeout(function() {
        store_default.theBody.classList.remove("page-transition");
        store_default.theBody.classList.add("page-show");
      }, 350);
    },
    onLeave: function() {
      setTimeout(function() {
        store_default.theBody.classList.remove("page-show");
        store_default.theBody.classList.add("page-transition");
      }, 150);
    },
    onLeaveCompleted: function() {
    }
  });
  var NSmilieu = import_barba5.default.BaseView.extend({
    namespace: "milieu",
    onEnter: function() {
      console.log("onEnter");
      Navigation.checkRedirect();
    },
    onEnterCompleted: function() {
      console.log("onEnterCompleted");
      setTimeout(function() {
        store_default.theBody.classList.remove("page-transition");
        store_default.theBody.classList.add("page-show");
      }, 350 * 4);
    },
    onLeave: function() {
      console.log("onLeave");
      setTimeout(function() {
        store_default.theBody.classList.remove("page-show");
        store_default.theBody.classList.add("page-transition");
      }, 150);
    },
    onLeaveCompleted: function() {
      console.log("onLeaveCompleted");
    }
  });

  // assets/js/src/acolyte.js
  function initFirstPageLoad() {
    loadFonts();
    if (store_default.theBody.classList.contains("js-firstLoad")) {
      setTimeout(function() {
        store_default.theBody.classList.remove("js-firstLoad");
        doneFirstPageAnimation();
      }, store_default.firstLoadDelay);
    }
  }
  function doneFirstPageAnimation() {
    BarbaInitAll();
    setTimeout(function() {
      store_default.theBody.classList.add("js-doneFirstLoad");
    }, store_default.firstLoadDelay * 2);
  }
  function loadFonts() {
    let wf = document.createElement("script");
    let GoogleFontsAPI = new Promise((resolve, reject) => {
      store_default.theBody.appendChild(wf);
      wf.onload = resolve;
      wf.onerror = reject;
      wf.async = true;
      wf.src = "https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js";
      wf.id = "googlefont";
    });
    GoogleFontsAPI.then(() => {
      WebFont.load({
        google: {
          families: [
            "Barlow:300,400,600,700",
            "Lora:400,500,700",
            "Material+Icons"
          ]
        }
      });
    });
  }
  function BarbaInitAll() {
    import_barba6.default.Pjax.start();
    NSpagedefault.init();
    NSmilieu.init();
    AjaxTransition.getTransition();
    AjaxTransition.linkClicked();
    AjaxTransition.newPageReady();
    AjaxTransition.transitionCompleted();
  }
  setTimeout(function() {
    StoreUpdate();
    getCurrentLang();
    initFirstPageLoad();
    ajaxInitPartial();
  }, 500);
})();
/*! npm.im/object-fit-images 3.2.4 */
/**
 * Sticky.js
 * Library for sticky elements written in vanilla javascript. With this library you can easily set sticky elements on your website. It's also responsive.
 *
 * @version 1.3.0
 * @author Rafal Galus <biuro@rafalgalus.pl>
 * @website https://rgalus.github.io/sticky-js/
 * @repo https://github.com/rgalus/sticky-js
 * @license https://github.com/rgalus/sticky-js/blob/master/LICENSE
 */
